/*! jQuery Migrate v1.4.1 | (c) jQuery Foundation and other contributors | jquery.org/license */
function PointerEventsPolyfill(t) {
    if (this.options = {
        selector: "*",
        mouseEvents: ["click", "dblclick", "mousedown", "mouseup"],
        usePolyfillIf: function() {
            var t;
            var e;
            if ("Microsoft Internet Explorer" == navigator.appName && (null != navigator.userAgent.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/) && 11 > parseFloat(RegExp.$1)))
                return !0;
            return !1
        }
    },
    t) {
        var e = this;
        $.each(t, (function(t, i) {
            e.options[t] = i
        }
        ))
    }
    this.options.usePolyfillIf() && this.register_mouse_events()
}
"undefined" == typeof jQuery.migrateMute && (jQuery.migrateMute = !0),
function(t, e, i) {
    function n(i) {
        var n = e.console;
        a[i] || (a[i] = !0,
        t.migrateWarnings.push(i),
        n && n.warn && !t.migrateMute && (n.warn("JQMIGRATE: " + i),
        t.migrateTrace && n.trace && n.trace()))
    }
    function o(e, i, o, a) {
        if (Object.defineProperty)
            try {
                return void Object.defineProperty(e, i, {
                    configurable: !0,
                    enumerable: !0,
                    get: function() {
                        return n(a),
                        o
                    },
                    set: function(t) {
                        n(a),
                        o = t
                    }
                })
            } catch (t) {}
        t._definePropertyBroken = !0,
        e[i] = o
    }
    t.migrateVersion = "1.4.1";
    var a = {};
    t.migrateWarnings = [],
    e.console && e.console.log && e.console.log("JQMIGRATE: Migrate is installed" + (t.migrateMute ? "" : " with logging active") + ", version " + t.migrateVersion),
    t.migrateTrace === i && (t.migrateTrace = !0),
    t.migrateReset = function() {
        a = {},
        t.migrateWarnings.length = 0
    }
    ,
    "BackCompat" === document.compatMode && n("jQuery is not compatible with Quirks Mode");
    var s = t("<input/>", {
        size: 1
    }).attr("size") && t.attrFn
      , r = t.attr
      , l = t.attrHooks.value && t.attrHooks.value.get || function() {
        return null
    }
      , c = t.attrHooks.value && t.attrHooks.value.set || function() {
        return i
    }
      , d = /^(?:input|button)$/i
      , u = /^[238]$/
      , p = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i
      , h = /^(?:checked|selected)$/i;
    o(t, "attrFn", s || {}, "jQuery.attrFn is deprecated"),
    t.attr = function(e, o, a, l) {
        var c = o.toLowerCase()
          , f = e && e.nodeType;
        return l && (r.length < 4 && n("jQuery.fn.attr( props, pass ) is deprecated"),
        e && !u.test(f) && (s ? o in s : t.isFunction(t.fn[o]))) ? t(e)[o](a) : ("type" === o && a !== i && d.test(e.nodeName) && e.parentNode && n("Can't change the 'type' of an input or button in IE 6/7/8"),
        !t.attrHooks[c] && p.test(c) && (t.attrHooks[c] = {
            get: function(e, n) {
                var o, a = t.prop(e, n);
                return !0 === a || "boolean" != typeof a && (o = e.getAttributeNode(n)) && !1 !== o.nodeValue ? n.toLowerCase() : i
            },
            set: function(e, i, n) {
                var o;
                return !1 === i ? t.removeAttr(e, n) : ((o = t.propFix[n] || n)in e && (e[o] = !0),
                e.setAttribute(n, n.toLowerCase())),
                n
            }
        },
        h.test(c) && n("jQuery.fn.attr('" + c + "') might use property instead of attribute")),
        r.call(t, e, o, a))
    }
    ,
    t.attrHooks.value = {
        get: function(t, e) {
            var i = (t.nodeName || "").toLowerCase();
            return "button" === i ? l.apply(this, arguments) : ("input" !== i && "option" !== i && n("jQuery.fn.attr('value') no longer gets properties"),
            e in t ? t.value : null)
        },
        set: function(t, e) {
            var i = (t.nodeName || "").toLowerCase();
            return "button" === i ? c.apply(this, arguments) : ("input" !== i && "option" !== i && n("jQuery.fn.attr('value', val) no longer sets properties"),
            void (t.value = e))
        }
    };
    var f, m, g = t.fn.init, y = t.find, v = t.parseJSON, b = /^\s*</, w = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/, $ = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g, _ = /^([^<]*)(<[\w\W]+>)([^>]*)$/;
    var x;
    for (x in t.fn.init = function(e, o, a) {
        var s, r;
        return e && "string" == typeof e && !t.isPlainObject(o) && (s = _.exec(t.trim(e))) && s[0] && (b.test(e) || n("$(html) HTML strings must start with '<' character"),
        s[3] && n("$(html) HTML text after last tag is ignored"),
        "#" === s[0].charAt(0) && (n("HTML string cannot start with a '#' character"),
        t.error("JQMIGRATE: Invalid selector string (XSS)")),
        o && o.context && o.context.nodeType && (o = o.context),
        t.parseHTML) ? g.call(this, t.parseHTML(s[2], o && o.ownerDocument || o || document, !0), o, a) : (r = g.apply(this, arguments),
        e && e.selector !== i ? (r.selector = e.selector,
        r.context = e.context) : (r.selector = "string" == typeof e ? e : "",
        e && (r.context = e.nodeType ? e : o || document)),
        r)
    }
    ,
    t.fn.init.prototype = t.fn,
    t.find = function(t) {
        var e = Array.prototype.slice.call(arguments);
        if ("string" == typeof t && w.test(t))
            try {
                document.querySelector(t)
            } catch (i) {
                t = t.replace($, (function(t, e, i, n) {
                    return "[" + e + i + '"' + n + '"]'
                }
                ));
                try {
                    document.querySelector(t),
                    n("Attribute selector with '#' must be quoted: " + e[0]),
                    e[0] = t
                } catch (t) {
                    n("Attribute selector with '#' was not fixed: " + e[0])
                }
            }
        return y.apply(this, e)
    }
    ,
    y)
        Object.prototype.hasOwnProperty.call(y, x) && (t.find[x] = y[x]);
    t.parseJSON = function(t) {
        return t ? v.apply(this, arguments) : (n("jQuery.parseJSON requires a valid JSON string"),
        null)
    }
    ,
    t.uaMatch = function(t) {
        t = t.toLowerCase();
        var e = /(chrome)[ \/]([\w.]+)/.exec(t) || /(webkit)[ \/]([\w.]+)/.exec(t) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(t) || /(msie) ([\w.]+)/.exec(t) || t.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(t) || [];
        return {
            browser: e[1] || "",
            version: e[2] || "0"
        }
    }
    ,
    t.browser || (m = {},
    (f = t.uaMatch(navigator.userAgent)).browser && (m[f.browser] = !0,
    m.version = f.version),
    m.chrome ? m.webkit = !0 : m.webkit && (m.safari = !0),
    t.browser = m),
    o(t, "browser", t.browser, "jQuery.browser is deprecated"),
    t.boxModel = t.support.boxModel = "CSS1Compat" === document.compatMode,
    o(t, "boxModel", t.boxModel, "jQuery.boxModel is deprecated"),
    o(t.support, "boxModel", t.support.boxModel, "jQuery.support.boxModel is deprecated"),
    t.sub = function() {
        function e(t, i) {
            return new e.fn.init(t,i)
        }
        t.extend(!0, e, this),
        e.superclass = this,
        e.fn = e.prototype = this(),
        e.fn.constructor = e,
        e.sub = this.sub,
        e.fn.init = function(n, o) {
            var a = t.fn.init.call(this, n, o, i);
            return a instanceof e ? a : e(a)
        }
        ,
        e.fn.init.prototype = e.fn;
        var i = e(document);
        return n("jQuery.sub() is deprecated"),
        e
    }
    ,
    t.fn.size = function() {
        return n("jQuery.fn.size() is deprecated; use the .length property"),
        this.length
    }
    ;
    var S = !1;
    t.swap && t.each(["height", "width", "reliableMarginRight"], (function(e, i) {
        var n = t.cssHooks[i] && t.cssHooks[i].get;
        n && (t.cssHooks[i].get = function() {
            var t;
            return S = !0,
            t = n.apply(this, arguments),
            S = !1,
            t
        }
        )
    }
    )),
    t.swap = function(t, e, i, o) {
        var a, s, r = {};
        for (s in S || n("jQuery.swap() is undocumented and deprecated"),
        e)
            r[s] = t.style[s],
            t.style[s] = e[s];
        for (s in a = i.apply(t, o || []),
        e)
            t.style[s] = r[s];
        return a
    }
    ,
    t.ajaxSetup({
        converters: {
            "text json": t.parseJSON
        }
    });
    var C = t.fn.data;
    t.fn.data = function(e) {
        var o, a, s = this[0];
        return !s || "events" !== e || 1 !== arguments.length || (o = t.data(s, e),
        a = t._data(s, e),
        o !== i && o !== a || a === i) ? C.apply(this, arguments) : (n("Use of jQuery.fn.data('events') is deprecated"),
        a)
    }
    ;
    var k = /\/(java|ecma)script/i;
    t.clean || (t.clean = function(e, i, o, a) {
        i = (i = !(i = i || document).nodeType && i[0] || i).ownerDocument || i,
        n("jQuery.clean() is deprecated");
        var s, r, l, c, d = [];
        if (t.merge(d, t.buildFragment(e, i).childNodes),
        o)
            for (l = function(t) {
                return !t.type || k.test(t.type) ? a ? a.push(t.parentNode ? t.parentNode.removeChild(t) : t) : o.appendChild(t) : void 0
            }
            ,
            s = 0; null != (r = d[s]); s++)
                t.nodeName(r, "script") && l(r) || (o.appendChild(r),
                "undefined" != typeof r.getElementsByTagName && (c = t.grep(t.merge([], r.getElementsByTagName("script")), l),
                d.splice.apply(d, [s + 1, 0].concat(c)),
                s += c.length));
        return d
    }
    );
    var T = t.event.add
      , P = t.event.remove
      , E = t.event.trigger
      , j = t.fn.toggle
      , A = t.fn.live
      , z = t.fn.die
      , I = t.fn.load
      , L = "ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess"
      , D = new RegExp("\\b(?:" + L + ")\\b")
      , M = /(?:^|\s)hover(\.\S+|)\b/
      , F = function(e) {
        return "string" != typeof e || t.event.special.hover ? e : (M.test(e) && n("'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'"),
        e && e.replace(M, "mouseenter$1 mouseleave$1"))
    };
    t.event.props && "attrChange" !== t.event.props[0] && t.event.props.unshift("attrChange", "attrName", "relatedNode", "srcElement"),
    t.event.dispatch && o(t.event, "handle", t.event.dispatch, "jQuery.event.handle is undocumented and deprecated"),
    t.event.add = function(t, e, i, o, a) {
        t !== document && D.test(e) && n("AJAX events should be attached to document: " + e),
        T.call(this, t, F(e || ""), i, o, a)
    }
    ,
    t.event.remove = function(t, e, i, n, o) {
        P.call(this, t, F(e) || "", i, n, o)
    }
    ,
    t.each(["load", "unload", "error"], (function(e, i) {
        t.fn[i] = function() {
            var t = Array.prototype.slice.call(arguments, 0);
            return "load" === i && "string" == typeof t[0] ? I.apply(this, t) : (n("jQuery.fn." + i + "() is deprecated"),
            t.splice(0, 0, i),
            arguments.length ? this.bind.apply(this, t) : (this.triggerHandler.apply(this, t),
            this))
        }
    }
    )),
    t.fn.toggle = function(e, i) {
        if (!t.isFunction(e) || !t.isFunction(i))
            return j.apply(this, arguments);
        n("jQuery.fn.toggle(handler, handler...) is deprecated");
        var o = arguments
          , a = e.guid || t.guid++
          , s = 0
          , r = function(i) {
            var n = (t._data(this, "lastToggle" + e.guid) || 0) % s;
            return t._data(this, "lastToggle" + e.guid, n + 1),
            i.preventDefault(),
            o[n].apply(this, arguments) || !1
        };
        for (r.guid = a; s < o.length; )
            o[s++].guid = a;
        return this.click(r)
    }
    ,
    t.fn.live = function(e, i, o) {
        return n("jQuery.fn.live() is deprecated"),
        A ? A.apply(this, arguments) : (t(this.context).on(e, this.selector, i, o),
        this)
    }
    ,
    t.fn.die = function(e, i) {
        return n("jQuery.fn.die() is deprecated"),
        z ? z.apply(this, arguments) : (t(this.context).off(e, this.selector || "**", i),
        this)
    }
    ,
    t.event.trigger = function(t, e, i, o) {
        return i || D.test(t) || n("Global events are undocumented and deprecated"),
        E.call(this, t, e, i || document, o)
    }
    ,
    t.each(L.split("|"), (function(e, i) {
        t.event.special[i] = {
            setup: function() {
                var e = this;
                return e !== document && (t.event.add(document, i + "." + t.guid, (function() {
                    t.event.trigger(i, Array.prototype.slice.call(arguments, 1), e, !0)
                }
                )),
                t._data(this, i, t.guid++)),
                !1
            },
            teardown: function() {
                return this !== document && t.event.remove(document, i + "." + t._data(this, i)),
                !1
            }
        }
    }
    )),
    t.event.special.ready = {
        setup: function() {
            this === document && n("'ready' event is deprecated")
        }
    };
    var q = t.fn.andSelf || t.fn.addBack
      , O = t.fn.find;
    if (t.fn.andSelf = function() {
        return n("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()"),
        q.apply(this, arguments)
    }
    ,
    t.fn.find = function(t) {
        var e = O.apply(this, arguments);
        return e.context = this.context,
        e.selector = this.selector ? this.selector + " " + t : t,
        e
    }
    ,
    t.Callbacks) {
        var B = t.Deferred
          , R = [["resolve", "done", t.Callbacks("once memory"), t.Callbacks("once memory"), "resolved"], ["reject", "fail", t.Callbacks("once memory"), t.Callbacks("once memory"), "rejected"], ["notify", "progress", t.Callbacks("memory"), t.Callbacks("memory")]];
        t.Deferred = function(e) {
            var i = B()
              , o = i.promise();
            return i.pipe = o.pipe = function() {
                var e = arguments;
                return n("deferred.pipe() is deprecated"),
                t.Deferred((function(n) {
                    t.each(R, (function(a, s) {
                        var r = t.isFunction(e[a]) && e[a];
                        i[s[1]]((function() {
                            var e = r && r.apply(this, arguments);
                            e && t.isFunction(e.promise) ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[s[0] + "With"](this === o ? n.promise() : this, r ? [e] : arguments)
                        }
                        ))
                    }
                    )),
                    e = null
                }
                )).promise()
            }
            ,
            i.isResolved = function() {
                return n("deferred.isResolved is deprecated"),
                "resolved" === i.state()
            }
            ,
            i.isRejected = function() {
                return n("deferred.isRejected is deprecated"),
                "rejected" === i.state()
            }
            ,
            e && e.call(i, i),
            i
        }
    }
}(jQuery, window),
/*!
  Zoom 1.7.15
  license: MIT
  http://www.jacklmoore.com/zoom
*/
function(t) {
    var e = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
    };
    t.zoom = function(e, i, n, o) {
        var a, s, r, l, c, d, u, p = t(e), h = p.css("position"), f = t(i);
        return p.css("position", /(absolute|fixed)/.test(h) ? h : "relative"),
        p.css("overflow", "hidden"),
        n.style.width = n.style.height = "",
        t(n).addClass("zoomImg").css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: n.width * o,
            height: n.height * o,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
        }).appendTo(e),
        {
            init: function() {
                s = p.outerWidth(),
                a = p.outerHeight(),
                i === p[0] ? (l = s,
                r = a) : (l = f.outerWidth(),
                r = f.outerHeight()),
                c = (n.width - s) / l,
                d = (n.height - a) / r,
                u = f.offset()
            },
            move: function(t) {
                var e = t.pageX - u.left
                  , i = t.pageY - u.top;
                i = Math.max(Math.min(i, r), 0),
                e = Math.max(Math.min(e, l), 0),
                n.style.left = e * -c + "px",
                n.style.top = i * -d + "px"
            }
        }
    }
    ,
    t.fn.zoom = function(i) {
        return this.each((function() {
            var n = t.extend({}, e, i || {}), o = n.target || this, a = this, s = t(a), r = t(o), l = document.createElement("img"), c = t(l), d = "mousemove.zoom", u = !1, p = !1, h;
            (n.url || ((h = s.find("img"))[0] && (n.url = h.data("src") || h.attr("src")),
            n.url)) && (!function() {
                var t = r.css("position");
                var e = r.css("overflow");
                s.one("zoom.destroy", (function() {
                    s.off(".zoom"),
                    r.css("position", t),
                    r.css("overflow", e),
                    c.remove()
                }
                ))
            }(),
            l.onload = function() {
                var e = t.zoom(o, a, l, n.magnify);
                function i(i) {
                    e.init(),
                    e.move(i),
                    c.stop().fadeTo(t.support.opacity ? n.duration : 0, 1, !!t.isFunction(n.onZoomIn) && n.onZoomIn.call(l))
                }
                function r() {
                    c.stop().fadeTo(n.duration, 0, !!t.isFunction(n.onZoomOut) && n.onZoomOut.call(l))
                }
                "grab" === n.on ? s.on("mousedown.zoom", (function(n) {
                    1 === n.which && (t(document).one("mouseup.zoom", (function() {
                        r(),
                        t(document).off(d, e.move)
                    }
                    )),
                    i(n),
                    t(document).on(d, e.move),
                    n.preventDefault())
                }
                )) : "click" === n.on ? s.on("click.zoom", (function(n) {
                    return u ? void 0 : (u = !0,
                    i(n),
                    t(document).on(d, e.move),
                    t(document).one("click.zoom", (function() {
                        r(),
                        u = !1,
                        t(document).off(d, e.move)
                    }
                    )),
                    !1)
                }
                )) : "toggle" === n.on ? s.on("click.zoom", (function(t) {
                    u ? r() : i(t),
                    u = !u
                }
                )) : "mouseover" === n.on && (e.init(),
                s.on("mouseenter.zoom", i).on("mouseleave.zoom", r).on(d, e.move)),
                n.touch && s.on("touchstart.zoom", (function(t) {
                    t.preventDefault(),
                    p ? (p = !1,
                    r()) : (p = !0,
                    i(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0]))
                }
                )).on("touchmove.zoom", (function(t) {
                    t.preventDefault(),
                    e.move(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0])
                }
                )).on("touchend.zoom", (function(t) {
                    t.preventDefault(),
                    p && (p = !1,
                    r())
                }
                )),
                t.isFunction(n.callback) && n.callback.call(l)
            }
            ,
            l.src = n.url)
        }
        ))
    }
    ,
    t.fn.zoom.defaults = e
}(window.jQuery),
function(t) {
    var e = !1;
    if ("function" == typeof define && define.amd && (define(t),
    e = !0),
    "object" == typeof exports && (module.exports = t(),
    e = !0),
    !e) {
        var i = window.Cookies
          , n = window.Cookies = t();
        n.noConflict = function() {
            return window.Cookies = i,
            n
        }
    }
}((function() {
    function t() {
        for (var t = 0, e = {}; t < arguments.length; t++) {
            var i = arguments[t];
            for (var n in i)
                e[n] = i[n]
        }
        return e
    }
    function e(i) {
        function n(e, o, a) {
            var s;
            if ("undefined" != typeof document) {
                if (arguments.length > 1) {
                    if ("number" == typeof (a = t({
                        path: "/"
                    }, n.defaults, a)).expires) {
                        var r = new Date;
                        r.setMilliseconds(r.getMilliseconds() + 864e5 * a.expires),
                        a.expires = r
                    }
                    a.expires = a.expires ? a.expires.toUTCString() : "";
                    try {
                        s = JSON.stringify(o),
                        /^[\{\[]/.test(s) && (o = s)
                    } catch (t) {}
                    o = i.write ? i.write(o, e) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent),
                    e = (e = (e = encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
                    var l = "";
                    for (var c in a)
                        a[c] && (l += "; " + c,
                        !0 !== a[c] && (l += "=" + a[c]));
                    return document.cookie = e + "=" + o + l
                }
                e || (s = {});
                for (var d = document.cookie ? document.cookie.split("; ") : [], u = /(%[0-9A-Z]{2})+/g, p = 0; p < d.length; p++) {
                    var h = d[p].split("=")
                      , f = h.slice(1).join("=");
                    '"' === f.charAt(0) && (f = f.slice(1, -1));
                    try {
                        var m = h[0].replace(u, decodeURIComponent);
                        if (f = i.read ? i.read(f, m) : i(f, m) || f.replace(u, decodeURIComponent),
                        this.json)
                            try {
                                f = JSON.parse(f)
                            } catch (t) {}
                        if (e === m) {
                            s = f;
                            break
                        }
                        e || (s[m] = f)
                    } catch (t) {}
                }
                return s
            }
        }
        return n.set = n,
        n.get = function(t) {
            return n.call(n, t)
        }
        ,
        n.getJSON = function() {
            return n.apply({
                json: !0
            }, [].slice.call(arguments))
        }
        ,
        n.defaults = {},
        n.remove = function(e, i) {
            n(e, "", t(i, {
                expires: -1
            }))
        }
        ,
        n.withConverter = e,
        n
    }
    return e((function() {}
    ))
}
)),
/*!
Waypoints - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function() {
    "use strict";
    function t(n) {
        if (!n)
            throw new Error("No options passed to Waypoint constructor");
        if (!n.element)
            throw new Error("No element option passed to Waypoint constructor");
        if (!n.handler)
            throw new Error("No handler option passed to Waypoint constructor");
        this.key = "waypoint-" + e,
        this.options = t.Adapter.extend({}, t.defaults, n),
        this.element = this.options.element,
        this.adapter = new t.Adapter(this.element),
        this.callback = n.handler,
        this.axis = this.options.horizontal ? "horizontal" : "vertical",
        this.enabled = this.options.enabled,
        this.triggerPoint = null,
        this.group = t.Group.findOrCreate({
            name: this.options.group,
            axis: this.axis
        }),
        this.context = t.Context.findOrCreateByElement(this.options.context),
        t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]),
        this.group.add(this),
        this.context.add(this),
        i[this.key] = this,
        e += 1
    }
    var e = 0
      , i = {};
    t.prototype.queueTrigger = function(t) {
        this.group.queueTrigger(this, t)
    }
    ,
    t.prototype.trigger = function(t) {
        this.enabled && this.callback && this.callback.apply(this, t)
    }
    ,
    t.prototype.destroy = function() {
        this.context.remove(this),
        this.group.remove(this),
        delete i[this.key]
    }
    ,
    t.prototype.disable = function() {
        return this.enabled = !1,
        this
    }
    ,
    t.prototype.enable = function() {
        return this.context.refresh(),
        this.enabled = !0,
        this
    }
    ,
    t.prototype.next = function() {
        return this.group.next(this)
    }
    ,
    t.prototype.previous = function() {
        return this.group.previous(this)
    }
    ,
    t.invokeAll = function(t) {
        var e = [];
        for (var n in i)
            e.push(i[n]);
        for (var o = 0, a = e.length; a > o; o++)
            e[o][t]()
    }
    ,
    t.destroyAll = function() {
        t.invokeAll("destroy")
    }
    ,
    t.disableAll = function() {
        t.invokeAll("disable")
    }
    ,
    t.enableAll = function() {
        t.invokeAll("enable")
    }
    ,
    t.refreshAll = function() {
        t.Context.refreshAll()
    }
    ,
    t.viewportHeight = function() {
        return window.innerHeight || document.documentElement.clientHeight
    }
    ,
    t.viewportWidth = function() {
        return document.documentElement.clientWidth
    }
    ,
    t.adapters = [],
    t.defaults = {
        context: window,
        continuous: !0,
        enabled: !0,
        group: "default",
        horizontal: !1,
        offset: 0
    },
    t.offsetAliases = {
        "bottom-in-view": function() {
            return this.context.innerHeight() - this.adapter.outerHeight()
        },
        "right-in-view": function() {
            return this.context.innerWidth() - this.adapter.outerWidth()
        }
    },
    window.Waypoint = t
}(),
function() {
    "use strict";
    function t(t) {
        window.setTimeout(t, 1e3 / 60)
    }
    function e(t) {
        this.element = t,
        this.Adapter = o.Adapter,
        this.adapter = new this.Adapter(t),
        this.key = "waypoint-context-" + i,
        this.didScroll = !1,
        this.didResize = !1,
        this.oldScroll = {
            x: this.adapter.scrollLeft(),
            y: this.adapter.scrollTop()
        },
        this.waypoints = {
            vertical: {},
            horizontal: {}
        },
        t.waypointContextKey = this.key,
        n[t.waypointContextKey] = this,
        i += 1,
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler()
    }
    var i = 0
      , n = {}
      , o = window.Waypoint
      , a = window.onload;
    e.prototype.add = function(t) {
        var e = t.options.horizontal ? "horizontal" : "vertical";
        this.waypoints[e][t.key] = t,
        this.refresh()
    }
    ,
    e.prototype.checkEmpty = function() {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal)
          , e = this.Adapter.isEmptyObject(this.waypoints.vertical);
        t && e && (this.adapter.off(".waypoints"),
        delete n[this.key])
    }
    ,
    e.prototype.createThrottledResizeHandler = function() {
        function t() {
            e.handleResize(),
            e.didResize = !1
        }
        var e = this;
        this.adapter.on("resize.waypoints", (function() {
            e.didResize || (e.didResize = !0,
            o.requestAnimationFrame(t))
        }
        ))
    }
    ,
    e.prototype.createThrottledScrollHandler = function() {
        function t() {
            e.handleScroll(),
            e.didScroll = !1
        }
        var e = this;
        this.adapter.on("scroll.waypoints", (function() {
            (!e.didScroll || o.isTouch) && (e.didScroll = !0,
            o.requestAnimationFrame(t))
        }
        ))
    }
    ,
    e.prototype.handleResize = function() {
        o.Context.refreshAll()
    }
    ,
    e.prototype.handleScroll = function() {
        var t = {}
          , e = {
            horizontal: {
                newScroll: this.adapter.scrollLeft(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left"
            },
            vertical: {
                newScroll: this.adapter.scrollTop(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up"
            }
        };
        for (var i in e) {
            var n = e[i], o, a = n.newScroll > n.oldScroll ? n.forward : n.backward;
            for (var s in this.waypoints[i]) {
                var r = this.waypoints[i][s], l = n.oldScroll < r.triggerPoint, c = n.newScroll >= r.triggerPoint, d, u;
                (l && c || !l && !c) && (r.queueTrigger(a),
                t[r.group.id] = r.group)
            }
        }
        for (var p in t)
            t[p].flushTriggers();
        this.oldScroll = {
            x: e.horizontal.newScroll,
            y: e.vertical.newScroll
        }
    }
    ,
    e.prototype.innerHeight = function() {
        return this.element == this.element.window ? o.viewportHeight() : this.adapter.innerHeight()
    }
    ,
    e.prototype.remove = function(t) {
        delete this.waypoints[t.axis][t.key],
        this.checkEmpty()
    }
    ,
    e.prototype.innerWidth = function() {
        return this.element == this.element.window ? o.viewportWidth() : this.adapter.innerWidth()
    }
    ,
    e.prototype.destroy = function() {
        var t = [];
        for (var e in this.waypoints)
            for (var i in this.waypoints[e])
                t.push(this.waypoints[e][i]);
        for (var n = 0, o = t.length; o > n; n++)
            t[n].destroy()
    }
    ,
    e.prototype.refresh = function() {
        var t, e = this.element == this.element.window, i = e ? void 0 : this.adapter.offset(), n = {};
        for (var a in this.handleScroll(),
        t = {
            horizontal: {
                contextOffset: e ? 0 : i.left,
                contextScroll: e ? 0 : this.oldScroll.x,
                contextDimension: this.innerWidth(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left",
                offsetProp: "left"
            },
            vertical: {
                contextOffset: e ? 0 : i.top,
                contextScroll: e ? 0 : this.oldScroll.y,
                contextDimension: this.innerHeight(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up",
                offsetProp: "top"
            }
        }) {
            var s = t[a];
            for (var r in this.waypoints[a]) {
                var l, c, d, u, p, h = this.waypoints[a][r], f = h.options.offset, m = h.triggerPoint, g = 0, y = null == m;
                h.element !== h.element.window && (g = h.adapter.offset()[s.offsetProp]),
                "function" == typeof f ? f = f.apply(h) : "string" == typeof f && (f = parseFloat(f),
                h.options.offset.indexOf("%") > -1 && (f = Math.ceil(s.contextDimension * f / 100))),
                l = s.contextScroll - s.contextOffset,
                h.triggerPoint = g + l - f,
                c = m < s.oldScroll,
                d = h.triggerPoint >= s.oldScroll,
                p = !c && !d,
                !y && (u = c && d) ? (h.queueTrigger(s.backward),
                n[h.group.id] = h.group) : (!y && p || y && s.oldScroll >= h.triggerPoint) && (h.queueTrigger(s.forward),
                n[h.group.id] = h.group)
            }
        }
        return o.requestAnimationFrame((function() {
            for (var t in n)
                n[t].flushTriggers()
        }
        )),
        this
    }
    ,
    e.findOrCreateByElement = function(t) {
        return e.findByElement(t) || new e(t)
    }
    ,
    e.refreshAll = function() {
        for (var t in n)
            n[t].refresh()
    }
    ,
    e.findByElement = function(t) {
        return n[t.waypointContextKey]
    }
    ,
    window.onload = function() {
        a && a(),
        e.refreshAll()
    }
    ,
    o.requestAnimationFrame = function(e) {
        var i;
        (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t).call(window, e)
    }
    ,
    o.Context = e
}(),
function() {
    "use strict";
    function t(t, e) {
        return t.triggerPoint - e.triggerPoint
    }
    function e(t, e) {
        return e.triggerPoint - t.triggerPoint
    }
    function i(t) {
        this.name = t.name,
        this.axis = t.axis,
        this.id = this.name + "-" + this.axis,
        this.waypoints = [],
        this.clearTriggerQueues(),
        n[this.axis][this.name] = this
    }
    var n = {
        vertical: {},
        horizontal: {}
    }
      , o = window.Waypoint;
    i.prototype.add = function(t) {
        this.waypoints.push(t)
    }
    ,
    i.prototype.clearTriggerQueues = function() {
        this.triggerQueues = {
            up: [],
            down: [],
            left: [],
            right: []
        }
    }
    ,
    i.prototype.flushTriggers = function() {
        for (var i in this.triggerQueues) {
            var n = this.triggerQueues[i]
              , o = "up" === i || "left" === i;
            n.sort(o ? e : t);
            for (var a = 0, s = n.length; s > a; a += 1) {
                var r = n[a];
                (r.options.continuous || a === n.length - 1) && r.trigger([i])
            }
        }
        this.clearTriggerQueues()
    }
    ,
    i.prototype.next = function(e) {
        this.waypoints.sort(t);
        var i = o.Adapter.inArray(e, this.waypoints), n;
        return i === this.waypoints.length - 1 ? null : this.waypoints[i + 1]
    }
    ,
    i.prototype.previous = function(e) {
        this.waypoints.sort(t);
        var i = o.Adapter.inArray(e, this.waypoints);
        return i ? this.waypoints[i - 1] : null
    }
    ,
    i.prototype.queueTrigger = function(t, e) {
        this.triggerQueues[e].push(t)
    }
    ,
    i.prototype.remove = function(t) {
        var e = o.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1)
    }
    ,
    i.prototype.first = function() {
        return this.waypoints[0]
    }
    ,
    i.prototype.last = function() {
        return this.waypoints[this.waypoints.length - 1]
    }
    ,
    i.findOrCreate = function(t) {
        return n[t.axis][t.name] || new i(t)
    }
    ,
    o.Group = i
}(),
function() {
    "use strict";
    function t(t) {
        this.$element = e(t)
    }
    var e = window.jQuery
      , i = window.Waypoint;
    e.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], (function(e, i) {
        t.prototype[i] = function() {
            var t = Array.prototype.slice.call(arguments);
            return this.$element[i].apply(this.$element, t)
        }
    }
    )),
    e.each(["extend", "inArray", "isEmptyObject"], (function(i, n) {
        t[n] = e[n]
    }
    )),
    i.adapters.push({
        name: "jquery",
        Adapter: t
    }),
    i.Adapter = t
}(),
function() {
    "use strict";
    function t(t) {
        return function() {
            var i = []
              , n = arguments[0];
            return t.isFunction(arguments[0]) && ((n = t.extend({}, arguments[1])).handler = arguments[0]),
            this.each((function() {
                var o = t.extend({}, n, {
                    element: this
                });
                "string" == typeof o.context && (o.context = t(this).closest(o.context)[0]),
                i.push(new e(o))
            }
            )),
            i
        }
    }
    var e = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
    window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto))
}(),
function() {
    "use strict";
    function t(n) {
        this.options = e.extend({}, t.defaults, n),
        this.container = this.options.element,
        "auto" !== this.options.container && (this.container = this.options.container),
        this.$container = e(this.container),
        this.$more = e(this.options.more),
        this.$more.length && (this.setupHandler(),
        this.waypoint = new i(this.options))
    }
    var e = window.jQuery
      , i = window.Waypoint;
    t.prototype.setupHandler = function() {
        this.options.handler = e.proxy((function() {
            this.options.onBeforePageLoad(),
            this.destroy(),
            this.$container.addClass(this.options.loadingClass),
            e.get(e(this.options.more).attr("href"), e.proxy((function(t) {
                var n = e(e.parseHTML(t))
                  , o = n.find(this.options.more)
                  , a = n.find(this.options.items);
                a.length || (a = n.filter(this.options.items)),
                this.$container.append(a),
                this.$container.removeClass(this.options.loadingClass),
                o.length || (o = n.filter(this.options.more)),
                o.length ? (this.$more.replaceWith(o),
                this.$more = o,
                this.waypoint = new i(this.options)) : this.$more.remove(),
                this.options.onAfterPageLoad(a)
            }
            ), this))
        }
        ), this)
    }
    ,
    t.prototype.destroy = function() {
        this.waypoint && this.waypoint.destroy()
    }
    ,
    t.defaults = {
        container: "auto",
        items: ".infinite-item",
        more: ".infinite-more-link",
        offset: "bottom-in-view",
        loadingClass: "infinite-loading",
        onBeforePageLoad: e.noop,
        onAfterPageLoad: e.noop
    },
    i.Infinite = t
}(),
function(t) {
    t.fn.mediaWrapper = function(e) {
        var i = t.extend({
            intrinsic: !0,
            baseWidth: 16,
            baseHeight: 9
        }, e);
        return this.each((function() {
            var e = "";
            e = 1 == i.intrinsic && "" !== t(this).attr("width") && "" !== t(this).attr("height") ? t(this).attr("height") / t(this).attr("width") * 100 : i.baseHeight / i.baseWidth * 100,
            t(this).wrap('<div class="mediaWrapper" style="position: relative; width: 100%; height: 0; padding: ' + e + '% 0 0 0; " />').css({
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0"
            })
        }
        ))
    }
}(jQuery),
PointerEventsPolyfill.initialize = function(t) {
    return null == PointerEventsPolyfill.singleton && (PointerEventsPolyfill.singleton = new PointerEventsPolyfill(t)),
    PointerEventsPolyfill.singleton
}
,
PointerEventsPolyfill.prototype.register_mouse_events = function() {
    $(document).on(this.options.mouseEvents.join(" "), this.options.selector, (function(t) {
        if ("none" == $(this).css("pointer-events")) {
            var e = $(this).css("display");
            $(this).css("display", "none");
            var i = document.elementFromPoint(t.clientX, t.clientY);
            return e ? $(this).css("display", e) : $(this).css("display", ""),
            t.target = i,
            $(i).trigger(t),
            !1
        }
        return !0
    }
    ))
}
,
/*!
 * Flickity PACKAGED v2.1.2
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2018 Metafizzy
 */
!function(t, e) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], (function(i) {
        return e(t, i)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery)
}(window, (function(t, e) {
    "use strict";
    function i(i, a, r) {
        function l(t, e, n) {
            var o, a = "$()." + i + '("' + e + '")';
            return t.each((function(t, l) {
                var c = r.data(l, i);
                if (c) {
                    var d = c[e];
                    if (d && "_" != e.charAt(0)) {
                        var u = d.apply(c, n);
                        o = void 0 === o ? u : o
                    } else
                        s(a + " is not a valid method")
                } else
                    s(i + " not initialized. Cannot call methods, i.e. " + a)
            }
            )),
            void 0 !== o ? o : t
        }
        function c(t, e) {
            t.each((function(t, n) {
                var o = r.data(n, i);
                o ? (o.option(e),
                o._init()) : (o = new a(n,e),
                r.data(n, i, o))
            }
            ))
        }
        (r = r || e || t.jQuery) && (a.prototype.option || (a.prototype.option = function(t) {
            r.isPlainObject(t) && (this.options = r.extend(!0, this.options, t))
        }
        ),
        r.fn[i] = function(t) {
            var e;
            return "string" == typeof t ? l(this, t, o.call(arguments, 1)) : (c(this, t),
            this)
        }
        ,
        n(r))
    }
    function n(t) {
        !t || t && t.bridget || (t.bridget = i)
    }
    var o = Array.prototype.slice
      , a = t.console
      , s = "undefined" == typeof a ? function() {}
    : function(t) {
        a.error(t)
    }
    ;
    return n(e || t.jQuery),
    i
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, (function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var i = this._events = this._events || {}
              , n = i[t] = i[t] || [];
            return -1 == n.indexOf(e) && n.push(e),
            this
        }
    }
    ,
    e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {}, n;
            return (i[t] = i[t] || {})[e] = !0,
            this
        }
    }
    ,
    e.off = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1),
            this
        }
    }
    ,
    e.emitEvent = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            i = i.slice(0),
            e = e || [];
            for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                var a = i[o], s;
                n && n[a] && (this.off(t, a),
                delete n[a]),
                a.apply(this, e)
            }
            return this
        }
    }
    ,
    e.allOff = function() {
        delete this._events,
        delete this._onceEvents
    }
    ,
    t
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, (function() {
    "use strict";
    function t(t) {
        var e = parseFloat(t), i;
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }
    function e() {}
    function i() {
        for (var t = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        }, e = 0; e < c; e++) {
            var i;
            t[l[e]] = 0
        }
        return t
    }
    function n(t) {
        var e = getComputedStyle(t);
        return e || r("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),
        e
    }
    function o() {
        if (!d) {
            d = !0;
            var e = document.createElement("div");
            e.style.width = "200px",
            e.style.padding = "1px 2px 3px 4px",
            e.style.borderStyle = "solid",
            e.style.borderWidth = "1px 2px 3px 4px",
            e.style.boxSizing = "border-box";
            var i = document.body || document.documentElement;
            i.appendChild(e);
            var o = n(e);
            s = 200 == Math.round(t(o.width)),
            a.isBoxSizeOuter = s,
            i.removeChild(e)
        }
    }
    function a(e) {
        if (o(),
        "string" == typeof e && (e = document.querySelector(e)),
        e && "object" == typeof e && e.nodeType) {
            var a = n(e);
            if ("none" == a.display)
                return i();
            var r = {};
            r.width = e.offsetWidth,
            r.height = e.offsetHeight;
            for (var d = r.isBorderBox = "border-box" == a.boxSizing, u = 0; u < c; u++) {
                var p = l[u]
                  , h = a[p]
                  , f = parseFloat(h);
                r[p] = isNaN(f) ? 0 : f
            }
            var m = r.paddingLeft + r.paddingRight
              , g = r.paddingTop + r.paddingBottom
              , y = r.marginLeft + r.marginRight
              , v = r.marginTop + r.marginBottom
              , b = r.borderLeftWidth + r.borderRightWidth
              , w = r.borderTopWidth + r.borderBottomWidth
              , $ = d && s
              , _ = t(a.width);
            !1 !== _ && (r.width = _ + ($ ? 0 : m + b));
            var x = t(a.height);
            return !1 !== x && (r.height = x + ($ ? 0 : g + w)),
            r.innerWidth = r.width - (m + b),
            r.innerHeight = r.height - (g + w),
            r.outerWidth = r.width + y,
            r.outerHeight = r.height + v,
            r
        }
    }
    var s, r = "undefined" == typeof console ? e : function(t) {
        console.error(t)
    }
    , l = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"], c = l.length, d = !1;
    return a
}
)),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, (function() {
    "use strict";
    var t = function() {
        var t = window.Element.prototype;
        if (t.matches)
            return "matches";
        if (t.matchesSelector)
            return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var n, o = e[i] + "MatchesSelector";
            if (t[o])
                return o
        }
    }();
    return function(e, i) {
        return e[t](i)
    }
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], (function(i) {
        return e(t, i)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector)
}(window, (function(t, e) {
    var i = {};
    i.extend = function(t, e) {
        for (var i in e)
            t[i] = e[i];
        return t
    }
    ,
    i.modulo = function(t, e) {
        return (t % e + e) % e
    }
    ;
    var n = Array.prototype.slice;
    i.makeArray = function(t) {
        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? n.call(t) : [t];
        var e
    }
    ,
    i.removeFrom = function(t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1)
    }
    ,
    i.getParent = function(t, i) {
        for (; t.parentNode && t != document.body; )
            if (t = t.parentNode,
            e(t, i))
                return t
    }
    ,
    i.getQueryElement = function(t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }
    ,
    i.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    i.filterFindElements = function(t, n) {
        t = i.makeArray(t);
        var o = [];
        return t.forEach((function(t) {
            if (t instanceof HTMLElement) {
                if (!n)
                    return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), a = 0; a < i.length; a++)
                    o.push(i[a])
            }
        }
        )),
        o
    }
    ,
    i.debounceMethod = function(t, e, i) {
        i = i || 100;
        var n = t.prototype[e]
          , o = e + "Timeout";
        t.prototype[e] = function() {
            var t = this[o];
            clearTimeout(t);
            var e = arguments
              , a = this;
            this[o] = setTimeout((function() {
                n.apply(a, e),
                delete a[o]
            }
            ), i)
        }
    }
    ,
    i.docReady = function(t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }
    ,
    i.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, (function(t, e, i) {
            return e + "-" + i
        }
        )).toLowerCase()
    }
    ;
    var o = t.console;
    return i.htmlInit = function(e, n) {
        i.docReady((function() {
            var a = i.toDashed(n)
              , s = "data-" + a
              , r = document.querySelectorAll("[" + s + "]")
              , l = document.querySelectorAll(".js-" + a)
              , c = i.makeArray(r).concat(i.makeArray(l))
              , d = s + "-options"
              , u = t.jQuery;
            c.forEach((function(t) {
                var i, a = t.getAttribute(s) || t.getAttribute(d);
                try {
                    i = a && JSON.parse(a)
                } catch (e) {
                    return void (o && o.error("Error parsing " + s + " on " + t.className + ": " + e))
                }
                var r = new e(t,i);
                u && u.data(t, n, r)
            }
            ))
        }
        ))
    }
    ,
    i
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/cell", ["get-size/get-size"], (function(i) {
        return e(t, i)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("get-size")) : (t.Flickity = t.Flickity || {},
    t.Flickity.Cell = e(t, t.getSize))
}(window, (function(t, e) {
    function i(t, e) {
        this.element = t,
        this.parent = e,
        this.create()
    }
    var n = i.prototype;
    return n.create = function() {
        this.element.style.position = "absolute",
        this.element.setAttribute("aria-selected", "false"),
        this.x = 0,
        this.shift = 0
    }
    ,
    n.destroy = function() {
        this.element.style.position = "";
        var t = this.parent.originSide;
        this.element.removeAttribute("aria-selected"),
        this.element.style[t] = ""
    }
    ,
    n.getSize = function() {
        this.size = e(this.element)
    }
    ,
    n.setPosition = function(t) {
        this.x = t,
        this.updateTarget(),
        this.renderPosition(t)
    }
    ,
    n.updateTarget = n.setDefaultTarget = function() {
        var t = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign
    }
    ,
    n.renderPosition = function(t) {
        var e = this.parent.originSide;
        this.element.style[e] = this.parent.getPositionValue(t)
    }
    ,
    n.wrapShift = function(t) {
        this.shift = t,
        this.renderPosition(this.x + this.parent.slideableWidth * t)
    }
    ,
    n.remove = function() {
        this.element.parentNode.removeChild(this.element)
    }
    ,
    i
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/slide", e) : "object" == typeof module && module.exports ? module.exports = e() : (t.Flickity = t.Flickity || {},
    t.Flickity.Slide = e())
}(window, (function() {
    "use strict";
    function t(t) {
        this.parent = t,
        this.isOriginLeft = "left" == t.originSide,
        this.cells = [],
        this.outerWidth = 0,
        this.height = 0
    }
    var e = t.prototype;
    return e.addCell = function(t) {
        if (this.cells.push(t),
        this.outerWidth += t.size.outerWidth,
        this.height = Math.max(t.size.outerHeight, this.height),
        1 == this.cells.length) {
            this.x = t.x;
            var e = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = t.size[e]
        }
    }
    ,
    e.updateTarget = function() {
        var t = this.isOriginLeft ? "marginRight" : "marginLeft"
          , e = this.getLastCell()
          , i = e ? e.size[t] : 0
          , n = this.outerWidth - (this.firstMargin + i);
        this.target = this.x + this.firstMargin + n * this.parent.cellAlign
    }
    ,
    e.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }
    ,
    e.select = function() {
        this.changeSelected(!0)
    }
    ,
    e.unselect = function() {
        this.changeSelected(!1)
    }
    ,
    e.changeSelected = function(t) {
        var e = t ? "add" : "remove";
        this.cells.forEach((function(i) {
            i.element.classList[e]("is-selected"),
            i.element.setAttribute("aria-selected", t.toString())
        }
        ))
    }
    ,
    e.getCellElements = function() {
        return this.cells.map((function(t) {
            return t.element
        }
        ))
    }
    ,
    t
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], (function(i) {
        return e(t, i)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("fizzy-ui-utils")) : (t.Flickity = t.Flickity || {},
    t.Flickity.animatePrototype = e(t, t.fizzyUIUtils))
}(window, (function(t, e) {
    var i = {};
    return i.startAnimation = function() {
        this.isAnimating || (this.isAnimating = !0,
        this.restingFrames = 0,
        this.animate())
    }
    ,
    i.animate = function() {
        this.applyDragForce(),
        this.applySelectedAttraction();
        var t = this.x;
        if (this.integratePhysics(),
        this.positionSlider(),
        this.settle(t),
        this.isAnimating) {
            var e = this;
            requestAnimationFrame((function() {
                e.animate()
            }
            ))
        }
    }
    ,
    i.positionSlider = function() {
        var t = this.x;
        this.options.wrapAround && this.cells.length > 1 && (t = e.modulo(t, this.slideableWidth),
        t -= this.slideableWidth,
        this.shiftWrapCells(t)),
        t += this.cursorPosition,
        t = this.options.rightToLeft ? -t : t;
        var i = this.getPositionValue(t);
        this.slider.style.transform = this.isAnimating ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")";
        var n = this.slides[0];
        if (n) {
            var o = -this.x - n.target
              , a = o / this.slidesWidth;
            this.dispatchEvent("scroll", null, [a, o])
        }
    }
    ,
    i.positionSliderAtSelected = function() {
        this.cells.length && (this.x = -this.selectedSlide.target,
        this.velocity = 0,
        this.positionSlider())
    }
    ,
    i.getPositionValue = function(t) {
        return this.options.percentPosition ? .01 * Math.round(t / this.size.innerWidth * 1e4) + "%" : Math.round(t) + "px"
    }
    ,
    i.settle = function(t) {
        this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * t) || this.restingFrames++,
        this.restingFrames > 2 && (this.isAnimating = !1,
        delete this.isFreeScrolling,
        this.positionSlider(),
        this.dispatchEvent("settle", null, [this.selectedIndex]))
    }
    ,
    i.shiftWrapCells = function(t) {
        var e = this.cursorPosition + t;
        this._shiftCells(this.beforeShiftCells, e, -1);
        var i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, i, 1)
    }
    ,
    i._shiftCells = function(t, e, i) {
        for (var n = 0; n < t.length; n++) {
            var o = t[n]
              , a = e > 0 ? i : 0;
            o.wrapShift(a),
            e -= o.size.outerWidth
        }
    }
    ,
    i._unshiftCells = function(t) {
        if (t && t.length)
            for (var e = 0; e < t.length; e++)
                t[e].wrapShift(0)
    }
    ,
    i.integratePhysics = function() {
        this.x += this.velocity,
        this.velocity *= this.getFrictionFactor()
    }
    ,
    i.applyForce = function(t) {
        this.velocity += t
    }
    ,
    i.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
    }
    ,
    i.getRestingPosition = function() {
        return this.x + this.velocity / (1 - this.getFrictionFactor())
    }
    ,
    i.applyDragForce = function() {
        if (this.isDraggable && this.isPointerDown) {
            var t, e = this.dragX - this.x - this.velocity;
            this.applyForce(e)
        }
    }
    ,
    i.applySelectedAttraction = function() {
        var t;
        if (!(this.isDraggable && this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
            var e, i = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
            this.applyForce(i)
        }
    }
    ,
    i
}
)),
function(t, e) {
    if ("function" == typeof define && define.amd)
        define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], (function(i, n, o, a, s, r) {
            return e(t, i, n, o, a, s, r)
        }
        ));
    else if ("object" == typeof module && module.exports)
        module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
    else {
        var i = t.Flickity;
        t.Flickity = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, i.Cell, i.Slide, i.animatePrototype)
    }
}(window, (function(t, e, i, n, o, a, s) {
    function r(t, e) {
        for (t = n.makeArray(t); t.length; )
            e.appendChild(t.shift())
    }
    function l(t, e) {
        var i = n.getQueryElement(t);
        if (i) {
            if (this.element = i,
            this.element.flickityGUID) {
                var o = h[this.element.flickityGUID];
                return o.option(e),
                o
            }
            c && (this.$element = c(this.element)),
            this.options = n.extend({}, this.constructor.defaults),
            this.option(e),
            this._create()
        } else
            u && u.error("Bad element for Flickity: " + (i || t))
    }
    var c = t.jQuery
      , d = t.getComputedStyle
      , u = t.console
      , p = 0
      , h = {};
    l.defaults = {
        accessibility: !0,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        namespaceJQueryEvents: !0,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0
    },
    l.createMethods = [];
    var f = l.prototype;
    n.extend(f, e.prototype),
    f._create = function() {
        var e = this.guid = ++p;
        for (var i in this.element.flickityGUID = e,
        h[e] = this,
        this.selectedIndex = 0,
        this.restingFrames = 0,
        this.x = 0,
        this.velocity = 0,
        this.originSide = this.options.rightToLeft ? "right" : "left",
        this.viewport = document.createElement("div"),
        this.viewport.className = "flickity-viewport",
        this._createSlider(),
        (this.options.resize || this.options.watchCSS) && t.addEventListener("resize", this),
        this.options.on) {
            var n = this.options.on[i];
            this.on(i, n)
        }
        l.createMethods.forEach((function(t) {
            this[t]()
        }
        ), this),
        this.options.watchCSS ? this.watchCSS() : this.activate()
    }
    ,
    f.option = function(t) {
        n.extend(this.options, t)
    }
    ,
    f.activate = function() {
        if (!this.isActive) {
            var t;
            this.isActive = !0,
            this.element.classList.add("flickity-enabled"),
            this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
            this.getSize(),
            r(this._filterFindCellElements(this.element.children), this.slider),
            this.viewport.appendChild(this.slider),
            this.element.appendChild(this.viewport),
            this.reloadCells(),
            this.options.accessibility && (this.element.tabIndex = 0,
            this.element.addEventListener("keydown", this)),
            this.emitEvent("activate");
            var e, i = this.options.initialIndex;
            e = this.isInitActivated ? this.selectedIndex : void 0 !== i && this.cells[i] ? i : 0,
            this.select(e, !1, !0),
            this.isInitActivated = !0,
            this.dispatchEvent("ready")
        }
    }
    ,
    f._createSlider = function() {
        var t = document.createElement("div");
        t.className = "flickity-slider",
        t.style[this.originSide] = 0,
        this.slider = t
    }
    ,
    f._filterFindCellElements = function(t) {
        return n.filterFindElements(t, this.options.cellSelector)
    }
    ,
    f.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children),
        this.positionCells(),
        this._getWrapShiftCells(),
        this.setGallerySize()
    }
    ,
    f._makeCells = function(t) {
        var e, i;
        return this._filterFindCellElements(t).map((function(t) {
            return new o(t,this)
        }
        ), this)
    }
    ,
    f.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }
    ,
    f.getLastSlide = function() {
        return this.slides[this.slides.length - 1]
    }
    ,
    f.positionCells = function() {
        this._sizeCells(this.cells),
        this._positionCells(0)
    }
    ,
    f._positionCells = function(t) {
        t = t || 0,
        this.maxCellHeight = t && this.maxCellHeight || 0;
        var e = 0;
        if (t > 0) {
            var i = this.cells[t - 1];
            e = i.x + i.size.outerWidth
        }
        for (var n = this.cells.length, o = t; o < n; o++) {
            var a = this.cells[o];
            a.setPosition(e),
            e += a.size.outerWidth,
            this.maxCellHeight = Math.max(a.size.outerHeight, this.maxCellHeight)
        }
        this.slideableWidth = e,
        this.updateSlides(),
        this._containSlides(),
        this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0
    }
    ,
    f._sizeCells = function(t) {
        t.forEach((function(t) {
            t.getSize()
        }
        ))
    }
    ,
    f.updateSlides = function() {
        if (this.slides = [],
        this.cells.length) {
            var t = new a(this);
            this.slides.push(t);
            var e, i = "left" == this.originSide ? "marginRight" : "marginLeft", n = this._getCanCellFit();
            this.cells.forEach((function(e, o) {
                if (t.cells.length) {
                    var s = t.outerWidth - t.firstMargin + (e.size.outerWidth - e.size[i]);
                    n.call(this, o, s) || (t.updateTarget(),
                    t = new a(this),
                    this.slides.push(t)),
                    t.addCell(e)
                } else
                    t.addCell(e)
            }
            ), this),
            t.updateTarget(),
            this.updateSelectedSlide()
        }
    }
    ,
    f._getCanCellFit = function() {
        var t = this.options.groupCells;
        if (!t)
            return function() {
                return !1
            }
            ;
        if ("number" == typeof t) {
            var e = parseInt(t, 10);
            return function(t) {
                return t % e != 0
            }
        }
        var i = "string" == typeof t && t.match(/^(\d+)%$/)
          , n = i ? parseInt(i[1], 10) / 100 : 1;
        return function(t, e) {
            return e <= (this.size.innerWidth + 1) * n
        }
    }
    ,
    f._init = f.reposition = function() {
        this.positionCells(),
        this.positionSliderAtSelected()
    }
    ,
    f.getSize = function() {
        this.size = i(this.element),
        this.setCellAlign(),
        this.cursorPosition = this.size.innerWidth * this.cellAlign
    }
    ;
    var m = {
        center: {
            left: .5,
            right: .5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    return f.setCellAlign = function() {
        var t = m[this.options.cellAlign];
        this.cellAlign = t ? t[this.originSide] : this.options.cellAlign
    }
    ,
    f.setGallerySize = function() {
        if (this.options.setGallerySize) {
            var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = t + "px"
        }
    }
    ,
    f._getWrapShiftCells = function() {
        if (this.options.wrapAround) {
            this._unshiftCells(this.beforeShiftCells),
            this._unshiftCells(this.afterShiftCells);
            var t = this.cursorPosition
              , e = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(t, e, -1),
            t = this.size.innerWidth - this.cursorPosition,
            this.afterShiftCells = this._getGapCells(t, 0, 1)
        }
    }
    ,
    f._getGapCells = function(t, e, i) {
        for (var n = []; t > 0; ) {
            var o = this.cells[e];
            if (!o)
                break;
            n.push(o),
            e += i,
            t -= o.size.outerWidth
        }
        return n
    }
    ,
    f._containSlides = function() {
        if (this.options.contain && !this.options.wrapAround && this.cells.length) {
            var t = this.options.rightToLeft
              , e = t ? "marginRight" : "marginLeft"
              , i = t ? "marginLeft" : "marginRight"
              , n = this.slideableWidth - this.getLastCell().size[i]
              , o = n < this.size.innerWidth
              , a = this.cursorPosition + this.cells[0].size[e]
              , s = n - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((function(t) {
                o ? t.target = n * this.cellAlign : (t.target = Math.max(t.target, a),
                t.target = Math.min(t.target, s))
            }
            ), this)
        }
    }
    ,
    f.dispatchEvent = function(t, e, i) {
        var n = e ? [e].concat(i) : i;
        if (this.emitEvent(t, n),
        c && this.$element) {
            var o = t += this.options.namespaceJQueryEvents ? ".flickity" : "";
            if (e) {
                var a = c.Event(e);
                a.type = t,
                o = a
            }
            this.$element.trigger(o, i)
        }
    }
    ,
    f.select = function(t, e, i) {
        if (this.isActive && (t = parseInt(t, 10),
        this._wrapSelect(t),
        (this.options.wrapAround || e) && (t = n.modulo(t, this.slides.length)),
        this.slides[t])) {
            var o = this.selectedIndex;
            this.selectedIndex = t,
            this.updateSelectedSlide(),
            i ? this.positionSliderAtSelected() : this.startAnimation(),
            this.options.adaptiveHeight && this.setGallerySize(),
            this.dispatchEvent("select", null, [t]),
            t != o && this.dispatchEvent("change", null, [t]),
            this.dispatchEvent("cellSelect")
        }
    }
    ,
    f._wrapSelect = function(t) {
        var e = this.slides.length, i;
        if (!(this.options.wrapAround && e > 1))
            return t;
        var o = n.modulo(t, e)
          , a = Math.abs(o - this.selectedIndex)
          , s = Math.abs(o + e - this.selectedIndex)
          , r = Math.abs(o - e - this.selectedIndex);
        !this.isDragSelect && s < a ? t += e : !this.isDragSelect && r < a && (t -= e),
        t < 0 ? this.x -= this.slideableWidth : t >= e && (this.x += this.slideableWidth)
    }
    ,
    f.previous = function(t, e) {
        this.select(this.selectedIndex - 1, t, e)
    }
    ,
    f.next = function(t, e) {
        this.select(this.selectedIndex + 1, t, e)
    }
    ,
    f.updateSelectedSlide = function() {
        var t = this.slides[this.selectedIndex];
        t && (this.unselectSelectedSlide(),
        this.selectedSlide = t,
        t.select(),
        this.selectedCells = t.cells,
        this.selectedElements = t.getCellElements(),
        this.selectedCell = t.cells[0],
        this.selectedElement = this.selectedElements[0])
    }
    ,
    f.unselectSelectedSlide = function() {
        this.selectedSlide && this.selectedSlide.unselect()
    }
    ,
    f.selectCell = function(t, e, i) {
        var n = this.queryCell(t);
        if (n) {
            var o = this.getCellSlideIndex(n);
            this.select(o, e, i)
        }
    }
    ,
    f.getCellSlideIndex = function(t) {
        for (var e = 0; e < this.slides.length; e++) {
            var i, n;
            if (-1 != this.slides[e].cells.indexOf(t))
                return e
        }
    }
    ,
    f.getCell = function(t) {
        for (var e = 0; e < this.cells.length; e++) {
            var i = this.cells[e];
            if (i.element == t)
                return i
        }
    }
    ,
    f.getCells = function(t) {
        t = n.makeArray(t);
        var e = [];
        return t.forEach((function(t) {
            var i = this.getCell(t);
            i && e.push(i)
        }
        ), this),
        e
    }
    ,
    f.getCellElements = function() {
        return this.cells.map((function(t) {
            return t.element
        }
        ))
    }
    ,
    f.getParentCell = function(t) {
        var e = this.getCell(t);
        return e || (t = n.getParent(t, ".flickity-slider > *"),
        this.getCell(t))
    }
    ,
    f.getAdjacentCellElements = function(t, e) {
        if (!t)
            return this.selectedSlide.getCellElements();
        e = void 0 === e ? this.selectedIndex : e;
        var i = this.slides.length;
        if (1 + 2 * t >= i)
            return this.getCellElements();
        for (var o = [], a = e - t; a <= e + t; a++) {
            var s = this.options.wrapAround ? n.modulo(a, i) : a
              , r = this.slides[s];
            r && (o = o.concat(r.getCellElements()))
        }
        return o
    }
    ,
    f.queryCell = function(t) {
        return "number" == typeof t ? this.cells[t] : ("string" == typeof t && (t = this.element.querySelector(t)),
        this.getCell(t))
    }
    ,
    f.uiChange = function() {
        this.emitEvent("uiChange")
    }
    ,
    f.childUIPointerDown = function(t) {
        this.emitEvent("childUIPointerDown", [t])
    }
    ,
    f.onresize = function() {
        this.watchCSS(),
        this.resize()
    }
    ,
    n.debounceMethod(l, "onresize", 150),
    f.resize = function() {
        if (this.isActive) {
            this.getSize(),
            this.options.wrapAround && (this.x = n.modulo(this.x, this.slideableWidth)),
            this.positionCells(),
            this._getWrapShiftCells(),
            this.setGallerySize(),
            this.emitEvent("resize");
            var t = this.selectedElements && this.selectedElements[0];
            this.selectCell(t, !1, !0)
        }
    }
    ,
    f.watchCSS = function() {
        var t;
        var e;
        this.options.watchCSS && (-1 != d(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate())
    }
    ,
    f.onkeydown = function(t) {
        var e = document.activeElement && document.activeElement != this.element;
        if (this.options.accessibility && !e) {
            var i = l.keyboardHandlers[t.keyCode];
            i && i.call(this)
        }
    }
    ,
    l.keyboardHandlers = {
        37: function() {
            var t = this.options.rightToLeft ? "next" : "previous";
            this.uiChange(),
            this[t]()
        },
        39: function() {
            var t = this.options.rightToLeft ? "previous" : "next";
            this.uiChange(),
            this[t]()
        }
    },
    f.focus = function() {
        var e = t.pageYOffset;
        this.element.focus({
            preventScroll: !0
        }),
        t.pageYOffset != e && t.scrollTo(t.pageXOffset, e)
    }
    ,
    f.deactivate = function() {
        this.isActive && (this.element.classList.remove("flickity-enabled"),
        this.element.classList.remove("flickity-rtl"),
        this.unselectSelectedSlide(),
        this.cells.forEach((function(t) {
            t.destroy()
        }
        )),
        this.element.removeChild(this.viewport),
        r(this.slider.children, this.element),
        this.options.accessibility && (this.element.removeAttribute("tabIndex"),
        this.element.removeEventListener("keydown", this)),
        this.isActive = !1,
        this.emitEvent("deactivate"))
    }
    ,
    f.destroy = function() {
        this.deactivate(),
        t.removeEventListener("resize", this),
        this.emitEvent("destroy"),
        c && this.$element && c.removeData(this.element, "flickity"),
        delete this.element.flickityGUID,
        delete h[this.guid]
    }
    ,
    n.extend(f, s),
    l.data = function(t) {
        var e = (t = n.getQueryElement(t)) && t.flickityGUID;
        return e && h[e]
    }
    ,
    n.htmlInit(l, "flickity"),
    c && c.bridget && c.bridget("flickity", l),
    l.setJQuery = function(t) {
        c = t
    }
    ,
    l.Cell = o,
    l
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], (function(i) {
        return e(t, i)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter")) : t.Unipointer = e(t, t.EvEmitter)
}(window, (function(t, e) {
    function i() {}
    function n() {}
    var o = n.prototype = Object.create(e.prototype);
    o.bindStartEvent = function(t) {
        this._bindStartEvent(t, !0)
    }
    ,
    o.unbindStartEvent = function(t) {
        this._bindStartEvent(t, !1)
    }
    ,
    o._bindStartEvent = function(e, i) {
        var n = (i = void 0 === i || i) ? "addEventListener" : "removeEventListener"
          , o = "mousedown";
        t.PointerEvent ? o = "pointerdown" : "ontouchstart"in t && (o = "touchstart"),
        e[n](o, this)
    }
    ,
    o.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    o.getTouch = function(t) {
        for (var e = 0; e < t.length; e++) {
            var i = t[e];
            if (i.identifier == this.pointerIdentifier)
                return i
        }
    }
    ,
    o.onmousedown = function(t) {
        var e = t.button;
        e && 0 !== e && 1 !== e || this._pointerDown(t, t)
    }
    ,
    o.ontouchstart = function(t) {
        this._pointerDown(t, t.changedTouches[0])
    }
    ,
    o.onpointerdown = function(t) {
        this._pointerDown(t, t)
    }
    ,
    o._pointerDown = function(t, e) {
        t.button || this.isPointerDown || (this.isPointerDown = !0,
        this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier,
        this.pointerDown(t, e))
    }
    ,
    o.pointerDown = function(t, e) {
        this._bindPostStartEvents(t),
        this.emitEvent("pointerDown", [t, e])
    }
    ;
    var a = {
        mousedown: ["mousemove", "mouseup"],
        touchstart: ["touchmove", "touchend", "touchcancel"],
        pointerdown: ["pointermove", "pointerup", "pointercancel"]
    };
    return o._bindPostStartEvents = function(e) {
        if (e) {
            var i = a[e.type];
            i.forEach((function(e) {
                t.addEventListener(e, this)
            }
            ), this),
            this._boundPointerEvents = i
        }
    }
    ,
    o._unbindPostStartEvents = function() {
        this._boundPointerEvents && (this._boundPointerEvents.forEach((function(e) {
            t.removeEventListener(e, this)
        }
        ), this),
        delete this._boundPointerEvents)
    }
    ,
    o.onmousemove = function(t) {
        this._pointerMove(t, t)
    }
    ,
    o.onpointermove = function(t) {
        t.pointerId == this.pointerIdentifier && this._pointerMove(t, t)
    }
    ,
    o.ontouchmove = function(t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerMove(t, e)
    }
    ,
    o._pointerMove = function(t, e) {
        this.pointerMove(t, e)
    }
    ,
    o.pointerMove = function(t, e) {
        this.emitEvent("pointerMove", [t, e])
    }
    ,
    o.onmouseup = function(t) {
        this._pointerUp(t, t)
    }
    ,
    o.onpointerup = function(t) {
        t.pointerId == this.pointerIdentifier && this._pointerUp(t, t)
    }
    ,
    o.ontouchend = function(t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerUp(t, e)
    }
    ,
    o._pointerUp = function(t, e) {
        this._pointerDone(),
        this.pointerUp(t, e)
    }
    ,
    o.pointerUp = function(t, e) {
        this.emitEvent("pointerUp", [t, e])
    }
    ,
    o._pointerDone = function() {
        this._pointerReset(),
        this._unbindPostStartEvents(),
        this.pointerDone()
    }
    ,
    o._pointerReset = function() {
        this.isPointerDown = !1,
        delete this.pointerIdentifier
    }
    ,
    o.pointerDone = i,
    o.onpointercancel = function(t) {
        t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t)
    }
    ,
    o.ontouchcancel = function(t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerCancel(t, e)
    }
    ,
    o._pointerCancel = function(t, e) {
        this._pointerDone(),
        this.pointerCancel(t, e)
    }
    ,
    o.pointerCancel = function(t, e) {
        this.emitEvent("pointerCancel", [t, e])
    }
    ,
    n.getPointerPoint = function(t) {
        return {
            x: t.pageX,
            y: t.pageY
        }
    }
    ,
    n
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], (function(i) {
        return e(t, i)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("unipointer")) : t.Unidragger = e(t, t.Unipointer)
}(window, (function(t, e) {
    function i() {}
    var n = i.prototype = Object.create(e.prototype);
    n.bindHandles = function() {
        this._bindHandles(!0)
    }
    ,
    n.unbindHandles = function() {
        this._bindHandles(!1)
    }
    ,
    n._bindHandles = function(e) {
        for (var i = (e = void 0 === e || e) ? "addEventListener" : "removeEventListener", n = e ? this._touchActionValue : "", o = 0; o < this.handles.length; o++) {
            var a = this.handles[o];
            this._bindStartEvent(a, e),
            a[i]("click", this),
            t.PointerEvent && (a.style.touchAction = n)
        }
    }
    ,
    n._touchActionValue = "none",
    n.pointerDown = function(t, e) {
        var i;
        this.okayPointerDown(t) && (this.pointerDownPointer = e,
        t.preventDefault(),
        this.pointerDownBlur(),
        this._bindPostStartEvents(t),
        this.emitEvent("pointerDown", [t, e]))
    }
    ;
    var o = {
        TEXTAREA: !0,
        INPUT: !0,
        SELECT: !0,
        OPTION: !0
    }
      , a = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0
    };
    return n.okayPointerDown = function(t) {
        var e = o[t.target.nodeName]
          , i = a[t.target.type]
          , n = !e || i;
        return n || this._pointerReset(),
        n
    }
    ,
    n.pointerDownBlur = function() {
        var t = document.activeElement, e;
        t && t.blur && t != document.body && t.blur()
    }
    ,
    n.pointerMove = function(t, e) {
        var i = this._dragPointerMove(t, e);
        this.emitEvent("pointerMove", [t, e, i]),
        this._dragMove(t, e, i)
    }
    ,
    n._dragPointerMove = function(t, e) {
        var i = {
            x: e.pageX - this.pointerDownPointer.pageX,
            y: e.pageY - this.pointerDownPointer.pageY
        };
        return !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e),
        i
    }
    ,
    n.hasDragStarted = function(t) {
        return Math.abs(t.x) > 3 || Math.abs(t.y) > 3
    }
    ,
    n.pointerUp = function(t, e) {
        this.emitEvent("pointerUp", [t, e]),
        this._dragPointerUp(t, e)
    }
    ,
    n._dragPointerUp = function(t, e) {
        this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e)
    }
    ,
    n._dragStart = function(t, e) {
        this.isDragging = !0,
        this.isPreventingClicks = !0,
        this.dragStart(t, e)
    }
    ,
    n.dragStart = function(t, e) {
        this.emitEvent("dragStart", [t, e])
    }
    ,
    n._dragMove = function(t, e, i) {
        this.isDragging && this.dragMove(t, e, i)
    }
    ,
    n.dragMove = function(t, e, i) {
        t.preventDefault(),
        this.emitEvent("dragMove", [t, e, i])
    }
    ,
    n._dragEnd = function(t, e) {
        this.isDragging = !1,
        setTimeout(function() {
            delete this.isPreventingClicks
        }
        .bind(this)),
        this.dragEnd(t, e)
    }
    ,
    n.dragEnd = function(t, e) {
        this.emitEvent("dragEnd", [t, e])
    }
    ,
    n.onclick = function(t) {
        this.isPreventingClicks && t.preventDefault()
    }
    ,
    n._staticClick = function(t, e) {
        this.isIgnoringMouseUp && "mouseup" == t.type || (this.staticClick(t, e),
        "mouseup" != t.type && (this.isIgnoringMouseUp = !0,
        setTimeout(function() {
            delete this.isIgnoringMouseUp
        }
        .bind(this), 400)))
    }
    ,
    n.staticClick = function(t, e) {
        this.emitEvent("staticClick", [t, e])
    }
    ,
    i.getPointerPoint = e.getPointerPoint,
    i
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], (function(i, n, o) {
        return e(t, i, n, o)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : t.Flickity = e(t, t.Flickity, t.Unidragger, t.fizzyUIUtils)
}(window, (function(t, e, i, n) {
    function o() {
        return {
            x: t.pageXOffset,
            y: t.pageYOffset
        }
    }
    n.extend(e.defaults, {
        draggable: ">1",
        dragThreshold: 3
    }),
    e.createMethods.push("_createDrag");
    var a = e.prototype;
    n.extend(a, i.prototype),
    a._touchActionValue = "pan-y";
    var s = "createTouch"in document
      , r = !1;
    a._createDrag = function() {
        this.on("activate", this.onActivateDrag),
        this.on("uiChange", this._uiChangeDrag),
        this.on("childUIPointerDown", this._childUIPointerDownDrag),
        this.on("deactivate", this.onDeactivateDrag),
        this.on("cellChange", this.updateDraggable),
        s && !r && (t.addEventListener("touchmove", (function() {}
        )),
        r = !0)
    }
    ,
    a.onActivateDrag = function() {
        this.handles = [this.viewport],
        this.bindHandles(),
        this.updateDraggable()
    }
    ,
    a.onDeactivateDrag = function() {
        this.unbindHandles(),
        this.element.classList.remove("is-draggable")
    }
    ,
    a.updateDraggable = function() {
        ">1" == this.options.draggable ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable,
        this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
    }
    ,
    a.bindDrag = function() {
        this.options.draggable = !0,
        this.updateDraggable()
    }
    ,
    a.unbindDrag = function() {
        this.options.draggable = !1,
        this.updateDraggable()
    }
    ,
    a._uiChangeDrag = function() {
        delete this.isFreeScrolling
    }
    ,
    a._childUIPointerDownDrag = function(t) {
        t.preventDefault(),
        this.pointerDownFocus(t)
    }
    ,
    a.pointerDown = function(e, i) {
        var n;
        this.isDraggable ? this.okayPointerDown(e) && (this._pointerDownPreventDefault(e),
        this.pointerDownFocus(e),
        document.activeElement != this.element && this.pointerDownBlur(),
        this.dragX = this.x,
        this.viewport.classList.add("is-pointer-down"),
        this.pointerDownScroll = o(),
        t.addEventListener("scroll", this),
        this._pointerDownDefault(e, i)) : this._pointerDownDefault(e, i)
    }
    ,
    a._pointerDownDefault = function(t, e) {
        this.pointerDownPointer = e,
        this._bindPostStartEvents(t),
        this.dispatchEvent("pointerDown", t, [e])
    }
    ;
    var l = {
        INPUT: !0,
        TEXTAREA: !0,
        SELECT: !0
    };
    return a.pointerDownFocus = function(t) {
        var e;
        l[t.target.nodeName] || this.focus()
    }
    ,
    a._pointerDownPreventDefault = function(t) {
        var e = "touchstart" == t.type
          , i = "touch" == t.pointerType
          , n = l[t.target.nodeName];
        e || i || n || t.preventDefault()
    }
    ,
    a.hasDragStarted = function(t) {
        return Math.abs(t.x) > this.options.dragThreshold
    }
    ,
    a.pointerUp = function(t, e) {
        delete this.isTouchScrolling,
        this.viewport.classList.remove("is-pointer-down"),
        this.dispatchEvent("pointerUp", t, [e]),
        this._dragPointerUp(t, e)
    }
    ,
    a.pointerDone = function() {
        t.removeEventListener("scroll", this),
        delete this.pointerDownScroll
    }
    ,
    a.dragStart = function(e, i) {
        this.isDraggable && (this.dragStartPosition = this.x,
        this.startAnimation(),
        t.removeEventListener("scroll", this),
        this.dispatchEvent("dragStart", e, [i]))
    }
    ,
    a.pointerMove = function(t, e) {
        var i = this._dragPointerMove(t, e);
        this.dispatchEvent("pointerMove", t, [e, i]),
        this._dragMove(t, e, i)
    }
    ,
    a.dragMove = function(t, e, i) {
        if (this.isDraggable) {
            t.preventDefault(),
            this.previousDragX = this.dragX;
            var n = this.options.rightToLeft ? -1 : 1;
            this.options.wrapAround && (i.x = i.x % this.slideableWidth);
            var o = this.dragStartPosition + i.x * n;
            if (!this.options.wrapAround && this.slides.length) {
                var a = Math.max(-this.slides[0].target, this.dragStartPosition);
                o = o > a ? .5 * (o + a) : o;
                var s = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                o = o < s ? .5 * (o + s) : o
            }
            this.dragX = o,
            this.dragMoveTime = new Date,
            this.dispatchEvent("dragMove", t, [e, i])
        }
    }
    ,
    a.dragEnd = function(t, e) {
        if (this.isDraggable) {
            this.options.freeScroll && (this.isFreeScrolling = !0);
            var i = this.dragEndRestingSelect();
            if (this.options.freeScroll && !this.options.wrapAround) {
                var n = this.getRestingPosition();
                this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target
            } else
                this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
            delete this.previousDragX,
            this.isDragSelect = this.options.wrapAround,
            this.select(i),
            delete this.isDragSelect,
            this.dispatchEvent("dragEnd", t, [e])
        }
    }
    ,
    a.dragEndRestingSelect = function() {
        var t = this.getRestingPosition(), e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)), i = this._getClosestResting(t, e, 1), n = this._getClosestResting(t, e, -1), o;
        return i.distance < n.distance ? i.index : n.index
    }
    ,
    a._getClosestResting = function(t, e, i) {
        for (var n = this.selectedIndex, o = 1 / 0, a = this.options.contain && !this.options.wrapAround ? function(t, e) {
            return t <= e
        }
        : function(t, e) {
            return t < e
        }
        ; a(e, o) && (n += i,
        o = e,
        null !== (e = this.getSlideDistance(-t, n))); )
            e = Math.abs(e);
        return {
            distance: o,
            index: n - i
        }
    }
    ,
    a.getSlideDistance = function(t, e) {
        var i = this.slides.length
          , o = this.options.wrapAround && i > 1
          , a = o ? n.modulo(e, i) : e
          , s = this.slides[a];
        if (!s)
            return null;
        var r = o ? this.slideableWidth * Math.floor(e / i) : 0;
        return t - (s.target + r)
    }
    ,
    a.dragEndBoostSelect = function() {
        if (void 0 === this.previousDragX || !this.dragMoveTime || new Date - this.dragMoveTime > 100)
            return 0;
        var t = this.getSlideDistance(-this.dragX, this.selectedIndex)
          , e = this.previousDragX - this.dragX;
        return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0
    }
    ,
    a.staticClick = function(t, e) {
        var i = this.getParentCell(t.target)
          , n = i && i.element
          , o = i && this.cells.indexOf(i);
        this.dispatchEvent("staticClick", t, [e, n, o])
    }
    ,
    a.onscroll = function() {
        var t = o()
          , e = this.pointerDownScroll.x - t.x
          , i = this.pointerDownScroll.y - t.y;
        (Math.abs(e) > 3 || Math.abs(i) > 3) && this._pointerDone()
    }
    ,
    e
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("tap-listener/tap-listener", ["unipointer/unipointer"], (function(i) {
        return e(t, i)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("unipointer")) : t.TapListener = e(t, t.Unipointer)
}(window, (function(t, e) {
    function i(t) {
        this.bindTap(t)
    }
    var n = i.prototype = Object.create(e.prototype);
    return n.bindTap = function(t) {
        t && (this.unbindTap(),
        this.tapElement = t,
        this._bindStartEvent(t, !0))
    }
    ,
    n.unbindTap = function() {
        this.tapElement && (this._bindStartEvent(this.tapElement, !0),
        delete this.tapElement)
    }
    ,
    n.pointerUp = function(i, n) {
        if (!this.isIgnoringMouseUp || "mouseup" != i.type) {
            var o = e.getPointerPoint(n), a = this.tapElement.getBoundingClientRect(), s = t.pageXOffset, r = t.pageYOffset, l;
            if (o.x >= a.left + s && o.x <= a.right + s && o.y >= a.top + r && o.y <= a.bottom + r && this.emitEvent("tap", [i, n]),
            "mouseup" != i.type) {
                this.isIgnoringMouseUp = !0;
                var c = this;
                setTimeout((function() {
                    delete c.isIgnoringMouseUp
                }
                ), 400)
            }
        }
    }
    ,
    n.destroy = function() {
        this.pointerDone(),
        this.unbindTap()
    }
    ,
    i
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], (function(i, n, o) {
        return e(t, i, n, o)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : e(t, t.Flickity, t.TapListener, t.fizzyUIUtils)
}(window, (function(t, e, i, n) {
    "use strict";
    function o(t, e) {
        this.direction = t,
        this.parent = e,
        this._create()
    }
    function a(t) {
        return "string" == typeof t ? t : "M " + t.x0 + ",50 L " + t.x1 + "," + (t.y1 + 50) + " L " + t.x2 + "," + (t.y2 + 50) + " L " + t.x3 + ",50  L " + t.x2 + "," + (50 - t.y2) + " L " + t.x1 + "," + (50 - t.y1) + " Z"
    }
    var s = "http://www.w3.org/2000/svg";
    o.prototype = Object.create(i.prototype),
    o.prototype._create = function() {
        this.isEnabled = !0,
        this.isPrevious = -1 == this.direction;
        var t = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == t;
        var e = this.element = document.createElement("button");
        e.className = "flickity-button flickity-prev-next-button",
        e.className += this.isPrevious ? " previous" : " next",
        e.setAttribute("type", "button"),
        this.disable(),
        e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        var i = this.createSVG();
        e.appendChild(i),
        this.on("tap", this.onTap),
        this.parent.on("select", this.update.bind(this)),
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }
    ,
    o.prototype.activate = function() {
        this.bindTap(this.element),
        this.element.addEventListener("click", this),
        this.parent.element.appendChild(this.element)
    }
    ,
    o.prototype.deactivate = function() {
        this.parent.element.removeChild(this.element),
        i.prototype.destroy.call(this),
        this.element.removeEventListener("click", this)
    }
    ,
    o.prototype.createSVG = function() {
        var t = document.createElementNS(s, "svg");
        t.setAttribute("class", "flickity-button-icon"),
        t.setAttribute("viewBox", "0 0 100 100");
        var e = document.createElementNS(s, "path")
          , i = a(this.parent.options.arrowShape);
        return e.setAttribute("d", i),
        e.setAttribute("class", "arrow"),
        this.isLeft || e.setAttribute("transform", "translate(100, 100) rotate(180) "),
        t.appendChild(e),
        t
    }
    ,
    o.prototype.onTap = function() {
        if (this.isEnabled) {
            this.parent.uiChange();
            var t = this.isPrevious ? "previous" : "next";
            this.parent[t]()
        }
    }
    ,
    o.prototype.handleEvent = n.handleEvent,
    o.prototype.onclick = function(t) {
        var e = document.activeElement;
        e && e == this.element && this.onTap(t, t)
    }
    ,
    o.prototype.enable = function() {
        this.isEnabled || (this.element.disabled = !1,
        this.isEnabled = !0)
    }
    ,
    o.prototype.disable = function() {
        this.isEnabled && (this.element.disabled = !0,
        this.isEnabled = !1)
    }
    ,
    o.prototype.update = function() {
        var t = this.parent.slides;
        if (this.parent.options.wrapAround && t.length > 1)
            this.enable();
        else {
            var e = t.length ? t.length - 1 : 0, i = this.isPrevious ? 0 : e, n;
            this[this.parent.selectedIndex == i ? "disable" : "enable"]()
        }
    }
    ,
    o.prototype.destroy = function() {
        this.deactivate()
    }
    ,
    n.extend(e.defaults, {
        prevNextButtons: !0,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    }),
    e.createMethods.push("_createPrevNextButtons");
    var r = e.prototype;
    return r._createPrevNextButtons = function() {
        this.options.prevNextButtons && (this.prevButton = new o(-1,this),
        this.nextButton = new o(1,this),
        this.on("activate", this.activatePrevNextButtons))
    }
    ,
    r.activatePrevNextButtons = function() {
        this.prevButton.activate(),
        this.nextButton.activate(),
        this.on("deactivate", this.deactivatePrevNextButtons)
    }
    ,
    r.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate(),
        this.nextButton.deactivate(),
        this.off("deactivate", this.deactivatePrevNextButtons)
    }
    ,
    e.PrevNextButton = o,
    e
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/page-dots", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], (function(i, n, o) {
        return e(t, i, n, o)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : e(t, t.Flickity, t.TapListener, t.fizzyUIUtils)
}(window, (function(t, e, i, n) {
    function o(t) {
        this.parent = t,
        this._create()
    }
    o.prototype = new i,
    o.prototype._create = function() {
        this.holder = document.createElement("ol"),
        this.holder.className = "flickity-page-dots",
        this.dots = [],
        this.on("tap", this.onTap),
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }
    ,
    o.prototype.activate = function() {
        this.setDots(),
        this.bindTap(this.holder),
        this.parent.element.appendChild(this.holder)
    }
    ,
    o.prototype.deactivate = function() {
        this.parent.element.removeChild(this.holder),
        i.prototype.destroy.call(this)
    }
    ,
    o.prototype.setDots = function() {
        var t = this.parent.slides.length - this.dots.length;
        t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t)
    }
    ,
    o.prototype.addDots = function(t) {
        for (var e = document.createDocumentFragment(), i = [], n = this.dots.length, o = n + t, a = n; a < o; a++) {
            var s = document.createElement("li");
            s.className = "dot",
            s.setAttribute("aria-label", "Page dot " + (a + 1)),
            e.appendChild(s),
            i.push(s)
        }
        this.holder.appendChild(e),
        this.dots = this.dots.concat(i)
    }
    ,
    o.prototype.removeDots = function(t) {
        var e;
        this.dots.splice(this.dots.length - t, t).forEach((function(t) {
            this.holder.removeChild(t)
        }
        ), this)
    }
    ,
    o.prototype.updateSelected = function() {
        this.selectedDot && (this.selectedDot.className = "dot",
        this.selectedDot.removeAttribute("aria-current")),
        this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex],
        this.selectedDot.className = "dot is-selected",
        this.selectedDot.setAttribute("aria-current", "step"))
    }
    ,
    o.prototype.onTap = function(t) {
        var e = t.target;
        if ("LI" == e.nodeName) {
            this.parent.uiChange();
            var i = this.dots.indexOf(e);
            this.parent.select(i)
        }
    }
    ,
    o.prototype.destroy = function() {
        this.deactivate()
    }
    ,
    e.PageDots = o,
    n.extend(e.defaults, {
        pageDots: !0
    }),
    e.createMethods.push("_createPageDots");
    var a = e.prototype;
    return a._createPageDots = function() {
        this.options.pageDots && (this.pageDots = new o(this),
        this.on("activate", this.activatePageDots),
        this.on("select", this.updateSelectedPageDots),
        this.on("cellChange", this.updatePageDots),
        this.on("resize", this.updatePageDots),
        this.on("deactivate", this.deactivatePageDots))
    }
    ,
    a.activatePageDots = function() {
        this.pageDots.activate()
    }
    ,
    a.updateSelectedPageDots = function() {
        this.pageDots.updateSelected()
    }
    ,
    a.updatePageDots = function() {
        this.pageDots.setDots()
    }
    ,
    a.deactivatePageDots = function() {
        this.pageDots.deactivate()
    }
    ,
    e.PageDots = o,
    e
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], (function(t, i, n) {
        return e(t, i, n)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : e(t.EvEmitter, t.fizzyUIUtils, t.Flickity)
}(window, (function(t, e, i) {
    function n(t) {
        this.parent = t,
        this.state = "stopped",
        this.onVisibilityChange = this.visibilityChange.bind(this),
        this.onVisibilityPlay = this.visibilityPlay.bind(this)
    }
    n.prototype = Object.create(t.prototype),
    n.prototype.play = function() {
        if ("playing" != this.state) {
            var t;
            if (document.hidden)
                return void document.addEventListener("visibilitychange", this.onVisibilityPlay);
            this.state = "playing",
            document.addEventListener("visibilitychange", this.onVisibilityChange),
            this.tick()
        }
    }
    ,
    n.prototype.tick = function() {
        if ("playing" == this.state) {
            var t = this.parent.options.autoPlay;
            t = "number" == typeof t ? t : 3e3;
            var e = this;
            this.clear(),
            this.timeout = setTimeout((function() {
                e.parent.next(!0),
                e.tick()
            }
            ), t)
        }
    }
    ,
    n.prototype.stop = function() {
        this.state = "stopped",
        this.clear(),
        document.removeEventListener("visibilitychange", this.onVisibilityChange)
    }
    ,
    n.prototype.clear = function() {
        clearTimeout(this.timeout)
    }
    ,
    n.prototype.pause = function() {
        "playing" == this.state && (this.state = "paused",
        this.clear())
    }
    ,
    n.prototype.unpause = function() {
        "paused" == this.state && this.play()
    }
    ,
    n.prototype.visibilityChange = function() {
        var t;
        this[document.hidden ? "pause" : "unpause"]()
    }
    ,
    n.prototype.visibilityPlay = function() {
        this.play(),
        document.removeEventListener("visibilitychange", this.onVisibilityPlay)
    }
    ,
    e.extend(i.defaults, {
        pauseAutoPlayOnHover: !0
    }),
    i.createMethods.push("_createPlayer");
    var o = i.prototype;
    return o._createPlayer = function() {
        this.player = new n(this),
        this.on("activate", this.activatePlayer),
        this.on("uiChange", this.stopPlayer),
        this.on("pointerDown", this.stopPlayer),
        this.on("deactivate", this.deactivatePlayer)
    }
    ,
    o.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(),
        this.element.addEventListener("mouseenter", this))
    }
    ,
    o.playPlayer = function() {
        this.player.play()
    }
    ,
    o.stopPlayer = function() {
        this.player.stop()
    }
    ,
    o.pausePlayer = function() {
        this.player.pause()
    }
    ,
    o.unpausePlayer = function() {
        this.player.unpause()
    }
    ,
    o.deactivatePlayer = function() {
        this.player.stop(),
        this.element.removeEventListener("mouseenter", this)
    }
    ,
    o.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(),
        this.element.addEventListener("mouseleave", this))
    }
    ,
    o.onmouseleave = function() {
        this.player.unpause(),
        this.element.removeEventListener("mouseleave", this)
    }
    ,
    i.Player = n,
    i
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], (function(i, n) {
        return e(t, i, n)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("fizzy-ui-utils")) : e(t, t.Flickity, t.fizzyUIUtils)
}(window, (function(t, e, i) {
    function n(t) {
        var e = document.createDocumentFragment();
        return t.forEach((function(t) {
            e.appendChild(t.element)
        }
        )),
        e
    }
    var o = e.prototype;
    return o.insert = function(t, e) {
        var i = this._makeCells(t);
        if (i && i.length) {
            var o = this.cells.length;
            e = void 0 === e ? o : e;
            var a = n(i)
              , s = e == o;
            if (s)
                this.slider.appendChild(a);
            else {
                var r = this.cells[e].element;
                this.slider.insertBefore(a, r)
            }
            if (0 === e)
                this.cells = i.concat(this.cells);
            else if (s)
                this.cells = this.cells.concat(i);
            else {
                var l = this.cells.splice(e, o - e);
                this.cells = this.cells.concat(i).concat(l)
            }
            this._sizeCells(i),
            this.cellChange(e, !0)
        }
    }
    ,
    o.append = function(t) {
        this.insert(t, this.cells.length)
    }
    ,
    o.prepend = function(t) {
        this.insert(t, 0)
    }
    ,
    o.remove = function(t) {
        var e = this.getCells(t);
        if (e && e.length) {
            var n = this.cells.length - 1;
            e.forEach((function(t) {
                t.remove();
                var e = this.cells.indexOf(t);
                n = Math.min(e, n),
                i.removeFrom(this.cells, t)
            }
            ), this),
            this.cellChange(n, !0)
        }
    }
    ,
    o.cellSizeChange = function(t) {
        var e = this.getCell(t);
        if (e) {
            e.getSize();
            var i = this.cells.indexOf(e);
            this.cellChange(i)
        }
    }
    ,
    o.cellChange = function(t, e) {
        var i = this.selectedElement;
        this._positionCells(t),
        this._getWrapShiftCells(),
        this.setGallerySize();
        var n = this.getCell(i);
        n && (this.selectedIndex = this.getCellSlideIndex(n)),
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex),
        this.emitEvent("cellChange", [t]),
        this.select(this.selectedIndex),
        e && this.positionSliderAtSelected()
    }
    ,
    e
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], (function(i, n) {
        return e(t, i, n)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("fizzy-ui-utils")) : e(t, t.Flickity, t.fizzyUIUtils)
}(window, (function(t, e, i) {
    "use strict";
    function n(t) {
        if ("IMG" == t.nodeName) {
            var e = t.getAttribute("data-flickity-lazyload")
              , n = t.getAttribute("data-flickity-lazyload-src")
              , o = t.getAttribute("data-flickity-lazyload-srcset");
            if (e || n || o)
                return [t]
        }
        var a = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]"
          , s = t.querySelectorAll(a);
        return i.makeArray(s)
    }
    function o(t, e) {
        this.img = t,
        this.flickity = e,
        this.load()
    }
    e.createMethods.push("_createLazyload");
    var a = e.prototype;
    return a._createLazyload = function() {
        this.on("select", this.lazyLoad)
    }
    ,
    a.lazyLoad = function() {
        var t = this.options.lazyLoad;
        if (t) {
            var e = "number" == typeof t ? t : 0
              , i = this.getAdjacentCellElements(e)
              , a = [];
            i.forEach((function(t) {
                var e = n(t);
                a = a.concat(e)
            }
            )),
            a.forEach((function(t) {
                new o(t,this)
            }
            ), this)
        }
    }
    ,
    o.prototype.handleEvent = i.handleEvent,
    o.prototype.load = function() {
        this.img.addEventListener("load", this),
        this.img.addEventListener("error", this);
        var t = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src")
          , e = this.img.getAttribute("data-flickity-lazyload-srcset");
        this.img.src = t,
        e && this.img.setAttribute("srcset", e),
        this.img.removeAttribute("data-flickity-lazyload"),
        this.img.removeAttribute("data-flickity-lazyload-src"),
        this.img.removeAttribute("data-flickity-lazyload-srcset")
    }
    ,
    o.prototype.onload = function(t) {
        this.complete(t, "flickity-lazyloaded")
    }
    ,
    o.prototype.onerror = function(t) {
        this.complete(t, "flickity-lazyerror")
    }
    ,
    o.prototype.complete = function(t, e) {
        this.img.removeEventListener("load", this),
        this.img.removeEventListener("error", this);
        var i = this.flickity.getParentCell(this.img)
          , n = i && i.element;
        this.flickity.cellSizeChange(n),
        this.img.classList.add(e),
        this.flickity.dispatchEvent("lazyLoad", t, n)
    }
    ,
    e.LazyLoader = o,
    e
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], e) : "object" == typeof module && module.exports && (module.exports = e(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
}(window, (function(t) {
    return t
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], e) : "object" == typeof module && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : t.Flickity = e(t.Flickity, t.fizzyUIUtils)
}(window, (function(t, e) {
    function i(t, e, i) {
        return (e - t) * i + t
    }
    t.createMethods.push("_createAsNavFor");
    var n = t.prototype;
    return n._createAsNavFor = function() {
        this.on("activate", this.activateAsNavFor),
        this.on("deactivate", this.deactivateAsNavFor),
        this.on("destroy", this.destroyAsNavFor);
        var t = this.options.asNavFor;
        if (t) {
            var e = this;
            setTimeout((function() {
                e.setNavCompanion(t)
            }
            ))
        }
    }
    ,
    n.setNavCompanion = function(i) {
        i = e.getQueryElement(i);
        var n = t.data(i);
        if (n && n != this) {
            this.navCompanion = n;
            var o = this;
            this.onNavCompanionSelect = function() {
                o.navCompanionSelect()
            }
            ,
            n.on("select", this.onNavCompanionSelect),
            this.on("staticClick", this.onNavStaticClick),
            this.navCompanionSelect(!0)
        }
    }
    ,
    n.navCompanionSelect = function(t) {
        if (this.navCompanion) {
            var e = this.navCompanion.selectedCells[0]
              , n = this.navCompanion.cells.indexOf(e)
              , o = n + this.navCompanion.selectedCells.length - 1
              , a = Math.floor(i(n, o, this.navCompanion.cellAlign));
            if (this.selectCell(a, !1, t),
            this.removeNavSelectedElements(),
            !(a >= this.cells.length)) {
                var s = this.cells.slice(n, o + 1);
                this.navSelectedElements = s.map((function(t) {
                    return t.element
                }
                )),
                this.changeNavSelectedClass("add")
            }
        }
    }
    ,
    n.changeNavSelectedClass = function(t) {
        this.navSelectedElements.forEach((function(e) {
            e.classList[t]("is-nav-selected")
        }
        ))
    }
    ,
    n.activateAsNavFor = function() {
        this.navCompanionSelect(!0)
    }
    ,
    n.removeNavSelectedElements = function() {
        this.navSelectedElements && (this.changeNavSelectedClass("remove"),
        delete this.navSelectedElements)
    }
    ,
    n.onNavStaticClick = function(t, e, i, n) {
        "number" == typeof n && this.navCompanion.selectCell(n)
    }
    ,
    n.deactivateAsNavFor = function() {
        this.removeNavSelectedElements()
    }
    ,
    n.destroyAsNavFor = function() {
        this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect),
        this.off("staticClick", this.onNavStaticClick),
        delete this.navCompanion)
    }
    ,
    t
}
)),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], (function(i) {
        return e(t, i)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter")) : t.imagesLoaded = e(t, t.EvEmitter)
}("undefined" != typeof window ? window : this, (function(t, e) {
    function i(t, e) {
        for (var i in e)
            t[i] = e[i];
        return t
    }
    function n(t) {
        return Array.isArray(t) ? t : "object" == typeof t && "number" == typeof t.length ? c.call(t) : [t];
        var e
    }
    function o(t, e, a) {
        if (!(this instanceof o))
            return new o(t,e,a);
        var s = t;
        return "string" == typeof t && (s = document.querySelectorAll(t)),
        s ? (this.elements = n(s),
        this.options = i({}, this.options),
        "function" == typeof e ? a = e : i(this.options, e),
        a && this.on("always", a),
        this.getImages(),
        r && (this.jqDeferred = new r.Deferred),
        void setTimeout(this.check.bind(this))) : void l.error("Bad element for imagesLoaded " + (s || t))
    }
    function a(t) {
        this.img = t
    }
    function s(t, e) {
        this.url = t,
        this.element = e,
        this.img = new Image
    }
    var r = t.jQuery
      , l = t.console
      , c = Array.prototype.slice;
    o.prototype = Object.create(e.prototype),
    o.prototype.options = {},
    o.prototype.getImages = function() {
        this.images = [],
        this.elements.forEach(this.addElementImages, this)
    }
    ,
    o.prototype.addElementImages = function(t) {
        "IMG" == t.nodeName && this.addImage(t),
        !0 === this.options.background && this.addElementBackgroundImages(t);
        var e = t.nodeType;
        if (e && d[e]) {
            for (var i = t.querySelectorAll("img"), n = 0; n < i.length; n++) {
                var o = i[n];
                this.addImage(o)
            }
            if ("string" == typeof this.options.background) {
                var a = t.querySelectorAll(this.options.background);
                for (n = 0; n < a.length; n++) {
                    var s = a[n];
                    this.addElementBackgroundImages(s)
                }
            }
        }
    }
    ;
    var d = {
        1: !0,
        9: !0,
        11: !0
    };
    return o.prototype.addElementBackgroundImages = function(t) {
        var e = getComputedStyle(t);
        if (e)
            for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(e.backgroundImage); null !== n; ) {
                var o = n && n[2];
                o && this.addBackground(o, t),
                n = i.exec(e.backgroundImage)
            }
    }
    ,
    o.prototype.addImage = function(t) {
        var e = new a(t);
        this.images.push(e)
    }
    ,
    o.prototype.addBackground = function(t, e) {
        var i = new s(t,e);
        this.images.push(i)
    }
    ,
    o.prototype.check = function() {
        function t(t, i, n) {
            setTimeout((function() {
                e.progress(t, i, n)
            }
            ))
        }
        var e = this;
        return this.progressedCount = 0,
        this.hasAnyBroken = !1,
        this.images.length ? void this.images.forEach((function(e) {
            e.once("progress", t),
            e.check()
        }
        )) : void this.complete()
    }
    ,
    o.prototype.progress = function(t, e, i) {
        this.progressedCount++,
        this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded,
        this.emitEvent("progress", [this, t, e]),
        this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t),
        this.progressedCount == this.images.length && this.complete(),
        this.options.debug && l && l.log("progress: " + i, t, e)
    }
    ,
    o.prototype.complete = function() {
        var t = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0,
        this.emitEvent(t, [this]),
        this.emitEvent("always", [this]),
        this.jqDeferred) {
            var e = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[e](this)
        }
    }
    ,
    a.prototype = Object.create(e.prototype),
    a.prototype.check = function() {
        var t;
        return this.getIsImageComplete() ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image,
        this.proxyImage.addEventListener("load", this),
        this.proxyImage.addEventListener("error", this),
        this.img.addEventListener("load", this),
        this.img.addEventListener("error", this),
        void (this.proxyImage.src = this.img.src))
    }
    ,
    a.prototype.getIsImageComplete = function() {
        return this.img.complete && this.img.naturalWidth
    }
    ,
    a.prototype.confirm = function(t, e) {
        this.isLoaded = t,
        this.emitEvent("progress", [this, this.img, e])
    }
    ,
    a.prototype.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    a.prototype.onload = function() {
        this.confirm(!0, "onload"),
        this.unbindEvents()
    }
    ,
    a.prototype.onerror = function() {
        this.confirm(!1, "onerror"),
        this.unbindEvents()
    }
    ,
    a.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this),
        this.proxyImage.removeEventListener("error", this),
        this.img.removeEventListener("load", this),
        this.img.removeEventListener("error", this)
    }
    ,
    s.prototype = Object.create(a.prototype),
    s.prototype.check = function() {
        var t;
        this.img.addEventListener("load", this),
        this.img.addEventListener("error", this),
        this.img.src = this.url,
        this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
        this.unbindEvents())
    }
    ,
    s.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this),
        this.img.removeEventListener("error", this)
    }
    ,
    s.prototype.confirm = function(t, e) {
        this.isLoaded = t,
        this.emitEvent("progress", [this, this.element, e])
    }
    ,
    o.makeJQueryPlugin = function(e) {
        (e = e || t.jQuery) && ((r = e).fn.imagesLoaded = function(t, e) {
            var i;
            return new o(this,t,e).jqDeferred.promise(r(this))
        }
        )
    }
    ,
    o.makeJQueryPlugin(),
    o
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], (function(i, n) {
        return e(t, i, n)
    }
    )) : "object" == typeof module && module.exports ? module.exports = e(t, require("flickity"), require("imagesloaded")) : t.Flickity = e(t, t.Flickity, t.imagesLoaded)
}(window, (function(t, e, i) {
    "use strict";
    e.createMethods.push("_createImagesLoaded");
    var n = e.prototype;
    return n._createImagesLoaded = function() {
        this.on("activate", this.imagesLoaded)
    }
    ,
    n.imagesLoaded = function() {
        function t(t, i) {
            var n = e.getParentCell(i.img);
            e.cellSizeChange(n && n.element),
            e.options.freeScroll || e.positionSliderAtSelected()
        }
        if (this.options.imagesLoaded) {
            var e = this;
            i(this.slider).on("progress", t)
        }
    }
    ,
    e
}
));
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
!function(t, e, i) {
    function n(t, e) {
        return typeof t === e
    }
    function o() {
        var t, e, i, o, a, s, r;
        for (var l in d)
            if (d.hasOwnProperty(l)) {
                if (t = [],
                (e = d[l]).name && (t.push(e.name.toLowerCase()),
                e.options && e.options.aliases && e.options.aliases.length))
                    for (i = 0; i < e.options.aliases.length; i++)
                        t.push(e.options.aliases[i].toLowerCase());
                for (o = n(e.fn, "function") ? e.fn() : e.fn,
                a = 0; a < t.length; a++)
                    1 === (r = (s = t[a]).split(".")).length ? p[r[0]] = o : (!p[r[0]] || p[r[0]]instanceof Boolean || (p[r[0]] = new Boolean(p[r[0]])),
                    p[r[0]][r[1]] = o),
                    c.push((o ? "" : "no-") + r.join("-"))
            }
    }
    function a(t) {
        var e = h.className
          , i = p._config.classPrefix || "";
        if (f && (e = e.baseVal),
        p._config.enableJSClass) {
            var n = new RegExp("(^|\\s)" + i + "no-js(\\s|$)");
            e = e.replace(n, "$1" + i + "js$2")
        }
        p._config.enableClasses && (e += " " + i + t.join(" " + i),
        f ? h.className.baseVal = e : h.className = e)
    }
    function s() {
        return "function" != typeof e.createElement ? e.createElement(arguments[0]) : f ? e.createElementNS.call(e, "http://www.w3.org/2000/svg", arguments[0]) : e.createElement.apply(e, arguments)
    }
    function r() {
        var t = e.body;
        return t || ((t = s(f ? "svg" : "body")).fake = !0),
        t
    }
    function l(t, i, n, o) {
        var a, l, c, d, u = "modernizr", p = s("div"), f = r();
        if (parseInt(n, 10))
            for (; n--; )
                (c = s("div")).id = o ? o[n] : u + (n + 1),
                p.appendChild(c);
        return (a = s("style")).type = "text/css",
        a.id = "s" + u,
        (f.fake ? f : p).appendChild(a),
        f.appendChild(p),
        a.styleSheet ? a.styleSheet.cssText = t : a.appendChild(e.createTextNode(t)),
        p.id = u,
        f.fake && (f.style.background = "",
        f.style.overflow = "hidden",
        d = h.style.overflow,
        h.style.overflow = "hidden",
        h.appendChild(f)),
        l = i(p, t),
        f.fake ? (f.parentNode.removeChild(f),
        h.style.overflow = d,
        h.offsetHeight) : p.parentNode.removeChild(p),
        !!l
    }
    var c = []
      , d = []
      , u = {
        _version: "3.3.1",
        _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(t, e) {
            var i = this;
            setTimeout((function() {
                e(i[t])
            }
            ), 0)
        },
        addTest: function(t, e, i) {
            d.push({
                name: t,
                fn: e,
                options: i
            })
        },
        addAsyncTest: function(t) {
            d.push({
                name: null,
                fn: t
            })
        }
    }
      , p = function() {};
    p.prototype = u,
    p = new p;
    var h = e.documentElement
      , f = "svg" === h.nodeName.toLowerCase()
      , m = u._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    u._prefixes = m;
    var g = u.testStyles = l;
    p.addTest("touchevents", (function() {
        var i;
        if ("ontouchstart"in t || t.DocumentTouch && e instanceof DocumentTouch)
            i = !0;
        else {
            var n = ["@media (", m.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            g(n, (function(t) {
                i = 9 === t.offsetTop
            }
            ))
        }
        return i
    }
    )),
    o(),
    a(c),
    delete u.addTest,
    delete u.addAsyncTest;
    for (var y = 0; y < p._q.length; y++)
        p._q[y]();
    t.Modernizr = p
}(window, document),
function(t, e) {
    "function" == typeof define && define.amd ? define([], (function() {
        return e()
    }
    )) : "object" == typeof exports ? module.exports = e() : t.Headhesive = e()
}(this, (function() {
    "use strict";
    var t = function(e, i) {
        for (var n in i)
            i.hasOwnProperty(n) && (e[n] = "object" == typeof i[n] ? t(e[n], i[n]) : i[n]);
        return e
    }
      , e = function(t, e) {
        var i, n, o, a = Date.now || function() {
            return (new Date).getTime()
        }
        , s = null, r = 0, l = function() {
            r = a(),
            s = null,
            o = t.apply(i, n),
            i = n = null
        };
        return function() {
            var c = a()
              , d = e - (c - r);
            return i = this,
            n = arguments,
            0 >= d ? (clearTimeout(s),
            s = null,
            r = c,
            o = t.apply(i, n),
            i = n = null) : s || (s = setTimeout(l, d)),
            o
        }
    }
      , i = function() {
        return void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
    }
      , n = function(t, e) {
        for (var i = 0, n = t.offsetHeight; t; )
            i += t.offsetTop,
            t = t.offsetParent;
        return "bottom" === e && (i += n),
        i
    }
      , o = function(e, i) {
        "querySelector"in document && "addEventListener"in window && (this.visible = !1,
        this.options = {
            offset: 300,
            offsetSide: "top",
            classes: {
                clone: "headhesive",
                stick: "headhesive--stick",
                unstick: "headhesive--unstick"
            },
            throttle: 250,
            onInit: function() {},
            onStick: function() {},
            onUnstick: function() {},
            onDestroy: function() {}
        },
        this.elem = "string" == typeof e ? document.querySelector(e) : e,
        this.options = t(this.options, i),
        this.init())
    };
    return o.prototype = {
        constructor: o,
        init: function() {
            if (this.clonedElem = this.elem.cloneNode(!0),
            this.clonedElem.className += " " + this.options.classes.clone,
            document.body.insertBefore(this.clonedElem, document.body.firstChild),
            "number" == typeof this.options.offset)
                this.scrollOffset = this.options.offset;
            else {
                if ("string" != typeof this.options.offset)
                    throw new Error("Invalid offset: " + this.options.offset);
                this._setScrollOffset()
            }
            this._throttleUpdate = e(this.update.bind(this), this.options.throttle),
            this._throttleScrollOffset = e(this._setScrollOffset.bind(this), this.options.throttle),
            window.addEventListener("scroll", this._throttleUpdate, !1),
            window.addEventListener("resize", this._throttleScrollOffset, !1),
            this.options.onInit.call(this)
        },
        _setScrollOffset: function() {
            "string" == typeof this.options.offset && (this.scrollOffset = n(document.querySelector(this.options.offset), this.options.offsetSide))
        },
        destroy: function() {
            document.body.removeChild(this.clonedElem),
            window.removeEventListener("scroll", this._throttleUpdate),
            window.removeEventListener("resize", this._throttleScrollOffset),
            this.options.onDestroy.call(this)
        },
        stick: function() {
            this.visible || (this.clonedElem.className = this.clonedElem.className.replace(new RegExp("(^|\\s)*" + this.options.classes.unstick + "(\\s|$)*","g"), ""),
            this.clonedElem.className += " " + this.options.classes.stick,
            this.visible = !0,
            this.options.onStick.call(this))
        },
        unstick: function() {
            this.visible && (this.clonedElem.className = this.clonedElem.className.replace(new RegExp("(^|\\s)*" + this.options.classes.stick + "(\\s|$)*","g"), ""),
            this.clonedElem.className += " " + this.options.classes.unstick,
            this.visible = !1,
            this.options.onUnstick.call(this))
        },
        update: function() {
            i() > this.scrollOffset ? this.stick() : this.unstick()
        }
    },
    o
}
)),
function() {
    var t = function() {
        function t() {}
        function e(t) {
            return decodeURIComponent(t.replace(/\+/g, " "))
        }
        function i(t, e) {
            var i = t.charAt(0)
              , n = e.split(i);
            return i === t ? n : n[(t = parseInt(t.substring(1), 10)) < 0 ? n.length + t : t - 1]
        }
        function n(t, i) {
            for (var n = t.charAt(0), o = i.split("&"), a = [], s = {}, r = [], l = t.substring(1), c = 0, d = o.length; c < d; c++)
                if ((a = o[c].match(/(.*?)=(.*)/)) || (a = [o[c], o[c], ""]),
                "" !== a[1].replace(/\s/g, "")) {
                    if (a[2] = e(a[2] || ""),
                    l === a[1])
                        return a[2];
                    (r = a[1].match(/(.*)\[([0-9]+)\]/)) ? (s[r[1]] = s[r[1]] || [],
                    s[r[1]][r[2]] = a[2]) : s[a[1]] = a[2]
                }
            return n === t ? s : s[l]
        }
        return function(e, o) {
            var a, s = {};
            if ("tld?" === e)
                return t();
            if (o = o || window.location.toString(),
            !e)
                return o;
            if (e = e.toString(),
            a = o.match(/^mailto:([^\/].+)/))
                s.protocol = "mailto",
                s.email = a[1];
            else {
                if ((a = o.match(/(.*?)\/#\!(.*)/)) && (o = a[1] + a[2]),
                (a = o.match(/(.*?)#(.*)/)) && (s.hash = a[2],
                o = a[1]),
                s.hash && e.match(/^#/))
                    return n(e, s.hash);
                if ((a = o.match(/(.*?)\?(.*)/)) && (s.query = a[2],
                o = a[1]),
                s.query && e.match(/^\?/))
                    return n(e, s.query);
                if ((a = o.match(/(.*?)\:?\/\/(.*)/)) && (s.protocol = a[1].toLowerCase(),
                o = a[2]),
                (a = o.match(/(.*?)(\/.*)/)) && (s.path = a[2],
                o = a[1]),
                s.path = (s.path || "").replace(/^([^\/])/, "/$1"),
                e.match(/^[\-0-9]+$/) && (e = e.replace(/^([^\/])/, "/$1")),
                e.match(/^\//))
                    return i(e, s.path.substring(1));
                if ((a = i("/-1", s.path.substring(1))) && (a = a.match(/(.*?)\.(.*)/)) && (s.file = a[0],
                s.filename = a[1],
                s.fileext = a[2]),
                (a = o.match(/(.*)\:([0-9]+)$/)) && (s.port = a[2],
                o = a[1]),
                (a = o.match(/(.*?)@(.*)/)) && (s.auth = a[1],
                o = a[2]),
                s.auth && (a = s.auth.match(/(.*)\:(.*)/),
                s.user = a ? a[1] : s.auth,
                s.pass = a ? a[2] : void 0),
                s.hostname = o.toLowerCase(),
                "." === e.charAt(0))
                    return i(e, s.hostname);
                t() && ((a = s.hostname.match(t())) && (s.tld = a[3],
                s.domain = a[2] ? a[2] + "." + a[3] : void 0,
                s.sub = a[1] || void 0)),
                s.port = s.port || ("https" === s.protocol ? "443" : "80"),
                s.protocol = s.protocol || ("443" === s.port ? "https" : "http")
            }
            return e in s ? s[e] : "{}" === e ? s : void 0
        }
    }();
    "function" == typeof window.define && window.define.amd ? window.define("js-url", [], (function() {
        return t
    }
    )) : ("undefined" != typeof window.jQuery && window.jQuery.extend({
        url: function(t, e) {
            return window.url(t, e)
        }
    }),
    window.url = t)
}();
/*! npm.im/object-fit-images 3.2.3 */
var objectFitImages = function() {
    "use strict";
    function t(t, e) {
        return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + t + "' height='" + e + "'%3E%3C/svg%3E"
    }
    function e(t) {
        if (t.srcset && !f && window.picturefill) {
            var e = window.picturefill._;
            t[e.ns] && t[e.ns].evaled || e.fillImg(t, {
                reselect: !0
            }),
            t[e.ns].curSrc || (t[e.ns].supported = !1,
            e.fillImg(t, {
                reselect: !0
            })),
            t.currentSrc = t[e.ns].curSrc || t.src
        }
    }
    function i(t) {
        for (var e, i = getComputedStyle(t).fontFamily, n = {}; null !== (e = c.exec(i)); )
            n[e[1]] = e[2];
        return n
    }
    function n(e, i, n) {
        var o = t(i || 1, n || 0);
        m.call(e, "src") !== o && g.call(e, "src", o)
    }
    function o(t, e) {
        t.naturalWidth ? e(t) : setTimeout(o, 100, t, e)
    }
    function a(t) {
        var a = i(t)
          , r = t[l];
        if (a["object-fit"] = a["object-fit"] || "fill",
        !r.img) {
            if ("fill" === a["object-fit"])
                return;
            if (!r.skipTest && u && !a["object-position"])
                return
        }
        if (!r.img) {
            r.img = new Image(t.width,t.height),
            r.img.srcset = m.call(t, "data-ofi-srcset") || t.srcset,
            r.img.src = m.call(t, "data-ofi-src") || t.src,
            g.call(t, "data-ofi-src", t.src),
            t.srcset && g.call(t, "data-ofi-srcset", t.srcset),
            n(t, t.naturalWidth || t.width, t.naturalHeight || t.height),
            t.srcset && (t.srcset = "");
            try {
                s(t)
            } catch (t) {
                window.console && console.warn("https://bit.ly/ofi-old-browser")
            }
        }
        e(r.img),
        t.style.backgroundImage = 'url("' + (r.img.currentSrc || r.img.src).replace(/"/g, '\\"') + '")',
        t.style.backgroundPosition = a["object-position"] || "center",
        t.style.backgroundRepeat = "no-repeat",
        t.style.backgroundOrigin = "content-box",
        /scale-down/.test(a["object-fit"]) ? o(r.img, (function() {
            r.img.naturalWidth > t.width || r.img.naturalHeight > t.height ? t.style.backgroundSize = "contain" : t.style.backgroundSize = "auto"
        }
        )) : t.style.backgroundSize = a["object-fit"].replace("none", "auto").replace("fill", "100% 100%"),
        o(r.img, (function(e) {
            n(t, e.naturalWidth, e.naturalHeight)
        }
        ))
    }
    function s(t) {
        var e = {
            get: function(e) {
                return t[l].img[e || "src"]
            },
            set: function(e, i) {
                return t[l].img[i || "src"] = e,
                g.call(t, "data-ofi-" + i, e),
                a(t),
                e
            }
        };
        Object.defineProperty(t, "src", e),
        Object.defineProperty(t, "currentSrc", {
            get: function() {
                return e.get("currentSrc")
            }
        }),
        Object.defineProperty(t, "srcset", {
            get: function() {
                return e.get("srcset")
            },
            set: function(t) {
                return e.set(t, "srcset")
            }
        })
    }
    function r(t, e) {
        var i = !y && !t;
        if (e = e || {},
        t = t || "img",
        p && !e.skipTest || !h)
            return !1;
        "img" === t ? t = document.getElementsByTagName("img") : "string" == typeof t ? t = document.querySelectorAll(t) : "length"in t || (t = [t]);
        for (var n = 0; n < t.length; n++)
            t[n][l] = t[n][l] || {
                skipTest: e.skipTest
            },
            a(t[n]);
        i && (document.body.addEventListener("load", (function(t) {
            "IMG" === t.target.tagName && r(t.target, {
                skipTest: e.skipTest
            })
        }
        ), !0),
        y = !0,
        t = "img"),
        e.watchMQ && window.addEventListener("resize", r.bind(null, t, {
            skipTest: e.skipTest
        }))
    }
    var l = "bfred-it:object-fit-images"
      , c = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g
      , d = "undefined" == typeof Image ? {
        style: {
            "object-position": 1
        }
    } : new Image
      , u = "object-fit"in d.style
      , p = "object-position"in d.style
      , h = "background-size"in d.style
      , f = "string" == typeof d.currentSrc
      , m = d.getAttribute
      , g = d.setAttribute
      , y = !1;
    return r.supportsObjectFit = u,
    r.supportsObjectPosition = p,
    function() {
        function t(t, e) {
            return t[l] && t[l].img && ("src" === e || "srcset" === e) ? t[l].img : t
        }
        p || (HTMLImageElement.prototype.getAttribute = function(e) {
            return m.call(t(this, e), e)
        }
        ,
        HTMLImageElement.prototype.setAttribute = function(e, i) {
            return g.call(t(this, e), e, String(i))
        }
        )
    }(),
    r
}();
/*
 * jQuery offscreen plugin
 *
 * Copyright Cory LaViska for A Beautiful Site, LLC
 *
 * @license: http://opensource.org/licenses/MIT
 *
 */
!function(t) {
    t.extend(t.expr[":"], {
        "off-top": function(e) {
            return t(e).offset().top < t(window).scrollTop()
        },
        "off-right": function(e) {
            return t(e).offset().left + t(e).outerWidth() - t(window).scrollLeft() > t(window).width()
        },
        "off-bottom": function(e) {
            return t(e).offset().top + t(e).outerHeight() - t(window).scrollTop() > t(window).height()
        },
        "off-left": function(e) {
            return t(e).offset().left < t(window).scrollLeft()
        },
        "off-screen": function(e) {
            return t(e).is(":off-top, :off-right, :off-bottom, :off-left")
        }
    })
}(jQuery),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.lazyframe = e()
}(this, (function() {
    "use strict";
    var t = Object.assign || function(t) {
        for (var e = 1; e < arguments.length; e++) {
            var i = arguments[e];
            for (var n in i)
                Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
        }
        return t
    }
    ;
    return function() {
        function e(e) {
            if (u = t({}, h, arguments.length <= 1 ? void 0 : arguments[1]),
            "string" == typeof e)
                for (var n = document.querySelectorAll(e), o = 0; o < n.length; o++)
                    i(n[o]);
            else if (void 0 === e.length)
                i(e);
            else if (e.length > 1)
                for (var a = 0; a < e.length; a++)
                    i(e[a]);
            else
                i(e[0]);
            u.lazyload && l()
        }
        function i(t) {
            var e = this;
            if (t instanceof HTMLElement != !1 && !t.classList.contains("lazyframe--loaded")) {
                var i = {
                    el: t,
                    settings: n(t)
                };
                i.el.addEventListener("click", (function() {
                    i.el.appendChild(i.iframe);
                    var n = t.querySelectorAll("iframe");
                    i.settings.onAppend.call(e, n[0])
                }
                )),
                u.lazyload ? c(i) : s(i, !!i.settings.thumbnail)
            }
        }
        function n(e) {
            var i = Array.prototype.slice.apply(e.attributes).filter((function(t) {
                return "" !== t.value
            }
            )).reduce((function(t, e) {
                return t[0 === e.name.indexOf("data-") ? e.name.split("data-")[1] : e.name] = e.value,
                t
            }
            ), {})
              , n = t({}, u, i, {
                y: e.offsetTop,
                parameters: o(i.src)
            });
            if (n.vendor) {
                var a = n.src.match(f.regex[n.vendor]);
                n.id = f.condition[n.vendor](a)
            }
            return n
        }
        function o(t) {
            var e = t.split("?");
            return e[1] ? -1 !== (e = e[1]).indexOf("autoplay") ? e : e + "&autoplay=1" : "autoplay=1"
        }
        function a(t) {
            return !(!t.vendor || t.title && t.thumbnail || ("youtube" === t.vendor || "youtube_nocookie" === t.vendor) && !t.apikey)
        }
        function s(t) {
            var e = this;
            a(t.settings) ? r(t, (function(i, n) {
                if (!i) {
                    var o = n[0]
                      , a = n[1];
                    if (a.settings.title || (a.settings.title = f.response[a.settings.vendor].title(o)),
                    !a.settings.thumbnail) {
                        var s = f.response[a.settings.vendor].thumbnail(o);
                        a.settings.thumbnail = s,
                        t.settings.onThumbnailLoad.call(e, s)
                    }
                    c(a, !0)
                }
            }
            )) : c(t, !0)
        }
        function r(t, e) {
            var i = f.endpoints[t.settings.vendor](t.settings)
              , n = new XMLHttpRequest;
            n.open("GET", i, !0),
            n.onload = function() {
                if (n.status >= 200 && n.status < 400) {
                    var i = JSON.parse(n.responseText);
                    e(null, [i, t])
                } else
                    e(!0)
            }
            ,
            n.onerror = function() {
                e(!0)
            }
            ,
            n.send()
        }
        function l() {
            var t = this
              , e = window.innerHeight
              , i = p.length
              , n = function(e, n) {
                e.settings.initialized = !0,
                e.el.classList.add("lazyframe--loaded"),
                i--,
                s(e),
                e.settings.initinview && e.el.click(),
                e.settings.onLoad.call(t, e)
            };
            p.filter((function(t) {
                return t.settings.y < e
            }
            )).forEach(n);
            var o = function(t, e, i) {
                var n = void 0;
                return function() {
                    var o = this
                      , a = arguments
                      , s = function() {
                        n = null,
                        i || t.apply(o, a)
                    }
                      , r = i && !n;
                    clearTimeout(n),
                    n = setTimeout(s, e),
                    r && t.apply(o, a)
                }
            }((function() {
                r = a < window.pageYOffset,
                a = window.pageYOffset,
                r && p.filter((function(t) {
                    return t.settings.y < e + a && !1 === t.settings.initialized
                }
                )).forEach(n),
                0 === i && window.removeEventListener("scroll", o, !1)
            }
            ), u.debounce)
              , a = 0
              , r = !1;
            window.addEventListener("scroll", o, !1)
        }
        function c(t, e) {
            if (t.iframe = d(t.settings),
            t.settings.thumbnail && e && (t.el.style.backgroundImage = "url(" + t.settings.thumbnail + ")"),
            t.settings.title && 0 === t.el.children.length) {
                var i = document.createDocumentFragment()
                  , n = document.createElement("span");
                n.className = "lazyframe__title",
                n.innerHTML = t.settings.title,
                i.appendChild(n),
                t.el.appendChild(i)
            }
            u.lazyload || (t.el.classList.add("lazyframe--loaded"),
            t.settings.onLoad.call(this, t),
            p.push(t)),
            t.settings.initialized || p.push(t)
        }
        function d(t) {
            var e = document.createDocumentFragment()
              , i = document.createElement("iframe");
            if (t.vendor && (t.src = f.src[t.vendor](t)),
            i.setAttribute("id", "lazyframe-" + t.id),
            i.setAttribute("src", t.src),
            i.setAttribute("frameborder", 0),
            i.setAttribute("allowfullscreen", ""),
            "vine" === t.vendor) {
                var n = document.createElement("script");
                n.setAttribute("src", "https://platform.vine.co/static/scripts/embed.js"),
                e.appendChild(n)
            }
            return e.appendChild(i),
            e
        }
        var u = void 0
          , p = []
          , h = {
            vendor: void 0,
            id: void 0,
            src: void 0,
            thumbnail: void 0,
            title: void 0,
            apikey: void 0,
            initialized: !1,
            parameters: void 0,
            y: void 0,
            debounce: 250,
            lazyload: !0,
            initinview: !1,
            onLoad: function(t) {},
            onAppend: function(t) {},
            onThumbnailLoad: function(t) {}
        }
          , f = {
            regex: {
                youtube_nocookie: /(?:youtube-nocookie\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=)))([a-zA-Z0-9_-]{6,11})/,
                youtube: /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/,
                vimeo: /vimeo\.com\/(?:video\/)?([0-9]*)(?:\?|)/,
                vine: /vine.co\/v\/(.*)/
            },
            condition: {
                youtube: function(t) {
                    return !(!t || 11 != t[1].length) && t[1]
                },
                youtube_nocookie: function(t) {
                    return !(!t || 11 != t[1].length) && t[1]
                },
                vimeo: function(t) {
                    return !!(t && 9 === t[1].length || 8 === t[1].length) && t[1]
                },
                vine: function(t) {
                    return !(!t || 11 !== t[1].length) && t[1]
                }
            },
            src: {
                youtube: function(t) {
                    return "https://www.youtube.com/embed/" + t.id + "/?" + t.parameters
                },
                youtube_nocookie: function(t) {
                    return "https://www.youtube-nocookie.com/embed/" + t.id + "/?" + t.parameters
                },
                vimeo: function(t) {
                    return "https://player.vimeo.com/video/" + t.id + "/?" + t.parameters
                },
                vine: function(t) {
                    return "https://vine.co/v/" + t.id + "/embed/simple"
                }
            },
            endpoints: {
                youtube: function(t) {
                    return "https://www.googleapis.com/youtube/v3/videos?id=" + t.id + "&key=" + t.apikey + "&fields=items(snippet(title,thumbnails))&part=snippet"
                },
                youtube_nocookie: function(t) {
                    return "https://www.googleapis.com/youtube/v3/videos?id=" + t.id + "&key=" + t.apikey + "&fields=items(snippet(title,thumbnails))&part=snippet"
                },
                vimeo: function(t) {
                    return "https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/" + t.id
                },
                vine: function(t) {
                    return "https://vine.co/oembed.json?url=https%3A%2F%2Fvine.co%2Fv%2F" + t.id
                }
            },
            response: {
                youtube: {
                    title: function(t) {
                        return t.items[0].snippet.title
                    },
                    thumbnail: function(t) {
                        var e = t.items[0].snippet.thumbnails;
                        return (e.maxres || e.standard || e.high || e.medium || e.default).url
                    }
                },
                youtube_nocookie: {
                    title: function(t) {
                        return t.items[0].snippet.title
                    },
                    thumbnail: function(t) {
                        var e = t.items[0].snippet.thumbnails;
                        return (e.maxres || e.standard || e.high || e.medium || e.default).url
                    }
                },
                vimeo: {
                    title: function(t) {
                        return t.title
                    },
                    thumbnail: function(t) {
                        return t.thumbnail_url
                    }
                },
                vine: {
                    title: function(t) {
                        return t.title
                    },
                    thumbnail: function(t) {
                        return t.thumbnail_url
                    }
                }
            }
        };
        return e
    }()
}
)),
!function(t, e, i, n) {
    "use strict";
    function o(t, e) {
        var n, o, a, s = [], r = 0;
        t && t.isDefaultPrevented() || (t.preventDefault(),
        e = e || {},
        t && t.data && (e = f(t.data.options, e)),
        n = e.$target || i(t.currentTarget).trigger("blur"),
        (a = i.fancybox.getInstance()) && a.$trigger && a.$trigger.is(n) || (e.selector ? s = i(e.selector) : (o = n.attr("data-fancybox") || "") ? s = (s = t.data ? t.data.items : []).length ? s.filter('[data-fancybox="' + o + '"]') : i('[data-fancybox="' + o + '"]') : s = [n],
        (r = i(s).index(n)) < 0 && (r = 0),
        (a = i.fancybox.open(s, e, r)).$trigger = n))
    }
    if (t.console = t.console || {
        info: function(t) {}
    },
    i) {
        if (i.fn.fancybox)
            return void console.info("fancyBox already initialized");
        var a = {
            closeExisting: !1,
            loop: !1,
            gutter: 50,
            keyboard: !0,
            preventCaptionOverlap: !0,
            arrows: !0,
            infobar: !0,
            smallBtn: "auto",
            toolbar: "auto",
            buttons: ["zoom", "slideShow", "thumbs", "close"],
            idleTime: 3,
            protect: !1,
            modal: !1,
            image: {
                preload: !1
            },
            ajax: {
                settings: {
                    data: {
                        fancybox: !0
                    }
                }
            },
            iframe: {
                tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
                preload: !0,
                css: {},
                attr: {
                    scrolling: "auto"
                }
            },
            video: {
                tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
                format: "",
                autoStart: !0
            },
            defaultType: "image",
            animationEffect: "zoom",
            animationDuration: 366,
            zoomOpacity: "auto",
            transitionEffect: "fade",
            transitionDuration: 366,
            slideClass: "",
            baseClass: "",
            baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
            spinnerTpl: '<div class="fancybox-loading"></div>',
            errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
            btnTpl: {
                download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
                zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
                close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
                arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
                arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
                smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>'
            },
            parentEl: "body",
            hideScrollbar: !0,
            autoFocus: !0,
            backFocus: !0,
            trapFocus: !0,
            fullScreen: {
                autoStart: !1
            },
            touch: {
                vertical: !0,
                momentum: !0
            },
            hash: null,
            media: {},
            slideShow: {
                autoStart: !1,
                speed: 3e3
            },
            thumbs: {
                autoStart: !1,
                hideOnClose: !0,
                parentEl: ".fancybox-container",
                axis: "y"
            },
            wheel: "auto",
            onInit: i.noop,
            beforeLoad: i.noop,
            afterLoad: i.noop,
            beforeShow: i.noop,
            afterShow: i.noop,
            beforeClose: i.noop,
            afterClose: i.noop,
            onActivate: i.noop,
            onDeactivate: i.noop,
            clickContent: function(t, e) {
                return "image" === t.type && "zoom"
            },
            clickSlide: "close",
            clickOutside: "close",
            dblclickContent: !1,
            dblclickSlide: !1,
            dblclickOutside: !1,
            mobile: {
                preventCaptionOverlap: !1,
                idleTime: !1,
                clickContent: function(t, e) {
                    return "image" === t.type && "toggleControls"
                },
                clickSlide: function(t, e) {
                    return "image" === t.type ? "toggleControls" : "close"
                },
                dblclickContent: function(t, e) {
                    return "image" === t.type && "zoom"
                },
                dblclickSlide: function(t, e) {
                    return "image" === t.type && "zoom"
                }
            },
            lang: "en",
            i18n: {
                en: {
                    CLOSE: "Close",
                    NEXT: "Next",
                    PREV: "Previous",
                    ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                    PLAY_START: "Start slideshow",
                    PLAY_STOP: "Pause slideshow",
                    FULL_SCREEN: "Full screen",
                    THUMBS: "Thumbnails",
                    DOWNLOAD: "Download",
                    SHARE: "Share",
                    ZOOM: "Zoom"
                },
                de: {
                    CLOSE: "Schlie&szlig;en",
                    NEXT: "Weiter",
                    PREV: "Zur&uuml;ck",
                    ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
                    PLAY_START: "Diaschau starten",
                    PLAY_STOP: "Diaschau beenden",
                    FULL_SCREEN: "Vollbild",
                    THUMBS: "Vorschaubilder",
                    DOWNLOAD: "Herunterladen",
                    SHARE: "Teilen",
                    ZOOM: "Vergr&ouml;&szlig;ern"
                }
            }
        }
          , s = i(t)
          , r = i(e)
          , l = 0
          , c = function(t) {
            return t && t.hasOwnProperty && t instanceof i
        }
          , d = function() {
            return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function(e) {
                return t.setTimeout(e, 1e3 / 60)
            }
        }()
          , u = function() {
            return t.cancelAnimationFrame || t.webkitCancelAnimationFrame || t.mozCancelAnimationFrame || t.oCancelAnimationFrame || function(e) {
                t.clearTimeout(e)
            }
        }()
          , p = function() {
            var t, i = e.createElement("fakeelement"), n = {
                transition: "transitionend",
                OTransition: "oTransitionEnd",
                MozTransition: "transitionend",
                WebkitTransition: "webkitTransitionEnd"
            };
            for (t in n)
                if (void 0 !== i.style[t])
                    return n[t];
            return "transitionend"
        }()
          , h = function(t) {
            return t && t.length && t[0].offsetHeight
        }
          , f = function(t, e) {
            var n = i.extend(!0, {}, t, e);
            return i.each(e, (function(t, e) {
                i.isArray(e) && (n[t] = e)
            }
            )),
            n
        }
          , m = function(t) {
            var n, o;
            return !(!t || t.ownerDocument !== e) && (i(".fancybox-container").css("pointer-events", "none"),
            n = {
                x: t.getBoundingClientRect().left + t.offsetWidth / 2,
                y: t.getBoundingClientRect().top + t.offsetHeight / 2
            },
            o = e.elementFromPoint(n.x, n.y) === t,
            i(".fancybox-container").css("pointer-events", ""),
            o)
        }
          , g = function(t, e, n) {
            var o = this;
            o.opts = f({
                index: n
            }, i.fancybox.defaults),
            i.isPlainObject(e) && (o.opts = f(o.opts, e)),
            i.fancybox.isMobile && (o.opts = f(o.opts, o.opts.mobile)),
            o.id = o.opts.id || ++l,
            o.currIndex = parseInt(o.opts.index, 10) || 0,
            o.prevIndex = null,
            o.prevPos = null,
            o.currPos = 0,
            o.firstRun = !0,
            o.group = [],
            o.slides = {},
            o.addContent(t),
            o.group.length && o.init()
        };
        i.extend(g.prototype, {
            init: function() {
                var n, o, a = this, s, r = a.group[a.currIndex].opts;
                r.closeExisting && i.fancybox.close(!0),
                i("body").addClass("fancybox-active"),
                !i.fancybox.getInstance() && !1 !== r.hideScrollbar && !i.fancybox.isMobile && e.body.scrollHeight > t.innerHeight && (i("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (t.innerWidth - e.documentElement.clientWidth) + "px;}</style>"),
                i("body").addClass("compensate-for-scrollbar")),
                o = "",
                i.each(r.buttons, (function(t, e) {
                    o += r.btnTpl[e] || ""
                }
                )),
                n = i(a.translate(a, r.baseTpl.replace("{{buttons}}", o).replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight))).attr("id", "fancybox-container-" + a.id).addClass(r.baseClass).data("FancyBox", a).appendTo(r.parentEl),
                a.$refs = {
                    container: n
                },
                ["bg", "inner", "infobar", "toolbar", "stage", "caption", "navigation"].forEach((function(t) {
                    a.$refs[t] = n.find(".fancybox-" + t)
                }
                )),
                a.trigger("onInit"),
                a.activate(),
                a.jumpTo(a.currIndex)
            },
            translate: function(t, e) {
                var i = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
                return e.replace(/\{\{(\w+)\}\}/g, (function(t, e) {
                    return void 0 === i[e] ? t : i[e]
                }
                ))
            },
            addContent: function(t) {
                var e, n = this, o = i.makeArray(t);
                i.each(o, (function(t, e) {
                    var o, a, s, r, l, c = {}, d = {};
                    i.isPlainObject(e) ? (c = e,
                    d = e.opts || e) : "object" === i.type(e) && i(e).length ? (d = (o = i(e)).data() || {},
                    (d = i.extend(!0, {}, d, d.options)).$orig = o,
                    c.src = n.opts.src || d.src || o.attr("href"),
                    c.type || c.src || (c.type = "inline",
                    c.src = e)) : c = {
                        type: "html",
                        src: e + ""
                    },
                    c.opts = i.extend(!0, {}, n.opts, d),
                    i.isArray(d.buttons) && (c.opts.buttons = d.buttons),
                    i.fancybox.isMobile && c.opts.mobile && (c.opts = f(c.opts, c.opts.mobile)),
                    a = c.type || c.opts.type,
                    r = c.src || "",
                    !a && r && ((s = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (a = "video",
                    c.opts.video.format || (c.opts.video.format = "video/" + ("ogv" === s[1] ? "ogg" : s[1]))) : r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? a = "image" : r.match(/\.(pdf)((\?|#).*)?$/i) ? (a = "iframe",
                    c = i.extend(!0, c, {
                        contentType: "pdf",
                        opts: {
                            iframe: {
                                preload: !1
                            }
                        }
                    })) : "#" === r.charAt(0) && (a = "inline")),
                    a ? c.type = a : n.trigger("objectNeedsType", c),
                    c.contentType || (c.contentType = i.inArray(c.type, ["html", "inline", "ajax"]) > -1 ? "html" : c.type),
                    c.index = n.group.length,
                    "auto" == c.opts.smallBtn && (c.opts.smallBtn = i.inArray(c.type, ["html", "inline", "ajax"]) > -1),
                    "auto" === c.opts.toolbar && (c.opts.toolbar = !c.opts.smallBtn),
                    c.$thumb = c.opts.$thumb || null,
                    c.opts.$trigger && c.index === n.opts.index && (c.$thumb = c.opts.$trigger.find("img:first"),
                    c.$thumb.length && (c.opts.$orig = c.opts.$trigger)),
                    c.$thumb && c.$thumb.length || !c.opts.$orig || (c.$thumb = c.opts.$orig.find("img:first")),
                    c.$thumb && !c.$thumb.length && (c.$thumb = null),
                    c.thumb = c.opts.thumb || (c.$thumb ? c.$thumb[0].src : null),
                    "function" === i.type(c.opts.caption) && (c.opts.caption = c.opts.caption.apply(e, [n, c])),
                    "function" === i.type(n.opts.caption) && (c.opts.caption = n.opts.caption.apply(e, [n, c])),
                    c.opts.caption instanceof i || (c.opts.caption = void 0 === c.opts.caption ? "" : c.opts.caption + ""),
                    "ajax" === c.type && ((l = r.split(/\s+/, 2)).length > 1 && (c.src = l.shift(),
                    c.opts.filter = l.shift())),
                    c.opts.modal && (c.opts = i.extend(!0, c.opts, {
                        trapFocus: !0,
                        infobar: 0,
                        toolbar: 0,
                        smallBtn: 0,
                        keyboard: 0,
                        slideShow: 0,
                        fullScreen: 0,
                        thumbs: 0,
                        touch: 0,
                        clickContent: !1,
                        clickSlide: !1,
                        clickOutside: !1,
                        dblclickContent: !1,
                        dblclickSlide: !1,
                        dblclickOutside: !1
                    })),
                    n.group.push(c)
                }
                )),
                Object.keys(n.slides).length && (n.updateControls(),
                (e = n.Thumbs) && e.isActive && (e.create(),
                e.focus()))
            },
            addEvents: function() {
                var e = this;
                e.removeEvents(),
                e.$refs.container.on("click.fb-close", "[data-fancybox-close]", (function(t) {
                    t.stopPropagation(),
                    t.preventDefault(),
                    e.close(t)
                }
                )).on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", (function(t) {
                    t.stopPropagation(),
                    t.preventDefault(),
                    e.previous()
                }
                )).on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", (function(t) {
                    t.stopPropagation(),
                    t.preventDefault(),
                    e.next()
                }
                )).on("click.fb", "[data-fancybox-zoom]", (function(t) {
                    e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]()
                }
                )),
                s.on("orientationchange.fb resize.fb", (function(t) {
                    t && t.originalEvent && "resize" === t.originalEvent.type ? (e.requestId && u(e.requestId),
                    e.requestId = d((function() {
                        e.update(t)
                    }
                    ))) : (e.current && "iframe" === e.current.type && e.$refs.stage.hide(),
                    setTimeout((function() {
                        e.$refs.stage.show(),
                        e.update(t)
                    }
                    ), i.fancybox.isMobile ? 600 : 250))
                }
                )),
                r.on("keydown.fb", (function(t) {
                    var n, o = (i.fancybox ? i.fancybox.getInstance() : null).current, a = t.keyCode || t.which;
                    if (9 != a)
                        return !o.opts.keyboard || t.ctrlKey || t.altKey || t.shiftKey || i(t.target).is("input,textarea,video,audio") ? void 0 : 8 === a || 27 === a ? (t.preventDefault(),
                        void e.close(t)) : 37 === a || 38 === a ? (t.preventDefault(),
                        void e.previous()) : 39 === a || 40 === a ? (t.preventDefault(),
                        void e.next()) : void e.trigger("afterKeydown", t, a);
                    o.opts.trapFocus && e.focus(t)
                }
                )),
                e.group[e.currIndex].opts.idleTime && (e.idleSecondsCounter = 0,
                r.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", (function(t) {
                    e.idleSecondsCounter = 0,
                    e.isIdle && e.showControls(),
                    e.isIdle = !1
                }
                )),
                e.idleInterval = t.setInterval((function() {
                    ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime && !e.isDragging && (e.isIdle = !0,
                    e.idleSecondsCounter = 0,
                    e.hideControls())
                }
                ), 1e3))
            },
            removeEvents: function() {
                var e = this;
                s.off("orientationchange.fb resize.fb"),
                r.off("keydown.fb .fb-idle"),
                this.$refs.container.off(".fb-close .fb-prev .fb-next"),
                e.idleInterval && (t.clearInterval(e.idleInterval),
                e.idleInterval = null)
            },
            previous: function(t) {
                return this.jumpTo(this.currPos - 1, t)
            },
            next: function(t) {
                return this.jumpTo(this.currPos + 1, t)
            },
            jumpTo: function(t, e) {
                var n, o, a, s, r, l, c, d, u, p = this, f = p.group.length;
                if (!(p.isDragging || p.isClosing || p.isAnimating && p.firstRun)) {
                    if (t = parseInt(t, 10),
                    !(a = p.current ? p.current.opts.loop : p.opts.loop) && (t < 0 || t >= f))
                        return !1;
                    if (n = p.firstRun = !Object.keys(p.slides).length,
                    r = p.current,
                    p.prevIndex = p.currIndex,
                    p.prevPos = p.currPos,
                    s = p.createSlide(t),
                    f > 1 && ((a || s.index < f - 1) && p.createSlide(t + 1),
                    (a || s.index > 0) && p.createSlide(t - 1)),
                    p.current = s,
                    p.currIndex = s.index,
                    p.currPos = s.pos,
                    p.trigger("beforeShow", n),
                    p.updateControls(),
                    s.forcedDuration = void 0,
                    i.isNumeric(e) ? s.forcedDuration = e : e = s.opts[n ? "animationDuration" : "transitionDuration"],
                    e = parseInt(e, 10),
                    o = p.isMoved(s),
                    s.$slide.addClass("fancybox-slide--current"),
                    n)
                        return s.opts.animationEffect && e && p.$refs.container.css("transition-duration", e + "ms"),
                        p.$refs.container.addClass("fancybox-is-open").trigger("focus"),
                        p.loadSlide(s),
                        void p.preload("image");
                    l = i.fancybox.getTranslate(r.$slide),
                    c = i.fancybox.getTranslate(p.$refs.stage),
                    i.each(p.slides, (function(t, e) {
                        i.fancybox.stop(e.$slide, !0)
                    }
                    )),
                    r.pos !== s.pos && (r.isComplete = !1),
                    r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"),
                    o ? (u = l.left - (r.pos * l.width + r.pos * r.opts.gutter),
                    i.each(p.slides, (function(t, n) {
                        n.$slide.removeClass("fancybox-animated").removeClass((function(t, e) {
                            return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ")
                        }
                        ));
                        var o = n.pos * l.width + n.pos * n.opts.gutter;
                        i.fancybox.setTranslate(n.$slide, {
                            top: 0,
                            left: o - c.left + u
                        }),
                        n.pos !== s.pos && n.$slide.addClass("fancybox-slide--" + (n.pos > s.pos ? "next" : "previous")),
                        h(n.$slide),
                        i.fancybox.animate(n.$slide, {
                            top: 0,
                            left: (n.pos - s.pos) * l.width + (n.pos - s.pos) * n.opts.gutter
                        }, e, (function() {
                            n.$slide.css({
                                transform: "",
                                opacity: ""
                            }).removeClass("fancybox-slide--next fancybox-slide--previous"),
                            n.pos === p.currPos && p.complete()
                        }
                        ))
                    }
                    ))) : e && s.opts.transitionEffect && (d = "fancybox-animated fancybox-fx-" + s.opts.transitionEffect,
                    r.$slide.addClass("fancybox-slide--" + (r.pos > s.pos ? "next" : "previous")),
                    i.fancybox.animate(r.$slide, d, e, (function() {
                        r.$slide.removeClass(d).removeClass("fancybox-slide--next fancybox-slide--previous")
                    }
                    ), !1)),
                    s.isLoaded ? p.revealContent(s) : p.loadSlide(s),
                    p.preload("image")
                }
            },
            createSlide: function(t) {
                var e, n, o = this;
                return n = (n = t % o.group.length) < 0 ? o.group.length + n : n,
                !o.slides[t] && o.group[n] && (e = i('<div class="fancybox-slide"></div>').appendTo(o.$refs.stage),
                o.slides[t] = i.extend(!0, {}, o.group[n], {
                    pos: t,
                    $slide: e,
                    isLoaded: !1
                }),
                o.updateSlide(o.slides[t])),
                o.slides[t]
            },
            scaleToActual: function(t, e, n) {
                var o, a, s, r, l, c = this, d = c.current, u = d.$content, p = i.fancybox.getTranslate(d.$slide).width, h = i.fancybox.getTranslate(d.$slide).height, f = d.width, m = d.height;
                c.isAnimating || c.isMoved() || !u || "image" != d.type || !d.isLoaded || d.hasError || (c.isAnimating = !0,
                i.fancybox.stop(u),
                t = void 0 === t ? .5 * p : t,
                e = void 0 === e ? .5 * h : e,
                (o = i.fancybox.getTranslate(u)).top -= i.fancybox.getTranslate(d.$slide).top,
                o.left -= i.fancybox.getTranslate(d.$slide).left,
                r = f / o.width,
                l = m / o.height,
                a = .5 * p - .5 * f,
                s = .5 * h - .5 * m,
                f > p && ((a = o.left * r - (t * r - t)) > 0 && (a = 0),
                a < p - f && (a = p - f)),
                m > h && ((s = o.top * l - (e * l - e)) > 0 && (s = 0),
                s < h - m && (s = h - m)),
                c.updateCursor(f, m),
                i.fancybox.animate(u, {
                    top: s,
                    left: a,
                    scaleX: r,
                    scaleY: l
                }, n || 366, (function() {
                    c.isAnimating = !1
                }
                )),
                c.SlideShow && c.SlideShow.isActive && c.SlideShow.stop())
            },
            scaleToFit: function(t) {
                var e, n = this, o = n.current, a = o.$content;
                n.isAnimating || n.isMoved() || !a || "image" != o.type || !o.isLoaded || o.hasError || (n.isAnimating = !0,
                i.fancybox.stop(a),
                e = n.getFitPos(o),
                n.updateCursor(e.width, e.height),
                i.fancybox.animate(a, {
                    top: e.top,
                    left: e.left,
                    scaleX: e.width / a.width(),
                    scaleY: e.height / a.height()
                }, t || 366, (function() {
                    n.isAnimating = !1
                }
                )))
            },
            getFitPos: function(t) {
                var e, n, o, a, s = this, r = t.$content, l = t.$slide, c = t.width || t.opts.width, d = t.height || t.opts.height, u = {};
                return !!(t.isLoaded && r && r.length) && (e = i.fancybox.getTranslate(s.$refs.stage).width,
                n = i.fancybox.getTranslate(s.$refs.stage).height,
                e -= parseFloat(l.css("paddingLeft")) + parseFloat(l.css("paddingRight")) + parseFloat(r.css("marginLeft")) + parseFloat(r.css("marginRight")),
                n -= parseFloat(l.css("paddingTop")) + parseFloat(l.css("paddingBottom")) + parseFloat(r.css("marginTop")) + parseFloat(r.css("marginBottom")),
                c && d || (c = e,
                d = n),
                (c *= o = Math.min(1, e / c, n / d)) > e - .5 && (c = e),
                (d *= o) > n - .5 && (d = n),
                "image" === t.type ? (u.top = Math.floor(.5 * (n - d)) + parseFloat(l.css("paddingTop")),
                u.left = Math.floor(.5 * (e - c)) + parseFloat(l.css("paddingLeft"))) : "video" === t.contentType && (d > c / (a = t.opts.width && t.opts.height ? c / d : t.opts.ratio || 16 / 9) ? d = c / a : c > d * a && (c = d * a)),
                u.width = c,
                u.height = d,
                u)
            },
            update: function(t) {
                var e = this;
                i.each(e.slides, (function(i, n) {
                    e.updateSlide(n, t)
                }
                ))
            },
            updateSlide: function(t, e) {
                var n = this
                  , o = t && t.$content
                  , a = t.width || t.opts.width
                  , s = t.height || t.opts.height
                  , r = t.$slide;
                n.adjustCaption(t),
                o && (a || s || "video" === t.contentType) && !t.hasError && (i.fancybox.stop(o),
                i.fancybox.setTranslate(o, n.getFitPos(t)),
                t.pos === n.currPos && (n.isAnimating = !1,
                n.updateCursor())),
                n.adjustLayout(t),
                r.length && (r.trigger("refresh"),
                t.pos === n.currPos && n.$refs.toolbar.add(n.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar", r.get(0).scrollHeight > r.get(0).clientHeight)),
                n.trigger("onUpdate", t, e)
            },
            centerSlide: function(t) {
                var e = this
                  , n = e.current
                  , o = n.$slide;
                !e.isClosing && n && (o.siblings().css({
                    transform: "",
                    opacity: ""
                }),
                o.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"),
                i.fancybox.animate(o, {
                    top: 0,
                    left: 0,
                    opacity: 1
                }, void 0 === t ? 0 : t, (function() {
                    o.css({
                        transform: "",
                        opacity: ""
                    }),
                    n.isComplete || e.complete()
                }
                ), !1))
            },
            isMoved: function(t) {
                var e, n, o = t || this.current;
                return !!o && (n = i.fancybox.getTranslate(this.$refs.stage),
                e = i.fancybox.getTranslate(o.$slide),
                !o.$slide.hasClass("fancybox-animated") && (Math.abs(e.top - n.top) > .5 || Math.abs(e.left - n.left) > .5))
            },
            updateCursor: function(t, e) {
                var n, o, a = this, s = a.current, r = a.$refs.container;
                s && !a.isClosing && a.Guestures && (r.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"),
                o = !!(n = a.canPan(t, e)) || a.isZoomable(),
                r.toggleClass("fancybox-is-zoomable", o),
                i("[data-fancybox-zoom]").prop("disabled", !o),
                n ? r.addClass("fancybox-can-pan") : o && ("zoom" === s.opts.clickContent || i.isFunction(s.opts.clickContent) && "zoom" == s.opts.clickContent(s)) ? r.addClass("fancybox-can-zoomIn") : s.opts.touch && (s.opts.touch.vertical || a.group.length > 1) && "video" !== s.contentType && r.addClass("fancybox-can-swipe"))
            },
            isZoomable: function() {
                var t, e = this, i = e.current;
                if (i && !e.isClosing && "image" === i.type && !i.hasError) {
                    if (!i.isLoaded)
                        return !0;
                    if ((t = e.getFitPos(i)) && (i.width > t.width || i.height > t.height))
                        return !0
                }
                return !1
            },
            isScaledDown: function(t, e) {
                var n, o = !1, a = this.current, s = a.$content;
                return void 0 !== t && void 0 !== e ? o = t < a.width && e < a.height : s && (o = (o = i.fancybox.getTranslate(s)).width < a.width && o.height < a.height),
                o
            },
            canPan: function(t, e) {
                var n = this
                  , o = n.current
                  , a = null
                  , s = !1;
                return "image" === o.type && (o.isComplete || t && e) && !o.hasError && (s = n.getFitPos(o),
                void 0 !== t && void 0 !== e ? a = {
                    width: t,
                    height: e
                } : o.isComplete && (a = i.fancybox.getTranslate(o.$content)),
                a && s && (s = Math.abs(a.width - s.width) > 1.5 || Math.abs(a.height - s.height) > 1.5)),
                s
            },
            loadSlide: function(t) {
                var e, n, o, a = this;
                if (!t.isLoading && !t.isLoaded) {
                    if (t.isLoading = !0,
                    !1 === a.trigger("beforeLoad", t))
                        return t.isLoading = !1,
                        !1;
                    switch (e = t.type,
                    (n = t.$slide).off("refresh").trigger("onReset").addClass(t.opts.slideClass),
                    e) {
                    case "image":
                        a.setImage(t);
                        break;
                    case "iframe":
                        a.setIframe(t);
                        break;
                    case "html":
                        a.setContent(t, t.src || t.content);
                        break;
                    case "video":
                        a.setContent(t, t.opts.video.tpl.replace(/\{\{src\}\}/gi, t.src).replace("{{format}}", t.opts.videoFormat || t.opts.video.format || "").replace("{{poster}}", t.thumb || ""));
                        break;
                    case "inline":
                        i(t.src).length ? a.setContent(t, i(t.src)) : a.setError(t);
                        break;
                    case "ajax":
                        a.showLoading(t),
                        o = i.ajax(i.extend({}, t.opts.ajax.settings, {
                            url: t.src,
                            success: function(e, i) {
                                "success" === i && a.setContent(t, e)
                            },
                            error: function(e, i) {
                                e && "abort" !== i && a.setError(t)
                            }
                        })),
                        n.one("onReset", (function() {
                            o.abort()
                        }
                        ));
                        break;
                    default:
                        a.setError(t)
                    }
                    return !0
                }
            },
            setImage: function(t) {
                var n, o = this;
                setTimeout((function() {
                    var e = t.$image;
                    o.isClosing || !t.isLoading || e && e.length && e[0].complete || t.hasError || o.showLoading(t)
                }
                ), 50),
                o.checkSrcset(t),
                t.$content = i('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(t.$slide.addClass("fancybox-slide--image")),
                !1 !== t.opts.preload && t.opts.width && t.opts.height && t.thumb && (t.width = t.opts.width,
                t.height = t.opts.height,
                (n = e.createElement("img")).onerror = function() {
                    i(this).remove(),
                    t.$ghost = null
                }
                ,
                n.onload = function() {
                    o.afterLoad(t)
                }
                ,
                t.$ghost = i(n).addClass("fancybox-image").appendTo(t.$content).attr("src", t.thumb)),
                o.setBigImage(t)
            },
            checkSrcset: function(e) {
                var i, n, o, a, s = e.opts.srcset || e.opts.image.srcset;
                if (s) {
                    o = t.devicePixelRatio || 1,
                    a = t.innerWidth * o,
                    (n = s.split(",").map((function(t) {
                        var e = {};
                        return t.trim().split(/\s+/).forEach((function(t, i) {
                            var n = parseInt(t.substring(0, t.length - 1), 10);
                            if (0 === i)
                                return e.url = t;
                            n && (e.value = n,
                            e.postfix = t[t.length - 1])
                        }
                        )),
                        e
                    }
                    ))).sort((function(t, e) {
                        return t.value - e.value
                    }
                    ));
                    for (var r = 0; r < n.length; r++) {
                        var l = n[r];
                        if ("w" === l.postfix && l.value >= a || "x" === l.postfix && l.value >= o) {
                            i = l;
                            break
                        }
                    }
                    !i && n.length && (i = n[n.length - 1]),
                    i && (e.src = i.url,
                    e.width && e.height && "w" == i.postfix && (e.height = e.width / e.height * i.value,
                    e.width = i.value),
                    e.opts.srcset = s)
                }
            },
            setBigImage: function(t) {
                var n = this
                  , o = e.createElement("img")
                  , a = i(o);
                t.$image = a.one("error", (function() {
                    n.setError(t)
                }
                )).one("load", (function() {
                    var e;
                    t.$ghost || (n.resolveImageSlideSize(t, this.naturalWidth, this.naturalHeight),
                    n.afterLoad(t)),
                    n.isClosing || (t.opts.srcset && ((e = t.opts.sizes) && "auto" !== e || (e = (t.width / t.height > 1 && s.width() / s.height() > 1 ? "100" : Math.round(t.width / t.height * 100)) + "vw"),
                    a.attr("sizes", e).attr("srcset", t.opts.srcset)),
                    t.$ghost && setTimeout((function() {
                        t.$ghost && !n.isClosing && t.$ghost.hide()
                    }
                    ), Math.min(300, Math.max(1e3, t.height / 1600))),
                    n.hideLoading(t))
                }
                )).addClass("fancybox-image").attr("src", t.src).appendTo(t.$content),
                (o.complete || "complete" == o.readyState) && a.naturalWidth && a.naturalHeight ? a.trigger("load") : o.error && a.trigger("error")
            },
            resolveImageSlideSize: function(t, e, i) {
                var n = parseInt(t.opts.width, 10)
                  , o = parseInt(t.opts.height, 10);
                t.width = e,
                t.height = i,
                n > 0 && (t.width = n,
                t.height = Math.floor(n * i / e)),
                o > 0 && (t.width = Math.floor(o * e / i),
                t.height = o)
            },
            setIframe: function(t) {
                var e, n = this, o = t.opts.iframe, a = t.$slide;
                t.$content = i('<div class="fancybox-content' + (o.preload ? " fancybox-is-hidden" : "") + '"></div>').css(o.css).appendTo(a),
                a.addClass("fancybox-slide--" + t.contentType),
                t.$iframe = e = i(o.tpl.replace(/\{rnd\}/g, (new Date).getTime())).attr(o.attr).appendTo(t.$content),
                o.preload ? (n.showLoading(t),
                e.on("load.fb error.fb", (function(e) {
                    this.isReady = 1,
                    t.$slide.trigger("refresh"),
                    n.afterLoad(t)
                }
                )),
                a.on("refresh.fb", (function() {
                    var i, n, s = t.$content, r = o.css.width, l = o.css.height;
                    if (1 === e[0].isReady) {
                        try {
                            n = (i = e.contents()).find("body")
                        } catch (t) {}
                        n && n.length && n.children().length && (a.css("overflow", "visible"),
                        s.css({
                            width: "100%",
                            "max-width": "100%",
                            height: "9999px"
                        }),
                        void 0 === r && (r = Math.ceil(Math.max(n[0].clientWidth, n.outerWidth(!0)))),
                        s.css("width", r || "").css("max-width", ""),
                        void 0 === l && (l = Math.ceil(Math.max(n[0].clientHeight, n.outerHeight(!0)))),
                        s.css("height", l || ""),
                        a.css("overflow", "auto")),
                        s.removeClass("fancybox-is-hidden")
                    }
                }
                ))) : n.afterLoad(t),
                e.attr("src", t.src),
                a.one("onReset", (function() {
                    try {
                        i(this).find("iframe").hide().unbind().attr("src", "//about:blank")
                    } catch (t) {}
                    i(this).off("refresh.fb").empty(),
                    t.isLoaded = !1,
                    t.isRevealed = !1
                }
                ))
            },
            setContent: function(t, e) {
                var n = this;
                n.isClosing || (n.hideLoading(t),
                t.$content && i.fancybox.stop(t.$content),
                t.$slide.empty(),
                c(e) && e.parent().length ? ((e.hasClass("fancybox-content") || e.parent().hasClass("fancybox-content")) && e.parents(".fancybox-slide").trigger("onReset"),
                t.$placeholder = i("<div>").hide().insertAfter(e),
                e.css("display", "inline-block")) : t.hasError || ("string" === i.type(e) && (e = i("<div>").append(i.trim(e)).contents()),
                t.opts.filter && (e = i("<div>").html(e).find(t.opts.filter))),
                t.$slide.one("onReset", (function() {
                    i(this).find("video,audio").trigger("pause"),
                    t.$placeholder && (t.$placeholder.after(e.removeClass("fancybox-content").hide()).remove(),
                    t.$placeholder = null),
                    t.$smallBtn && (t.$smallBtn.remove(),
                    t.$smallBtn = null),
                    t.hasError || (i(this).empty(),
                    t.isLoaded = !1,
                    t.isRevealed = !1)
                }
                )),
                i(e).appendTo(t.$slide),
                i(e).is("video,audio") && (i(e).addClass("fancybox-video"),
                i(e).wrap("<div></div>"),
                t.contentType = "video",
                t.opts.width = t.opts.width || i(e).attr("width"),
                t.opts.height = t.opts.height || i(e).attr("height")),
                t.$content = t.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first(),
                t.$content.siblings().hide(),
                t.$content.length || (t.$content = t.$slide.wrapInner("<div></div>").children().first()),
                t.$content.addClass("fancybox-content"),
                t.$slide.addClass("fancybox-slide--" + t.contentType),
                n.afterLoad(t))
            },
            setError: function(t) {
                t.hasError = !0,
                t.$slide.trigger("onReset").removeClass("fancybox-slide--" + t.contentType).addClass("fancybox-slide--error"),
                t.contentType = "html",
                this.setContent(t, this.translate(t, t.opts.errorTpl)),
                t.pos === this.currPos && (this.isAnimating = !1)
            },
            showLoading: function(t) {
                var e = this;
                (t = t || e.current) && !t.$spinner && (t.$spinner = i(e.translate(e, e.opts.spinnerTpl)).appendTo(t.$slide).hide().fadeIn("fast"))
            },
            hideLoading: function(t) {
                var e;
                (t = t || this.current) && t.$spinner && (t.$spinner.stop().remove(),
                delete t.$spinner)
            },
            afterLoad: function(t) {
                var e = this;
                e.isClosing || (t.isLoading = !1,
                t.isLoaded = !0,
                e.trigger("afterLoad", t),
                e.hideLoading(t),
                !t.opts.smallBtn || t.$smallBtn && t.$smallBtn.length || (t.$smallBtn = i(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(t.$content)),
                t.opts.protect && t.$content && !t.hasError && (t.$content.on("contextmenu.fb", (function(t) {
                    return 2 == t.button && t.preventDefault(),
                    !0
                }
                )),
                "image" === t.type && i('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
                e.adjustCaption(t),
                e.adjustLayout(t),
                t.pos === e.currPos && e.updateCursor(),
                e.revealContent(t))
            },
            adjustCaption: function(t) {
                var e, i = this, n = t || i.current, o = n.opts.caption, a = n.opts.preventCaptionOverlap, s = i.$refs.caption, r = !1;
                s.toggleClass("fancybox-caption--separate", a),
                a && o && o.length && (n.pos !== i.currPos ? ((e = s.clone().appendTo(s.parent())).children().eq(0).empty().html(o),
                r = e.outerHeight(!0),
                e.empty().remove()) : i.$caption && (r = i.$caption.outerHeight(!0)),
                n.$slide.css("padding-bottom", r || ""))
            },
            adjustLayout: function(t) {
                var e, i, n, o, a, s = t || this.current;
                s.isLoaded && !0 !== s.opts.disableLayoutFix && (s.$content.css("margin-bottom", ""),
                s.$content.outerHeight() > s.$slide.height() + .5 && (n = s.$slide[0].style["padding-bottom"],
                o = s.$slide.css("padding-bottom"),
                parseFloat(o) > 0 && (e = s.$slide[0].scrollHeight,
                s.$slide.css("padding-bottom", 0),
                Math.abs(e - s.$slide[0].scrollHeight) < 1 && (i = o),
                s.$slide.css("padding-bottom", n))),
                s.$content.css("margin-bottom", i))
            },
            revealContent: function(t) {
                var e, n, o, a, s = this, r = t.$slide, l = !1, c = !1, d = s.isMoved(t), u = t.isRevealed;
                return t.isRevealed = !0,
                e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"],
                o = t.opts[s.firstRun ? "animationDuration" : "transitionDuration"],
                o = parseInt(void 0 === t.forcedDuration ? o : t.forcedDuration, 10),
                !d && t.pos === s.currPos && o || (e = !1),
                "zoom" === e && (t.pos === s.currPos && o && "image" === t.type && !t.hasError && (c = s.getThumbPos(t)) ? l = s.getFitPos(t) : e = "fade"),
                "zoom" === e ? (s.isAnimating = !0,
                l.scaleX = l.width / c.width,
                l.scaleY = l.height / c.height,
                "auto" == (a = t.opts.zoomOpacity) && (a = Math.abs(t.width / t.height - c.width / c.height) > .1),
                a && (c.opacity = .1,
                l.opacity = 1),
                i.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"), c),
                h(t.$content),
                void i.fancybox.animate(t.$content, l, o, (function() {
                    s.isAnimating = !1,
                    s.complete()
                }
                ))) : (s.updateSlide(t),
                e ? (i.fancybox.stop(r),
                n = "fancybox-slide--" + (t.pos >= s.prevPos ? "next" : "previous") + " fancybox-animated fancybox-fx-" + e,
                r.addClass(n).removeClass("fancybox-slide--current"),
                t.$content.removeClass("fancybox-is-hidden"),
                h(r),
                "image" !== t.type && t.$content.hide().show(0),
                void i.fancybox.animate(r, "fancybox-slide--current", o, (function() {
                    r.removeClass(n).css({
                        transform: "",
                        opacity: ""
                    }),
                    t.pos === s.currPos && s.complete()
                }
                ), !0)) : (t.$content.removeClass("fancybox-is-hidden"),
                u || !d || "image" !== t.type || t.hasError || t.$content.hide().fadeIn("fast"),
                void (t.pos === s.currPos && s.complete())))
            },
            getThumbPos: function(t) {
                var e, n, o, a, s, r = !1, l = t.$thumb;
                return !(!l || !m(l[0])) && (e = i.fancybox.getTranslate(l),
                n = parseFloat(l.css("border-top-width") || 0),
                o = parseFloat(l.css("border-right-width") || 0),
                a = parseFloat(l.css("border-bottom-width") || 0),
                s = parseFloat(l.css("border-left-width") || 0),
                r = {
                    top: e.top + n,
                    left: e.left + s,
                    width: e.width - o - s,
                    height: e.height - n - a,
                    scaleX: 1,
                    scaleY: 1
                },
                e.width > 0 && e.height > 0 && r)
            },
            complete: function() {
                var t, e = this, n = e.current, o = {};
                !e.isMoved() && n.isLoaded && (n.isComplete || (n.isComplete = !0,
                n.$slide.siblings().trigger("onReset"),
                e.preload("inline"),
                h(n.$slide),
                n.$slide.addClass("fancybox-slide--complete"),
                i.each(e.slides, (function(t, n) {
                    n.pos >= e.currPos - 1 && n.pos <= e.currPos + 1 ? o[n.pos] = n : n && (i.fancybox.stop(n.$slide),
                    n.$slide.off().remove())
                }
                )),
                e.slides = o),
                e.isAnimating = !1,
                e.updateCursor(),
                e.trigger("afterShow"),
                n.opts.video.autoStart && n.$slide.find("video,audio").filter(":visible:first").trigger("play").one("ended", (function() {
                    this.webkitExitFullscreen && this.webkitExitFullscreen(),
                    e.next()
                }
                )),
                n.opts.autoFocus && "html" === n.contentType && ((t = n.$content.find("input[autofocus]:enabled:visible:first")).length ? t.trigger("focus") : e.focus(null, !0)),
                n.$slide.scrollTop(0).scrollLeft(0))
            },
            preload: function(t) {
                var e, i, n = this;
                n.group.length < 2 || (i = n.slides[n.currPos + 1],
                (e = n.slides[n.currPos - 1]) && e.type === t && n.loadSlide(e),
                i && i.type === t && n.loadSlide(i))
            },
            focus: function(t, n) {
                var o, a, s = this, r = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden])", "iframe", "object", "embed", "video", "audio", "[contenteditable]", '[tabindex]:not([tabindex^="-"])'].join(",");
                s.isClosing || ((o = (o = !t && s.current && s.current.isComplete ? s.current.$slide.find("*:visible" + (n ? ":not(.fancybox-close-small)" : "")) : s.$refs.container.find("*:visible")).filter(r).filter((function() {
                    return "hidden" !== i(this).css("visibility") && !i(this).hasClass("disabled")
                }
                ))).length ? (a = o.index(e.activeElement),
                t && t.shiftKey ? (a < 0 || 0 == a) && (t.preventDefault(),
                o.eq(o.length - 1).trigger("focus")) : (a < 0 || a == o.length - 1) && (t && t.preventDefault(),
                o.eq(0).trigger("focus"))) : s.$refs.container.trigger("focus"))
            },
            activate: function() {
                var t = this;
                i(".fancybox-container").each((function() {
                    var e = i(this).data("FancyBox");
                    e && e.id !== t.id && !e.isClosing && (e.trigger("onDeactivate"),
                    e.removeEvents(),
                    e.isVisible = !1)
                }
                )),
                t.isVisible = !0,
                (t.current || t.isIdle) && (t.update(),
                t.updateControls()),
                t.trigger("onActivate"),
                t.addEvents()
            },
            close: function(t, e) {
                var n, o, a, s, r, l, c, u = this, p = u.current, f = function() {
                    u.cleanUp(t)
                };
                return !(u.isClosing || (u.isClosing = !0,
                !1 === u.trigger("beforeClose", t) ? (u.isClosing = !1,
                d((function() {
                    u.update()
                }
                )),
                1) : (u.removeEvents(),
                a = p.$content,
                n = p.opts.animationEffect,
                o = i.isNumeric(e) ? e : n ? p.opts.animationDuration : 0,
                p.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"),
                !0 !== t ? i.fancybox.stop(p.$slide) : n = !1,
                p.$slide.siblings().trigger("onReset").remove(),
                o && u.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing").css("transition-duration", o + "ms"),
                u.hideLoading(p),
                u.hideControls(!0),
                u.updateCursor(),
                "zoom" !== n || a && o && "image" === p.type && !u.isMoved() && !p.hasError && (c = u.getThumbPos(p)) || (n = "fade"),
                "zoom" === n ? (i.fancybox.stop(a),
                s = i.fancybox.getTranslate(a),
                l = {
                    top: s.top,
                    left: s.left,
                    scaleX: s.width / c.width,
                    scaleY: s.height / c.height,
                    width: c.width,
                    height: c.height
                },
                r = p.opts.zoomOpacity,
                "auto" == r && (r = Math.abs(p.width / p.height - c.width / c.height) > .1),
                r && (c.opacity = 0),
                i.fancybox.setTranslate(a, l),
                h(a),
                i.fancybox.animate(a, c, o, f),
                0) : (n && o ? i.fancybox.animate(p.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"), "fancybox-animated fancybox-fx-" + n, o, f) : !0 === t ? setTimeout(f, o) : f(),
                0))))
            },
            cleanUp: function(e) {
                var n, o, a, s = this, r = s.current.opts.$orig;
                s.current.$slide.trigger("onReset"),
                s.$refs.container.empty().remove(),
                s.trigger("afterClose", e),
                s.current.opts.backFocus && (r && r.length && r.is(":visible") || (r = s.$trigger),
                r && r.length && (o = t.scrollX,
                a = t.scrollY,
                r.trigger("focus"),
                i("html, body").scrollTop(a).scrollLeft(o))),
                s.current = null,
                (n = i.fancybox.getInstance()) ? n.activate() : (i("body").removeClass("fancybox-active compensate-for-scrollbar"),
                i("#fancybox-style-noscroll").remove())
            },
            trigger: function(t, e) {
                var n, o = Array.prototype.slice.call(arguments, 1), a = this, s = e && e.opts ? e : a.current;
                if (s ? o.unshift(s) : s = a,
                o.unshift(a),
                i.isFunction(s.opts[t]) && (n = s.opts[t].apply(s, o)),
                !1 === n)
                    return n;
                "afterClose" !== t && a.$refs ? a.$refs.container.trigger(t + ".fb", o) : r.trigger(t + ".fb", o)
            },
            updateControls: function() {
                var t = this
                  , n = t.current
                  , o = n.index
                  , a = t.$refs.container
                  , s = t.$refs.caption
                  , r = n.opts.caption;
                n.$slide.trigger("refresh"),
                r && r.length ? (t.$caption = s,
                s.children().eq(0).html(r)) : t.$caption = null,
                t.hasHiddenControls || t.isIdle || t.showControls(),
                a.find("[data-fancybox-count]").html(t.group.length),
                a.find("[data-fancybox-index]").html(o + 1),
                a.find("[data-fancybox-prev]").prop("disabled", !n.opts.loop && o <= 0),
                a.find("[data-fancybox-next]").prop("disabled", !n.opts.loop && o >= t.group.length - 1),
                "image" === n.type ? a.find("[data-fancybox-zoom]").show().end().find("[data-fancybox-download]").attr("href", n.opts.image.src || n.src).show() : n.opts.toolbar && a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
                i(e.activeElement).is(":hidden,[disabled]") && t.$refs.container.trigger("focus")
            },
            hideControls: function(t) {
                var e, i = ["infobar", "toolbar", "nav"];
                !t && this.current.opts.preventCaptionOverlap || i.push("caption"),
                this.$refs.container.removeClass(i.map((function(t) {
                    return "fancybox-show-" + t
                }
                )).join(" ")),
                this.hasHiddenControls = !0
            },
            showControls: function() {
                var t = this
                  , e = t.current ? t.current.opts : t.opts
                  , i = t.$refs.container;
                t.hasHiddenControls = !1,
                t.idleSecondsCounter = 0,
                i.toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons)).toggleClass("fancybox-show-infobar", !!(e.infobar && t.group.length > 1)).toggleClass("fancybox-show-caption", !!t.$caption).toggleClass("fancybox-show-nav", !!(e.arrows && t.group.length > 1)).toggleClass("fancybox-is-modal", !!e.modal)
            },
            toggleControls: function() {
                this.hasHiddenControls ? this.showControls() : this.hideControls()
            }
        }),
        i.fancybox = {
            version: "3.5.6",
            defaults: a,
            getInstance: function(t) {
                var e = i('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox")
                  , n = Array.prototype.slice.call(arguments, 1);
                return e instanceof g && ("string" === i.type(t) ? e[t].apply(e, n) : "function" === i.type(t) && t.apply(e, n),
                e)
            },
            open: function(t, e, i) {
                return new g(t,e,i)
            },
            close: function(t) {
                var e = this.getInstance();
                e && (e.close(),
                !0 === t && this.close(t))
            },
            destroy: function() {
                this.close(!0),
                r.add("body").off("click.fb-start", "**")
            },
            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
            use3d: function() {
                var i = e.createElement("div");
                return t.getComputedStyle && t.getComputedStyle(i) && t.getComputedStyle(i).getPropertyValue("transform") && !(e.documentMode && e.documentMode < 11)
            }(),
            getTranslate: function(t) {
                var e;
                return !(!t || !t.length) && {
                    top: (e = t[0].getBoundingClientRect()).top || 0,
                    left: e.left || 0,
                    width: e.width,
                    height: e.height,
                    opacity: parseFloat(t.css("opacity"))
                }
            },
            setTranslate: function(t, e) {
                var i = ""
                  , n = {};
                if (t && e)
                    return void 0 === e.left && void 0 === e.top || (i = (void 0 === e.left ? t.position().left : e.left) + "px, " + (void 0 === e.top ? t.position().top : e.top) + "px",
                    i = this.use3d ? "translate3d(" + i + ", 0px)" : "translate(" + i + ")"),
                    void 0 !== e.scaleX && void 0 !== e.scaleY ? i += " scale(" + e.scaleX + ", " + e.scaleY + ")" : void 0 !== e.scaleX && (i += " scaleX(" + e.scaleX + ")"),
                    i.length && (n.transform = i),
                    void 0 !== e.opacity && (n.opacity = e.opacity),
                    void 0 !== e.width && (n.width = e.width),
                    void 0 !== e.height && (n.height = e.height),
                    t.css(n)
            },
            animate: function(t, e, n, o, a) {
                var s, r = this;
                i.isFunction(n) && (o = n,
                n = null),
                r.stop(t),
                s = r.getTranslate(t),
                t.on(p, (function(l) {
                    (!l || !l.originalEvent || t.is(l.originalEvent.target) && "z-index" != l.originalEvent.propertyName) && (r.stop(t),
                    i.isNumeric(n) && t.css("transition-duration", ""),
                    i.isPlainObject(e) ? void 0 !== e.scaleX && void 0 !== e.scaleY && r.setTranslate(t, {
                        top: e.top,
                        left: e.left,
                        width: s.width * e.scaleX,
                        height: s.height * e.scaleY,
                        scaleX: 1,
                        scaleY: 1
                    }) : !0 !== a && t.removeClass(e),
                    i.isFunction(o) && o(l))
                }
                )),
                i.isNumeric(n) && t.css("transition-duration", n + "ms"),
                i.isPlainObject(e) ? (void 0 !== e.scaleX && void 0 !== e.scaleY && (delete e.width,
                delete e.height,
                t.parent().hasClass("fancybox-slide--image") && t.parent().addClass("fancybox-is-scaling")),
                i.fancybox.setTranslate(t, e)) : t.addClass(e),
                t.data("timer", setTimeout((function() {
                    t.trigger(p)
                }
                ), n + 33))
            },
            stop: function(t, e) {
                t && t.length && (clearTimeout(t.data("timer")),
                e && t.trigger(p),
                t.off(p).css("transition-duration", ""),
                t.parent().removeClass("fancybox-is-scaling"))
            }
        },
        i.fn.fancybox = function(t) {
            var e;
            return (e = (t = t || {}).selector || !1) ? i("body").off("click.fb-start", e).on("click.fb-start", e, {
                options: t
            }, o) : this.off("click.fb-start").on("click.fb-start", {
                items: this,
                options: t
            }, o),
            this
        }
        ,
        r.on("click.fb-start", "[data-fancybox]", o),
        r.on("click.fb-start", "[data-fancybox-trigger]", (function(t) {
            i('[data-fancybox="' + i(this).attr("data-fancybox-trigger") + '"]').eq(i(this).attr("data-fancybox-index") || 0).trigger("click.fb-start", {
                $trigger: i(this)
            })
        }
        )),
        function() {
            var t = null;
            r.on("mousedown mouseup focus blur", ".fancybox-button", (function(e) {
                switch (e.type) {
                case "mousedown":
                    t = i(this);
                    break;
                case "mouseup":
                    t = null;
                    break;
                case "focusin":
                    i(".fancybox-button").removeClass("fancybox-focus"),
                    i(this).is(t) || i(this).is("[disabled]") || i(this).addClass("fancybox-focus");
                    break;
                case "focusout":
                    i(".fancybox-button").removeClass("fancybox-focus")
                }
            }
            ))
        }()
    }
}(window, document, jQuery),
function(t) {
    "use strict";
    var e = {
        youtube: {
            matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
            params: {
                autoplay: 1,
                autohide: 1,
                fs: 1,
                rel: 0,
                hd: 1,
                wmode: "transparent",
                enablejsapi: 1,
                html5: 1
            },
            paramPlace: 8,
            type: "iframe",
            url: "https://www.youtube-nocookie.com/embed/$4",
            thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg"
        },
        vimeo: {
            matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
            params: {
                autoplay: 1,
                hd: 1,
                show_title: 1,
                show_byline: 1,
                show_portrait: 0,
                fullscreen: 1
            },
            paramPlace: 3,
            type: "iframe",
            url: "//player.vimeo.com/video/$2"
        },
        instagram: {
            matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
            type: "image",
            url: "//$1/p/$2/media/?size=l"
        },
        gmap_place: {
            matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
            type: "iframe",
            url: function(t) {
                return "//maps.google." + t[2] + "/?ll=" + (t[9] ? t[9] + "&z=" + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, "&") : "") : t[12] + "").replace(/\?/, "&") + "&output=" + (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
            }
        },
        gmap_search: {
            matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
            type: "iframe",
            url: function(t) {
                return "//maps.google." + t[2] + "/maps?q=" + t[5].replace("query=", "q=").replace("api=1", "") + "&output=embed"
            }
        }
    }
      , i = function(e, i, n) {
        if (e)
            return n = n || "",
            "object" === t.type(n) && (n = t.param(n, !0)),
            t.each(i, (function(t, i) {
                e = e.replace("$" + t, i || "")
            }
            )),
            n.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + n),
            e
    };
    t(document).on("objectNeedsType.fb", (function(n, o, a) {
        var s, r, l, c, d, u, p, h = a.src || "", f = !1;
        s = t.extend(!0, {}, e, a.opts.media),
        t.each(s, (function(e, n) {
            if (l = h.match(n.matcher)) {
                if (f = n.type,
                p = e,
                u = {},
                n.paramPlace && l[n.paramPlace]) {
                    "?" == (d = l[n.paramPlace])[0] && (d = d.substring(1)),
                    d = d.split("&");
                    for (var o = 0; o < d.length; ++o) {
                        var s = d[o].split("=", 2);
                        2 == s.length && (u[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")))
                    }
                }
                return c = t.extend(!0, {}, n.params, a.opts[e], u),
                h = "function" === t.type(n.url) ? n.url.call(this, l, c, a) : i(n.url, l, c),
                r = "function" === t.type(n.thumb) ? n.thumb.call(this, l, c, a) : i(n.thumb, l),
                "youtube" === e ? h = h.replace(/&t=((\d+)m)?(\d+)s/, (function(t, e, i, n) {
                    return "&start=" + ((i ? 60 * parseInt(i, 10) : 0) + parseInt(n, 10))
                }
                )) : "vimeo" === e && (h = h.replace("&%23", "#")),
                !1
            }
        }
        )),
        f ? (a.opts.thumb || a.opts.$thumb && a.opts.$thumb.length || (a.opts.thumb = r),
        "iframe" === f && (a.opts = t.extend(!0, a.opts, {
            iframe: {
                preload: !1,
                attr: {
                    scrolling: "no"
                }
            }
        })),
        t.extend(a, {
            type: f,
            src: h,
            origSrc: a.src,
            contentSource: p,
            contentType: "image" === f ? "image" : "gmap_place" == p || "gmap_search" == p ? "map" : "video"
        })) : h && (a.type = a.opts.defaultType)
    }
    ));
    var n = {
        youtube: {
            src: "https://www.youtube.com/iframe_api",
            class: "YT",
            loading: !1,
            loaded: !1
        },
        vimeo: {
            src: "https://player.vimeo.com/api/player.js",
            class: "Vimeo",
            loading: !1,
            loaded: !1
        },
        load: function(t) {
            var e, i = this;
            this[t].loaded ? setTimeout((function() {
                i.done(t)
            }
            )) : this[t].loading || (this[t].loading = !0,
            (e = document.createElement("script")).type = "text/javascript",
            e.src = this[t].src,
            "youtube" === t ? window.onYouTubeIframeAPIReady = function() {
                i[t].loaded = !0,
                i.done(t)
            }
            : e.onload = function() {
                i[t].loaded = !0,
                i.done(t)
            }
            ,
            document.body.appendChild(e))
        },
        done: function(e) {
            var i, n, o;
            "youtube" === e && delete window.onYouTubeIframeAPIReady,
            (i = t.fancybox.getInstance()) && (n = i.current.$content.find("iframe"),
            "youtube" === e && void 0 !== YT && YT ? o = new YT.Player(n.attr("id"),{
                events: {
                    onStateChange: function(t) {
                        0 == t.data && i.next()
                    }
                }
            }) : "vimeo" === e && void 0 !== Vimeo && Vimeo && (o = new Vimeo.Player(n)).on("ended", (function() {
                i.next()
            }
            )))
        }
    };
    t(document).on({
        "afterShow.fb": function(t, e, i) {
            e.group.length > 1 && ("youtube" === i.contentSource || "vimeo" === i.contentSource) && n.load(i.contentSource)
        }
    })
}(jQuery),
function(t, e, i) {
    "use strict";
    var n = function() {
        return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function(e) {
            return t.setTimeout(e, 1e3 / 60)
        }
    }()
      , o = function() {
        return t.cancelAnimationFrame || t.webkitCancelAnimationFrame || t.mozCancelAnimationFrame || t.oCancelAnimationFrame || function(e) {
            t.clearTimeout(e)
        }
    }()
      , a = function(e) {
        var i = [];
        for (var n in e = (e = e.originalEvent || e || t.e).touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [e])
            e[n].pageX ? i.push({
                x: e[n].pageX,
                y: e[n].pageY
            }) : e[n].clientX && i.push({
                x: e[n].clientX,
                y: e[n].clientY
            });
        return i
    }
      , s = function(t, e, i) {
        return e && t ? "x" === i ? t.x - e.x : "y" === i ? t.y - e.y : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)) : 0
    }
      , r = function(t) {
        if (t.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe') || i.isFunction(t.get(0).onclick) || t.data("selectable"))
            return !0;
        for (var e = 0, n = t[0].attributes, o = n.length; e < o; e++)
            if ("data-fancybox-" === n[e].nodeName.substr(0, 14))
                return !0;
        return !1
    }
      , l = function(e) {
        var i = t.getComputedStyle(e)["overflow-y"]
          , n = t.getComputedStyle(e)["overflow-x"]
          , o = ("scroll" === i || "auto" === i) && e.scrollHeight > e.clientHeight
          , a = ("scroll" === n || "auto" === n) && e.scrollWidth > e.clientWidth;
        return o || a
    }
      , c = function(t) {
        for (var e = !1; ; ) {
            if (e = l(t.get(0)))
                break;
            if (!(t = t.parent()).length || t.hasClass("fancybox-stage") || t.is("body"))
                break
        }
        return e
    }
      , d = function(t) {
        var e = this;
        e.instance = t,
        e.$bg = t.$refs.bg,
        e.$stage = t.$refs.stage,
        e.$container = t.$refs.container,
        e.destroy(),
        e.$container.on("touchstart.fb.touch mousedown.fb.touch", i.proxy(e, "ontouchstart"))
    };
    d.prototype.destroy = function() {
        var t = this;
        t.$container.off(".fb.touch"),
        i(e).off(".fb.touch"),
        t.requestId && (o(t.requestId),
        t.requestId = null),
        t.tapped && (clearTimeout(t.tapped),
        t.tapped = null)
    }
    ,
    d.prototype.ontouchstart = function(n) {
        var o = this
          , l = i(n.target)
          , d = o.instance
          , u = d.current
          , p = u.$slide
          , h = u.$content
          , f = "touchstart" == n.type;
        if (f && o.$container.off("mousedown.fb.touch"),
        (!n.originalEvent || 2 != n.originalEvent.button) && p.length && l.length && !r(l) && !r(l.parent()) && (l.is("img") || !(n.originalEvent.clientX > l[0].clientWidth + l.offset().left))) {
            if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated"))
                return n.stopPropagation(),
                void n.preventDefault();
            o.realPoints = o.startPoints = a(n),
            o.startPoints.length && (u.touch && n.stopPropagation(),
            o.startEvent = n,
            o.canTap = !0,
            o.$target = l,
            o.$content = h,
            o.opts = u.opts.touch,
            o.isPanning = !1,
            o.isSwiping = !1,
            o.isZooming = !1,
            o.isScrolling = !1,
            o.canPan = d.canPan(),
            o.startTime = (new Date).getTime(),
            o.distanceX = o.distanceY = o.distance = 0,
            o.canvasWidth = Math.round(p[0].clientWidth),
            o.canvasHeight = Math.round(p[0].clientHeight),
            o.contentLastPos = null,
            o.contentStartPos = i.fancybox.getTranslate(o.$content) || {
                top: 0,
                left: 0
            },
            o.sliderStartPos = i.fancybox.getTranslate(p),
            o.stagePos = i.fancybox.getTranslate(d.$refs.stage),
            o.sliderStartPos.top -= o.stagePos.top,
            o.sliderStartPos.left -= o.stagePos.left,
            o.contentStartPos.top -= o.stagePos.top,
            o.contentStartPos.left -= o.stagePos.left,
            i(e).off(".fb.touch").on(f ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", i.proxy(o, "ontouchend")).on(f ? "touchmove.fb.touch" : "mousemove.fb.touch", i.proxy(o, "ontouchmove")),
            i.fancybox.isMobile && e.addEventListener("scroll", o.onscroll, !0),
            ((o.opts || o.canPan) && (l.is(o.$stage) || o.$stage.find(l).length) || (l.is(".fancybox-image") && n.preventDefault(),
            i.fancybox.isMobile && l.parents(".fancybox-caption").length)) && (o.isScrollable = c(l) || c(l.parent()),
            i.fancybox.isMobile && o.isScrollable || n.preventDefault(),
            (1 === o.startPoints.length || u.hasError) && (o.canPan ? (i.fancybox.stop(o.$content),
            o.isPanning = !0) : o.isSwiping = !0,
            o.$container.addClass("fancybox-is-grabbing")),
            2 === o.startPoints.length && "image" === u.type && (u.isLoaded || u.$ghost) && (o.canTap = !1,
            o.isSwiping = !1,
            o.isPanning = !1,
            o.isZooming = !0,
            i.fancybox.stop(o.$content),
            o.centerPointStartX = .5 * (o.startPoints[0].x + o.startPoints[1].x) - i(t).scrollLeft(),
            o.centerPointStartY = .5 * (o.startPoints[0].y + o.startPoints[1].y) - i(t).scrollTop(),
            o.percentageOfImageAtPinchPointX = (o.centerPointStartX - o.contentStartPos.left) / o.contentStartPos.width,
            o.percentageOfImageAtPinchPointY = (o.centerPointStartY - o.contentStartPos.top) / o.contentStartPos.height,
            o.startDistanceBetweenFingers = s(o.startPoints[0], o.startPoints[1]))))
        }
    }
    ,
    d.prototype.onscroll = function(t) {
        var i = this;
        i.isScrolling = !0,
        e.removeEventListener("scroll", i.onscroll, !0)
    }
    ,
    d.prototype.ontouchmove = function(t) {
        var e = this;
        return void 0 !== t.originalEvent.buttons && 0 === t.originalEvent.buttons ? void e.ontouchend(t) : e.isScrolling ? void (e.canTap = !1) : (e.newPoints = a(t),
        void ((e.opts || e.canPan) && e.newPoints.length && e.newPoints.length && (e.isSwiping && !0 === e.isSwiping || t.preventDefault(),
        e.distanceX = s(e.newPoints[0], e.startPoints[0], "x"),
        e.distanceY = s(e.newPoints[0], e.startPoints[0], "y"),
        e.distance = s(e.newPoints[0], e.startPoints[0]),
        e.distance > 0 && (e.isSwiping ? e.onSwipe(t) : e.isPanning ? e.onPan() : e.isZooming && e.onZoom()))))
    }
    ,
    d.prototype.onSwipe = function(e) {
        var a, s = this, r = s.instance, l = s.isSwiping, c = s.sliderStartPos.left || 0;
        if (!0 !== l)
            "x" == l && (s.distanceX > 0 && (s.instance.group.length < 2 || 0 === s.instance.current.index && !s.instance.current.opts.loop) ? c += Math.pow(s.distanceX, .8) : s.distanceX < 0 && (s.instance.group.length < 2 || s.instance.current.index === s.instance.group.length - 1 && !s.instance.current.opts.loop) ? c -= Math.pow(-s.distanceX, .8) : c += s.distanceX),
            s.sliderLastPos = {
                top: "x" == l ? 0 : s.sliderStartPos.top + s.distanceY,
                left: c
            },
            s.requestId && (o(s.requestId),
            s.requestId = null),
            s.requestId = n((function() {
                s.sliderLastPos && (i.each(s.instance.slides, (function(t, e) {
                    var n = e.pos - s.instance.currPos;
                    i.fancybox.setTranslate(e.$slide, {
                        top: s.sliderLastPos.top,
                        left: s.sliderLastPos.left + n * s.canvasWidth + n * e.opts.gutter
                    })
                }
                )),
                s.$container.addClass("fancybox-is-sliding"))
            }
            ));
        else if (Math.abs(s.distance) > 10) {
            if (s.canTap = !1,
            r.group.length < 2 && s.opts.vertical ? s.isSwiping = "y" : r.isDragging || !1 === s.opts.vertical || "auto" === s.opts.vertical && i(t).width() > 800 ? s.isSwiping = "x" : (a = Math.abs(180 * Math.atan2(s.distanceY, s.distanceX) / Math.PI),
            s.isSwiping = a > 45 && a < 135 ? "y" : "x"),
            "y" === s.isSwiping && i.fancybox.isMobile && s.isScrollable)
                return void (s.isScrolling = !0);
            r.isDragging = s.isSwiping,
            s.startPoints = s.newPoints,
            i.each(r.slides, (function(t, e) {
                var n, o;
                i.fancybox.stop(e.$slide),
                n = i.fancybox.getTranslate(e.$slide),
                o = i.fancybox.getTranslate(r.$refs.stage),
                e.$slide.css({
                    transform: "",
                    opacity: "",
                    "transition-duration": ""
                }).removeClass("fancybox-animated").removeClass((function(t, e) {
                    return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ")
                }
                )),
                e.pos === r.current.pos && (s.sliderStartPos.top = n.top - o.top,
                s.sliderStartPos.left = n.left - o.left),
                i.fancybox.setTranslate(e.$slide, {
                    top: n.top - o.top,
                    left: n.left - o.left
                })
            }
            )),
            r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop()
        }
    }
    ,
    d.prototype.onPan = function() {
        var t = this;
        s(t.newPoints[0], t.realPoints[0]) < (i.fancybox.isMobile ? 10 : 5) ? t.startPoints = t.newPoints : (t.canTap = !1,
        t.contentLastPos = t.limitMovement(),
        t.requestId && o(t.requestId),
        t.requestId = n((function() {
            i.fancybox.setTranslate(t.$content, t.contentLastPos)
        }
        )))
    }
    ,
    d.prototype.limitMovement = function() {
        var t, e, i, n, o, a, s = this, r = s.canvasWidth, l = s.canvasHeight, c = s.distanceX, d = s.distanceY, u = s.contentStartPos, p = u.left, h = u.top, f = u.width, m = u.height;
        return o = f > r ? p + c : p,
        a = h + d,
        t = Math.max(0, .5 * r - .5 * f),
        e = Math.max(0, .5 * l - .5 * m),
        i = Math.min(r - f, .5 * r - .5 * f),
        n = Math.min(l - m, .5 * l - .5 * m),
        c > 0 && o > t && (o = t - 1 + Math.pow(-t + p + c, .8) || 0),
        c < 0 && o < i && (o = i + 1 - Math.pow(i - p - c, .8) || 0),
        d > 0 && a > e && (a = e - 1 + Math.pow(-e + h + d, .8) || 0),
        d < 0 && a < n && (a = n + 1 - Math.pow(n - h - d, .8) || 0),
        {
            top: a,
            left: o
        }
    }
    ,
    d.prototype.limitPosition = function(t, e, i, n) {
        var o = this
          , a = o.canvasWidth
          , s = o.canvasHeight;
        return i > a ? t = (t = t > 0 ? 0 : t) < a - i ? a - i : t : t = Math.max(0, a / 2 - i / 2),
        n > s ? e = (e = e > 0 ? 0 : e) < s - n ? s - n : e : e = Math.max(0, s / 2 - n / 2),
        {
            top: e,
            left: t
        }
    }
    ,
    d.prototype.onZoom = function() {
        var e = this, a = e.contentStartPos, r = a.width, l = a.height, c = a.left, d = a.top, u, p = s(e.newPoints[0], e.newPoints[1]) / e.startDistanceBetweenFingers, h = Math.floor(r * p), f = Math.floor(l * p), m = (r - h) * e.percentageOfImageAtPinchPointX, g = (l - f) * e.percentageOfImageAtPinchPointY, y = (e.newPoints[0].x + e.newPoints[1].x) / 2 - i(t).scrollLeft(), v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - i(t).scrollTop(), b = y - e.centerPointStartX, w, $, _, x = {
            top: d + (g + (v - e.centerPointStartY)),
            left: c + (m + b),
            scaleX: p,
            scaleY: p
        };
        e.canTap = !1,
        e.newWidth = h,
        e.newHeight = f,
        e.contentLastPos = x,
        e.requestId && o(e.requestId),
        e.requestId = n((function() {
            i.fancybox.setTranslate(e.$content, e.contentLastPos)
        }
        ))
    }
    ,
    d.prototype.ontouchend = function(t) {
        var n = this
          , s = n.isSwiping
          , r = n.isPanning
          , l = n.isZooming
          , c = n.isScrolling;
        if (n.endPoints = a(t),
        n.dMs = Math.max((new Date).getTime() - n.startTime, 1),
        n.$container.removeClass("fancybox-is-grabbing"),
        i(e).off(".fb.touch"),
        e.removeEventListener("scroll", n.onscroll, !0),
        n.requestId && (o(n.requestId),
        n.requestId = null),
        n.isSwiping = !1,
        n.isPanning = !1,
        n.isZooming = !1,
        n.isScrolling = !1,
        n.instance.isDragging = !1,
        n.canTap)
            return n.onTap(t);
        n.speed = 100,
        n.velocityX = n.distanceX / n.dMs * .5,
        n.velocityY = n.distanceY / n.dMs * .5,
        r ? n.endPanning() : l ? n.endZooming() : n.endSwiping(s, c)
    }
    ,
    d.prototype.endSwiping = function(t, e) {
        var n = this
          , o = !1
          , a = n.instance.group.length
          , s = Math.abs(n.distanceX)
          , r = "x" == t && a > 1 && (n.dMs > 130 && s > 10 || s > 50);
        n.sliderLastPos = null,
        "y" == t && !e && Math.abs(n.distanceY) > 50 ? (i.fancybox.animate(n.instance.current.$slide, {
            top: n.sliderStartPos.top + n.distanceY + 150 * n.velocityY,
            opacity: 0
        }, 200),
        o = n.instance.close(!0, 250)) : r && n.distanceX > 0 ? o = n.instance.previous(300) : r && n.distanceX < 0 && (o = n.instance.next(300)),
        !1 !== o || "x" != t && "y" != t || n.instance.centerSlide(200),
        n.$container.removeClass("fancybox-is-sliding")
    }
    ,
    d.prototype.endPanning = function() {
        var t, e, n, o = this;
        o.contentLastPos && (!1 === o.opts.momentum || o.dMs > 350 ? (t = o.contentLastPos.left,
        e = o.contentLastPos.top) : (t = o.contentLastPos.left + 500 * o.velocityX,
        e = o.contentLastPos.top + 500 * o.velocityY),
        (n = o.limitPosition(t, e, o.contentStartPos.width, o.contentStartPos.height)).width = o.contentStartPos.width,
        n.height = o.contentStartPos.height,
        i.fancybox.animate(o.$content, n, 366))
    }
    ,
    d.prototype.endZooming = function() {
        var t, e, n, o, a = this, s = a.instance.current, r = a.newWidth, l = a.newHeight;
        a.contentLastPos && (t = a.contentLastPos.left,
        o = {
            top: e = a.contentLastPos.top,
            left: t,
            width: r,
            height: l,
            scaleX: 1,
            scaleY: 1
        },
        i.fancybox.setTranslate(a.$content, o),
        r < a.canvasWidth && l < a.canvasHeight ? a.instance.scaleToFit(150) : r > s.width || l > s.height ? a.instance.scaleToActual(a.centerPointStartX, a.centerPointStartY, 150) : (n = a.limitPosition(t, e, r, l),
        i.fancybox.animate(a.$content, n, 150)))
    }
    ,
    d.prototype.onTap = function(e) {
        var n, o = this, s = i(e.target), r = o.instance, l = r.current, c = e && a(e) || o.startPoints, d = c[0] ? c[0].x - i(t).scrollLeft() - o.stagePos.left : 0, u = c[0] ? c[0].y - i(t).scrollTop() - o.stagePos.top : 0, p = function(t) {
            var n = l.opts[t];
            if (i.isFunction(n) && (n = n.apply(r, [l, e])),
            n)
                switch (n) {
                case "close":
                    r.close(o.startEvent);
                    break;
                case "toggleControls":
                    r.toggleControls();
                    break;
                case "next":
                    r.next();
                    break;
                case "nextOrClose":
                    r.group.length > 1 ? r.next() : r.close(o.startEvent);
                    break;
                case "zoom":
                    "image" == l.type && (l.isLoaded || l.$ghost) && (r.canPan() ? r.scaleToFit() : r.isScaledDown() ? r.scaleToActual(d, u) : r.group.length < 2 && r.close(o.startEvent))
                }
        };
        if ((!e.originalEvent || 2 != e.originalEvent.button) && (s.is("img") || !(d > s[0].clientWidth + s.offset().left))) {
            if (s.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"))
                n = "Outside";
            else if (s.is(".fancybox-slide"))
                n = "Slide";
            else {
                if (!r.current.$content || !r.current.$content.find(s).addBack().filter(s).length)
                    return;
                n = "Content"
            }
            if (o.tapped) {
                if (clearTimeout(o.tapped),
                o.tapped = null,
                Math.abs(d - o.tapX) > 50 || Math.abs(u - o.tapY) > 50)
                    return this;
                p("dblclick" + n)
            } else
                o.tapX = d,
                o.tapY = u,
                l.opts["dblclick" + n] && l.opts["dblclick" + n] !== l.opts["click" + n] ? o.tapped = setTimeout((function() {
                    o.tapped = null,
                    r.isAnimating || p("click" + n)
                }
                ), 500) : p("click" + n);
            return this
        }
    }
    ,
    i(e).on("onActivate.fb", (function(t, e) {
        e && !e.Guestures && (e.Guestures = new d(e))
    }
    )).on("beforeClose.fb", (function(t, e) {
        e && e.Guestures && e.Guestures.destroy()
    }
    ))
}(window, document, jQuery),
function(t, e) {
    "use strict";
    e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
            slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>'
        },
        slideShow: {
            autoStart: !1,
            speed: 3e3,
            progress: !0
        }
    });
    var i = function(t) {
        this.instance = t,
        this.init()
    };
    e.extend(i.prototype, {
        timer: null,
        isActive: !1,
        $button: null,
        init: function() {
            var t = this
              , i = t.instance
              , n = i.group[i.currIndex].opts.slideShow;
            t.$button = i.$refs.toolbar.find("[data-fancybox-play]").on("click", (function() {
                t.toggle()
            }
            )),
            i.group.length < 2 || !n ? t.$button.hide() : n.progress && (t.$progress = e('<div class="fancybox-progress"></div>').appendTo(i.$refs.inner))
        },
        set: function(t) {
            var i = this
              , n = i.instance
              , o = n.current;
            o && (!0 === t || o.opts.loop || n.currIndex < n.group.length - 1) ? i.isActive && "video" !== o.contentType && (i.$progress && e.fancybox.animate(i.$progress.show(), {
                scaleX: 1
            }, o.opts.slideShow.speed),
            i.timer = setTimeout((function() {
                n.current.opts.loop || n.current.index != n.group.length - 1 ? n.next() : n.jumpTo(0)
            }
            ), o.opts.slideShow.speed)) : (i.stop(),
            n.idleSecondsCounter = 0,
            n.showControls())
        },
        clear: function() {
            var t = this;
            clearTimeout(t.timer),
            t.timer = null,
            t.$progress && t.$progress.removeAttr("style").hide()
        },
        start: function() {
            var t = this
              , e = t.instance.current;
            e && (t.$button.attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause"),
            t.isActive = !0,
            e.isComplete && t.set(!0),
            t.instance.trigger("onSlideShowChange", !0))
        },
        stop: function() {
            var t = this
              , e = t.instance.current;
            t.clear(),
            t.$button.attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play"),
            t.isActive = !1,
            t.instance.trigger("onSlideShowChange", !1),
            t.$progress && t.$progress.removeAttr("style").hide()
        },
        toggle: function() {
            var t = this;
            t.isActive ? t.stop() : t.start()
        }
    }),
    e(t).on({
        "onInit.fb": function(t, e) {
            e && !e.SlideShow && (e.SlideShow = new i(e))
        },
        "beforeShow.fb": function(t, e, i, n) {
            var o = e && e.SlideShow;
            n ? o && i.opts.slideShow.autoStart && o.start() : o && o.isActive && o.clear()
        },
        "afterShow.fb": function(t, e, i) {
            var n = e && e.SlideShow;
            n && n.isActive && n.set()
        },
        "afterKeydown.fb": function(i, n, o, a, s) {
            var r = n && n.SlideShow;
            !r || !o.opts.slideShow || 80 !== s && 32 !== s || e(t.activeElement).is("button,a,input") || (a.preventDefault(),
            r.toggle())
        },
        "beforeClose.fb onDeactivate.fb": function(t, e) {
            var i = e && e.SlideShow;
            i && i.stop()
        }
    }),
    e(t).on("visibilitychange", (function() {
        var i = e.fancybox.getInstance()
          , n = i && i.SlideShow;
        n && n.isActive && (t.hidden ? n.clear() : n.set())
    }
    ))
}(document, jQuery),
function(t, e) {
    "use strict";
    var i = function() {
        for (var e = [["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"], ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"], ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"], ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"], ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]], i = {}, n = 0; n < e.length; n++) {
            var o = e[n];
            if (o && o[1]in t) {
                for (var a = 0; a < o.length; a++)
                    i[e[0][a]] = o[a];
                return i
            }
        }
        return !1
    }();
    if (i) {
        var n = {
            request: function(e) {
                (e = e || t.documentElement)[i.requestFullscreen](e.ALLOW_KEYBOARD_INPUT)
            },
            exit: function() {
                t[i.exitFullscreen]()
            },
            toggle: function(e) {
                e = e || t.documentElement,
                this.isFullscreen() ? this.exit() : this.request(e)
            },
            isFullscreen: function() {
                return Boolean(t[i.fullscreenElement])
            },
            enabled: function() {
                return Boolean(t[i.fullscreenEnabled])
            }
        };
        e.extend(!0, e.fancybox.defaults, {
            btnTpl: {
                fullScreen: '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>'
            },
            fullScreen: {
                autoStart: !1
            }
        }),
        e(t).on(i.fullscreenchange, (function() {
            var t = n.isFullscreen()
              , i = e.fancybox.getInstance();
            i && (i.current && "image" === i.current.type && i.isAnimating && (i.isAnimating = !1,
            i.update(!0, !0, 0),
            i.isComplete || i.complete()),
            i.trigger("onFullscreenChange", t),
            i.$refs.container.toggleClass("fancybox-is-fullscreen", t),
            i.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter", !t).toggleClass("fancybox-button--fsexit", t))
        }
        ))
    }
    e(t).on({
        "onInit.fb": function(t, e) {
            var o;
            i ? e && e.group[e.currIndex].opts.fullScreen ? ((o = e.$refs.container).on("click.fb-fullscreen", "[data-fancybox-fullscreen]", (function(t) {
                t.stopPropagation(),
                t.preventDefault(),
                n.toggle()
            }
            )),
            e.opts.fullScreen && !0 === e.opts.fullScreen.autoStart && n.request(),
            e.FullScreen = n) : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide() : e.$refs.toolbar.find("[data-fancybox-fullscreen]").remove()
        },
        "afterKeydown.fb": function(t, e, i, n, o) {
            e && e.FullScreen && 70 === o && (n.preventDefault(),
            e.FullScreen.toggle())
        },
        "beforeClose.fb": function(t, e) {
            e && e.FullScreen && e.$refs.container.hasClass("fancybox-is-fullscreen") && n.exit()
        }
    })
}(document, jQuery),
function(t, e) {
    "use strict";
    var i = "fancybox-thumbs";
    e.fancybox.defaults = e.extend(!0, {
        btnTpl: {
            thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>'
        },
        thumbs: {
            autoStart: !1,
            hideOnClose: !0,
            parentEl: ".fancybox-container",
            axis: "y"
        }
    }, e.fancybox.defaults);
    var n = function(t) {
        this.init(t)
    };
    e.extend(n.prototype, {
        $button: null,
        $grid: null,
        $list: null,
        isVisible: !1,
        isActive: !1,
        init: function(t) {
            var e = this
              , i = t.group
              , n = 0;
            e.instance = t,
            e.opts = i[t.currIndex].opts.thumbs,
            t.Thumbs = e,
            e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]");
            for (var o = 0, a = i.length; o < a && (i[o].thumb && n++,
            !(n > 1)); o++)
                ;
            n > 1 && e.opts ? (e.$button.removeAttr("style").on("click", (function() {
                e.toggle()
            }
            )),
            e.isActive = !0) : e.$button.hide()
        },
        create: function() {
            var t, n = this, o = n.instance, a = n.opts.parentEl, s = [];
            n.$grid || (n.$grid = e('<div class="' + i + " " + i + "-" + n.opts.axis + '"></div>').appendTo(o.$refs.container.find(a).addBack().filter(a)),
            n.$grid.on("click", "a", (function() {
                o.jumpTo(e(this).attr("data-index"))
            }
            ))),
            n.$list || (n.$list = e('<div class="' + i + '__list">').appendTo(n.$grid)),
            e.each(o.group, (function(e, i) {
                (t = i.thumb) || "image" !== i.type || (t = i.src),
                s.push('<a href="javascript:;" tabindex="0" data-index="' + e + '"' + (t && t.length ? ' style="background-image:url(' + t + ')"' : 'class="fancybox-thumbs-missing"') + "></a>")
            }
            )),
            n.$list[0].innerHTML = s.join(""),
            "x" === n.opts.axis && n.$list.width(parseInt(n.$grid.css("padding-right"), 10) + o.group.length * n.$list.children().eq(0).outerWidth(!0))
        },
        focus: function(t) {
            var e, i, n = this, o = n.$list, a = n.$grid;
            n.instance.current && (i = (e = o.children().removeClass("fancybox-thumbs-active").filter('[data-index="' + n.instance.current.index + '"]').addClass("fancybox-thumbs-active")).position(),
            "y" === n.opts.axis && (i.top < 0 || i.top > o.height() - e.outerHeight()) ? o.stop().animate({
                scrollTop: o.scrollTop() + i.top
            }, t) : "x" === n.opts.axis && (i.left < a.scrollLeft() || i.left > a.scrollLeft() + (a.width() - e.outerWidth())) && o.parent().stop().animate({
                scrollLeft: i.left
            }, t))
        },
        update: function() {
            var t = this;
            t.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible),
            t.isVisible ? (t.$grid || t.create(),
            t.instance.trigger("onThumbsShow"),
            t.focus(0)) : t.$grid && t.instance.trigger("onThumbsHide"),
            t.instance.update()
        },
        hide: function() {
            this.isVisible = !1,
            this.update()
        },
        show: function() {
            this.isVisible = !0,
            this.update()
        },
        toggle: function() {
            this.isVisible = !this.isVisible,
            this.update()
        }
    }),
    e(t).on({
        "onInit.fb": function(t, e) {
            var i;
            e && !e.Thumbs && ((i = new n(e)).isActive && !0 === i.opts.autoStart && i.show())
        },
        "beforeShow.fb": function(t, e, i, n) {
            var o = e && e.Thumbs;
            o && o.isVisible && o.focus(n ? 0 : 250)
        },
        "afterKeydown.fb": function(t, e, i, n, o) {
            var a = e && e.Thumbs;
            a && a.isActive && 71 === o && (n.preventDefault(),
            a.toggle())
        },
        "beforeClose.fb": function(t, e) {
            var i = e && e.Thumbs;
            i && i.isVisible && !1 !== i.opts.hideOnClose && i.$grid.hide()
        }
    })
}(document, jQuery),
function(t, e) {
    "use strict";
    function i(t) {
        var e = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;",
            "`": "&#x60;",
            "=": "&#x3D;"
        };
        return String(t).replace(/[&<>"'`=\/]/g, (function(t) {
            return e[t]
        }
        ))
    }
    e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
            share: '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>'
        },
        share: {
            url: function(t, e) {
                return !t.currentHash && "inline" !== e.type && "html" !== e.type && (e.origSrc || e.src) || window.location
            },
            tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>'
        }
    }),
    e(t).on("click", "[data-fancybox-share]", (function() {
        var t, n, o = e.fancybox.getInstance(), a = o.current || null;
        a && ("function" === e.type(a.opts.share.url) && (t = a.opts.share.url.apply(a, [o, a])),
        n = a.opts.share.tpl.replace(/\{\{media\}\}/g, "image" === a.type ? encodeURIComponent(a.src) : "").replace(/\{\{url\}\}/g, encodeURIComponent(t)).replace(/\{\{url_raw\}\}/g, i(t)).replace(/\{\{descr\}\}/g, o.$caption ? encodeURIComponent(o.$caption.text()) : ""),
        e.fancybox.open({
            src: o.translate(o, n),
            type: "html",
            opts: {
                touch: !1,
                animationEffect: !1,
                afterLoad: function(t, e) {
                    o.$refs.container.one("beforeClose.fb", (function() {
                        t.close(null, 0)
                    }
                    )),
                    e.$content.find(".fancybox-share__button").click((function() {
                        return window.open(this.href, "Share", "width=550, height=450"),
                        !1
                    }
                    ))
                },
                mobile: {
                    autoFocus: !1
                }
            }
        }))
    }
    ))
}(document, jQuery),
function(t, e, i) {
    "use strict";
    function n() {
        var e = t.location.hash.substr(1), i = e.split("-"), n = i.length > 1 && /^\+?\d+$/.test(i[i.length - 1]) && parseInt(i.pop(-1), 10) || 1, o;
        return {
            hash: e,
            index: n < 1 ? 1 : n,
            gallery: i.join("-")
        }
    }
    function o(t) {
        "" !== t.gallery && i("[data-fancybox='" + i.escapeSelector(t.gallery) + "']").eq(t.index - 1).focus().trigger("click.fb-start")
    }
    function a(t) {
        var e, i;
        return !!t && ("" !== (i = (e = t.current ? t.current.opts : t.opts).hash || (e.$orig ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger") : "")) && i)
    }
    i.escapeSelector || (i.escapeSelector = function(t) {
        return (t + "").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, (function(t, e) {
            return e ? "\0" === t ? "ï¿½" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
        }
        ))
    }
    ),
    i((function() {
        !1 !== i.fancybox.defaults.hash && (i(e).on({
            "onInit.fb": function(t, e) {
                var i, o;
                !1 !== e.group[e.currIndex].opts.hash && (i = n(),
                (o = a(e)) && i.gallery && o == i.gallery && (e.currIndex = i.index - 1))
            },
            "beforeShow.fb": function(i, n, o, s) {
                var r;
                o && !1 !== o.opts.hash && (r = a(n)) && (n.currentHash = r + (n.group.length > 1 ? "-" + (o.index + 1) : ""),
                t.location.hash !== "#" + n.currentHash && (s && !n.origHash && (n.origHash = t.location.hash),
                n.hashTimer && clearTimeout(n.hashTimer),
                n.hashTimer = setTimeout((function() {
                    "replaceState"in t.history ? (t.history[s ? "pushState" : "replaceState"]({}, e.title, t.location.pathname + t.location.search + "#" + n.currentHash),
                    s && (n.hasCreatedHistory = !0)) : t.location.hash = n.currentHash,
                    n.hashTimer = null
                }
                ), 300)))
            },
            "beforeClose.fb": function(i, n, o) {
                o && !1 !== o.opts.hash && (clearTimeout(n.hashTimer),
                n.currentHash && n.hasCreatedHistory ? t.history.back() : n.currentHash && ("replaceState"in t.history ? t.history.replaceState({}, e.title, t.location.pathname + t.location.search + (n.origHash || "")) : t.location.hash = n.origHash),
                n.currentHash = null)
            }
        }),
        i(t).on("hashchange.fb", (function() {
            var t = n()
              , e = null;
            i.each(i(".fancybox-container").get().reverse(), (function(t, n) {
                var o = i(n).data("FancyBox");
                if (o && o.currentHash)
                    return e = o,
                    !1
            }
            )),
            e ? e.currentHash === t.gallery + "-" + t.index || 1 === t.index && e.currentHash == t.gallery || (e.currentHash = null,
            e.close()) : "" !== t.gallery && o(t)
        }
        )),
        setTimeout((function() {
            i.fancybox.getInstance() || o(n())
        }
        ), 50))
    }
    ))
}(window, document, jQuery),
function(t, e) {
    "use strict";
    var i = (new Date).getTime();
    e(t).on({
        "onInit.fb": function(t, e, n) {
            e.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", (function(t) {
                var n = e.current
                  , o = (new Date).getTime();
                e.group.length < 2 || !1 === n.opts.wheel || "auto" === n.opts.wheel && "image" !== n.type || (t.preventDefault(),
                t.stopPropagation(),
                n.$slide.hasClass("fancybox-animated") || (t = t.originalEvent || t,
                o - i < 250 || (i = o,
                e[(-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0 ? "next" : "previous"]())))
            }
            ))
        }
    })
}(document, jQuery);
var featuredCollectionSection = {
    init: function() {
        $(".js-product-slider .products-slider").each((function(t, e) {
            var i, n, o, a, s, r = $(this).data("products-per-slide"), l = $(this).data("products-limit"), c = $(this).data("products-available");
            i = "2" == r && r < c && r < l || "4" == r && r < c && r < l || "6" == r && r < c && r < l ? "left" : "center",
            a = o = n = r < c && r < l,
            "2" == r && r < c || "4" == r && r < c || "6" == r && r < c ? s = 0 : "3" == r && c ? s = 1 : "5" == r && c ? s = 2 : "7" == r && c && (s = 3),
            $(window).width() <= 798 && (i = "center",
            a = o = n = !0,
            s = 1,
            $(this).parents(".even-num-slides").removeClass("even-num-slides")),
            $(this).flickity({
                lazyLoad: 2,
                imagesLoaded: !0,
                draggable: n,
                prevNextButtons: o,
                wrapAround: a,
                cellAlign: i,
                pageDots: usePageDots,
                contain: !0,
                freeScroll: !0,
                arrowShape: arrowSize,
                initialIndex: s
            }),
            $(this).addClass("slider-initialized")
        }
        ))
    },
    unload: function(t) {
        var e = t.find(".js-product-slider");
        e.hasClass("flickity-enabled") && e.flickity("destroy")
    }
};
var featuredPromotions = {
    init: function() {
        (798 < $(window).width() || 0 == $(window).width()) && ($(".feature-overlay").hover((function() {
            $(this).find(".feature-details").slideDown("100", (function() {
                $(this).addClass("reveal-details")
            }
            ))
        }
        ), (function() {
            $(this).find(".feature-details").removeClass("reveal-details"),
            $(this).find(".feature-details").slideUp("100")
        }
        )),
        $(".js-featured-promotions").each((function(t, e) {
            var i = $(this)
              , n = $(this).data("promo-animation");
            i.waypoint((function() {
                $(this.element).find(".feature-section").addClass("animated " + n)
            }
            ), {
                offset: "80%"
            })
        }
        )))
    }
};
var slideshow = {
    init: function() {
        $(".js-homepage-slideshow").each((function(t, e) {
            var i = $(this)
              , n = {
                slideshowSpeed: 1e3 * i.data("slideshow-speed"),
                slideshowTextAnimation: i.data("slideshow-text-animation"),
                adaptiveHeight: i.data("adaptive-height")
            };
            if (!i.hasClass("flickity-enabled")) {
                var o = 1 !== i.find(".gallery-cell").length;
                if (i.flickity({
                    adaptiveHeight: n.adaptiveHeight,
                    wrapAround: !0,
                    cellAlign: "left",
                    imagesLoaded: !0,
                    prevNextButtons: o,
                    draggable: o,
                    pageDots: usePageDots,
                    autoPlay: n.slideshowSpeed,
                    arrowShape: arrowSize
                }),
                "" != n.slideshowTextAnimation) {
                    var a = i.data("flickity");
                    setTimeout((function() {
                        i.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + n.slideshowTextAnimation)
                    }
                    ), 400),
                    i.on("select.flickity", (function() {
                        if (i.is(":visible")) {
                            var t = a.selectedIndex + 1;
                            setTimeout((function() {
                                i.find(".caption-content").removeClass("animated " + n.slideshowTextAnimation),
                                i.find(".gallery-cell:nth-child(" + t + ") .caption-content").addClass("animated " + n.slideshowTextAnimation)
                            }
                            ), 400)
                        }
                    }
                    ))
                }
            }
            1 < i.find(".gallery-cell").length ? i.addClass("multi-image") : i.addClass("single-image"),
            i.find(".gallery-cell").each((function() {
                var t = 0;
                $(this).find(".action_button").each((function() {
                    $button = $(this),
                    $(this).width() > t && (t = $(this).width())
                }
                )),
                $(this).find(".action_button").width(t)
            }
            ))
        }
        ))
    },
    unload: function(t) {
        t.find(".js-homepage-slideshow").flickity("destroy")
    }
};
var testimonial = {
    init: function() {
        $(".js-testimonial").each((function(t, e) {
            var i = $(this)
              , n = {
                slideshowSpeed: 1e3 * i.data("slideshow-speed"),
                slideshowTextAnimation: i.data("slideshow-text-animation")
            };
            if (0 < $(".testimonial-image").length && $(".testimonial-block").each((function() {
                if (0 == $(this).find(".testimonial-image").length) {
                    var t = $(this).closest(".testimonial-block");
                    $(t).addClass("set-testimonial-height")
                }
            }
            )),
            !i.hasClass("flickity-enabled")) {
                var o = 1 !== i.find(".gallery-cell").length;
                if (i.flickity({
                    wrapAround: !0,
                    cellAlign: "left",
                    imagesLoaded: !0,
                    prevNextButtons: o,
                    draggable: o,
                    pageDots: usePageDots,
                    autoPlay: n.slideshowSpeed,
                    arrowShape: arrowSize
                }),
                "" != n.slideshowTextAnimation) {
                    var a = i.data("flickity");
                    setTimeout((function() {
                        i.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + n.slideshowTextAnimation)
                    }
                    ), 400),
                    i.on("select.flickity", (function() {
                        if (i.is(":visible")) {
                            var t = a.selectedIndex + 1;
                            setTimeout((function() {
                                i.find(".caption-content").removeClass("animated " + n.slideshowTextAnimation),
                                i.find(".gallery-cell:nth-child(" + t + ") .caption-content").addClass("animated " + n.slideshowTextAnimation)
                            }
                            ), 400)
                        }
                    }
                    ))
                }
            }
            1 < i.find(".gallery-cell").length ? i.addClass("multi-image") : i.addClass("single-image"),
            i.find(".gallery-cell").each((function() {
                var t = 0;
                $(this).find(".action_button").each((function() {
                    $button = $(this),
                    $(this).width() > t && (t = $(this).width())
                }
                )),
                $(this).find(".action_button").width(t)
            }
            ))
        }
        ))
    },
    unload: function(t) {
        t.find(".js-testimonial").flickity("destroy")
    }
};
var gallery = {
    init: function() {
        $(".gallery-horizontal").find(".gallery-image-wrapper").each((function() {
            var t, e, i = $(this), n = $(this).find("img");
            $("<img />").attr("src", $(n).attr("src")).on("load", (function() {
                t = this.width,
                e = this.height,
                $(i).css("flex-basis", 200 * t / e),
                $(i).css("flex-grow", 200 * t / e),
                $(i).find("i").css("padding-bottom", e / t * 100 + "%")
            }
            ))
        }
        )),
        $("[rel=gallery]").length && $("[rel=gallery]").fancybox({
            baseClass: "gallery-section__lightbox",
            clickContent: "nextOrClose"
        })
    }
};
var supports_video = function() {
    return !!document.createElement("video").canPlayType
}
  , videoSection = {
    init: function() {
        function t(t) {
            t.find(".caption").not(".display-mobile-text").hide(),
            t.find(".caption").not(".display-mobile-text").find(".action_button").hide()
        }
        $(".js-video.lazyframe").each((function(t, e) {
            if ($(e).hasClass("showPosterImage--true")) {
                var i = $(e).closest(".video-section").attr("id");
                lazyframe("#" + i + " .lazyframe.showPosterImage--true", {
                    initinview: !1
                })
            } else
                i = $(e).closest(".video-section").attr("id"),
                lazyframe("#" + i + " .lazyframe.showPosterImage--false", {
                    initinview: !0,
                    onLoad: function(t) {
                        $(e).find("iframe").slice(1).remove()
                    }
                })
        }
        )),
        $(".js-video").hasClass("hide-text-on-video") && $(".js-video").hasClass("video-autoplay--true") && t($(".js-video.hide-text-on-video.video-autoplay--true")),
        $(".video-section .lazyvideo.hide-text-on-video").on("click", (function() {
            t($(this).parents(".js-video-section"))
        }
        )),
        $("[data-play-video-button], video.hide-text-on-video").on("click", (function() {
            var e = $(this).parents(".js-video-section")
              , i = e.find(".lazyframe")
              , n = e.find(".js-video");
            if (n.data("mp4") || n.data("ogv"))
                e.find(".js-video.hide-text-on-video").length && t(e);
            else {
                var o = document.createElement("iframe");
                iframeSrc = i.data("src"),
                cleanIframeSrc = iframeSrc.substring(0, iframeSrc.indexOf("?")) + "?&autoplay=1",
                o.src = cleanIframeSrc,
                o.setAttribute("allowfullscreen", !0),
                o.setAttribute("frameborder", 0),
                i.append(o),
                e.find(".js-video.hide-text-on-video").length && t(e)
            }
        }
        ))
    },
    unload: function(t) {
        t.find("[data-play-video]").off("click"),
        t.find("video.hide-text-on-video").off("click")
    }
};
var cart = {
    init: function() {
        $("#cart_form .tos_agree").length && $("body").on("click", "#cart_form input[type='submit']", (function() {
            if (!$(this).parents("form").find(".tos_agree").is(":checked")) {
                var t = '<p class="warning animated bounceIn">' + Shopify.translation.agree_to_terms_warning + "</p>";
                return 0 == $("p.warning").length && $(this).before(t),
                !1
            }
            $(this).submit()
        }
        )),
        $("body").hasClass("cart") && $(".product_form form").on("submit", (function() {
            setTimeout((function() {
                document.location.href = "/cart"
            }
            ), 500)
        }
        ))
    }
};
selectCallback = function(t, e) {
    var i = $(".product-" + e.product.id)
      , n = $(".notify-form-" + e.product.id)
      , o = $(".product_form, .shopify-product-form", i)
      , a = o.data("variant-inventory")
      , s = $(".notify_form__inputs")
      , r = Shopify.translation.notify_email
      , l = "{{ contact.fields.email }}"
      , c = Shopify.translation.notify_email_send
      , d = s.data("url");
    if (t)
        var u = Shopify.translation.notify_message_first + t.title + Shopify.translation.notify_message_last + d;
    if (s.hasClass("customer--true"))
        var p, h = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="' + "{{ customer.email }}" + '" />';
    else
        h = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="' + r + '" value="' + l + '" />';
    var f = h + '<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="' + u + '" value="' + u + '" /><input class="action_button" type="submit" value="' + c + '" style="margin-bottom:0px" />';
    var m;
    t && t.featured_image && i.is(":visible") && $(".js-product-gallery, .js-gallery-modal", i).each((function() {
        var e = $(this)
          , i = Flickity.data(this);
        if (e.is(":visible") && null != i) {
            var n = $('[data-image-id="' + t.featured_image.id + '"]').data("index");
            i.select(n, !1, !0)
        }
    }
    ));
    if (t)
        if (a && a.forEach((function(e) {
            e.id === t.id && (t.inventory_quantity = e.inventory_quantity,
            t.inventory_management = e.inventory_management,
            t.inventory_policy = e.inventory_policy)
        }
        )),
        $(".sku span", i).text(t.sku),
        "swatches" == Shopify.theme_settings.product_form_style)
            for (var g = 0, y = t.options.length; g < y; g++) {
                var v = o.find('.swatch[data-option-index="' + escape(g) + '"] :radio[value="' + t.options[g].replace(/\"/g, '\\"') + '"]');
                v.length && (v.get(0).checked = !0)
            }
        else
            $(".notify_form_message", i).attr("value", $(".notify_form_message", i).data("body") + " - " + t.title);
    if (t && 1 == t.available) {
        if (t.price < t.compare_at_price ? ($(".was_price", i).html('<span class="money">' + Shopify.formatMoney(t.compare_at_price, $("body").data("money-format")) + "</span>"),
        $(".savings", i).html(Shopify.translation.savings_text + " " + parseInt(100 * (t.compare_at_price - t.price) / t.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(t.compare_at_price - t.price, $("body").data("money-format")) + "</span>)"),
        $(".current_price", i).parent().addClass("sale")) : ($(".was_price", i).html(""),
        $(".savings", i).html(""),
        $(".current_price", i).parent().removeClass("sale")),
        t.inventory_management && 0 < t.inventory_quantity) {
            if (Shopify.theme_settings.display_inventory_left) {
                items_left_text = 1 == t.inventory_quantity ? Shopify.translation.one_item_left : Shopify.translation.items_left_text;
                var b = parseInt(Shopify.theme_settings.inventory_threshold);
                t.inventory_quantity <= b ? $(".items_left", i).html(t.inventory_quantity + " " + items_left_text) : $(".items_left", i).html("")
            }
            Shopify.theme_settings.limit_quantity && "deny" == t.inventory_policy && $(".quantity", i).attr("max", t.inventory_quantity)
        } else
            $(".items_left", i).text(""),
            $(".quantity", i).removeAttr("max");
        $(".sold_out", i).text(""),
        0 < t.price ? $(".current_price", i).removeClass("sold_out").html('<span class="money">' + Shopify.formatMoney(t.price, $("body").data("money-format")) + "</span>") : $(".current_price", i).removeClass("sold_out").html(Shopify.theme_settings.free_text),
        $(".add_to_cart", i).removeClass("disabled").removeAttr("disabled").find("span").text($(".add_to_cart", i).data("label")),
        $(".shopify-payment-button", i).removeClass("disabled"),
        $(".purchase-details__buttons", i).removeClass("product-is-unavailable"),
        $(".modal_price", i).removeClass("variant-unavailable"),
        n.hide(),
        s.empty()
    } else {
        var w = t ? Shopify.theme_settings.sold_out_text : Shopify.translation.unavailable_text;
        t ? (0 < t.price ? $(".current_price", i).html('<span class="money">' + Shopify.formatMoney(t.price, $("body").data("money-format")) + "</span>") : $(".current_price", i).html(Shopify.theme_settings.free_text),
        Shopify.theme_settings.display_sold_out_price && $(".current_price", i).parents(".price__container--display-price-true").addClass("has-margin-right"),
        $(".modal_price", i).removeClass("variant-unavailable")) : ($(".modal_price", i).addClass("variant-unavailable"),
        $(".current_price", i).html(""),
        $(".was_price", i).html(""),
        $(".savings", i).html(""),
        $(".current_price", i).parents(".price__container--display-price-true").removeClass("has-margin-right")),
        Shopify.theme_settings.display_sold_out_price || ($(".current_price", i).html(""),
        $(".was_price", i).html(""),
        $(".savings", i).html("")),
        $(".items_left", i).text(""),
        $(".quantity", i).removeAttr("max"),
        $(".sold_out", i).text(w),
        $(".purchase-details__buttons", i).addClass("product-is-unavailable"),
        $(".add_to_cart", i).addClass("disabled").attr("disabled", "disabled").find("span").text(w),
        $(".shopify-payment-button").addClass("disabled"),
        n.hide(),
        s.empty(),
        t && !t.available && (n.fadeIn(),
        s.empty(),
        s.append(f))
    }
    Shopify.theme_settings.show_multiple_currencies && convertCurrencies()
}
;
var productPage = {
    init: function() {
        var t = !0
          , e = !0
          , i = $(".js-product-gallery").data("autoplay");
        setTimeout((function() {
            imageFunctions.linkGalleryAndCarousel($(".js-product-page-gallery .js-product-gallery"), $(".js-product-page-gallery .product_gallery_nav"))
        }
        ), 1e3),
        $(".js-full-width-product-images").length && imageFunctions.fullWidth(".product-template .product .description img", ".js-full-width-product-images"),
        $(".js-product-gallery").hasClass("single-image") && (e = t = !1),
        $(".product_section .description").find("iframe").wrap('<div class="lazyframe" data-ratio="16:9"></div>'),
        is_touch_device() && $(".js-product-gallery").hasClass("popup-enabled--false") ? (imageFunctions.zoom(".js-product-gallery"),
        t = !1) : imageFunctions.zoom(".js-product-gallery", !1),
        $(".js-product-gallery").flickity({
            adaptiveHeight: !0,
            wrapAround: "true",
            cellAlign: "left",
            draggable: t,
            contain: !0,
            imagesLoaded: !0,
            lazyLoad: 2,
            pageDots: !1,
            prevNextButtons: e,
            autoPlay: !!i && 6e3,
            dragThreshold: 10,
            arrowShape: arrowSize
        });
        var n = !0
          , o = !1
          , a = !1;
        7 <= $(".product_gallery_nav .gallery-cell").length && (a = o = !(n = !"left")),
        $(".product-template .product_gallery_nav.product_gallery_nav--bottom-slider").flickity({
            asNavFor: ".product_gallery",
            adaptiveHeight: !1,
            wrapAround: a,
            cellAlign: "left",
            draggable: !0,
            groupCells: n,
            prevNextButtons: o,
            pageDots: !1,
            lazyLoad: 2,
            dragThreshold: 10,
            arrowShape: arrowSize
        }),
        "?contact_posted=true" === window.location.search && ($(".notify_form .contact-form").hide(),
        $(".notify_form .contact-form").prev(".message").html(Shopify.translation.notify_success_text)),
        $(".notify_form .contact-form").each((function() {
            var t = $(this);
            t.on("submit", (function(e) {
                "true" !== $('input[name="challenge"]', t).val() && ($.ajax({
                    type: t.attr("method"),
                    url: t.attr("action"),
                    data: t.serialize(),
                    success: function(e) {
                        t.fadeOut("slow", (function() {
                            t.prev(".message").html(Shopify.translation.notify_success_text)
                        }
                        ))
                    },
                    error: function(e) {
                        $('input[name="challenge"]', t).val("true"),
                        t.submit()
                    }
                }),
                e.preventDefault())
            }
            ))
        }
        )),
        "swatches" == Shopify.theme_settings.product_form_style && $("body").on("change", ".swatch :radio", (function() {
            var t = $(this).closest(".swatch").attr("data-option-index")
              , e = $(this).val()
              , i = $(this).closest(".product_form form");
            if (i.siblings(".notify_form").length)
                var n = i.siblings(".notify_form");
            else
                n = $(".js-notify-form");
            var o = i.find(".swatch_options input:checked").eq(0).val()
              , a = i.find(".swatch_options input:checked").eq(1).val() || ""
              , s = i.find(".swatch_options input:checked").eq(2).val() || "";
            if (o && a && s)
                var r = o + " / " + a + " / " + s;
            else
                r = o && a ? o + " / " + a : o;
            n.find(".notify_form_message").attr("value", n.find(".notify_form_message").data("body") + " - " + r),
            $(this).closest("form").find(".single-option-selector").eq(t).val(e).trigger("change")
        }
        )),
        $(".js-product-gallery a").fancybox({
            baseClass: "product-section__lightbox",
            clickContent: !1,
            afterShow: function(t, e) {
                t.$trigger.first().parents(".js-product-gallery").data("zoom") && $(".fancybox-image").wrap('<span class="zoom-wrap" style="display:inline-block"></span>').css("display", "block").parent().zoom({
                    touch: !1,
                    magnify: 1
                })
            },
            afterClose: function(t, e) {
                const i = t.$trigger.first().parents(".js-product-gallery");
                i.hide(),
                setTimeout((function() {
                    i.fadeIn(100)
                }
                ), 1)
            }
        }),
        $(".js-product_section .product_form_options").each((function() {
            new Shopify.OptionSelectors($(this).data("select-id"),{
                product: $(this).data("product"),
                onVariantSelected: selectCallback,
                enableHistoryState: $(this).data("enable-state")
            })
        }
        )),
        $(".product-recommendations-container").length && productPage.loadProductRecommendations()
    },
    loadProductRecommendations: function() {
        var t = $(".meta-related-recommended-collection")
          , e = $(".product-recommendations")
          , i = e.data("productId")
          , n = e.data("limit")
          , o = e.data("enabled")
          , a = t.data("enabled")
          , s = $("[data-product-recommendations-container]")
          , r = $(".js-recommended-products-slider");
        if (t.length) {
            if (!a)
                return void s.empty();
            s.html(t.html()),
            r.length && this.recommendedProductsSlider(),
            $("[data-product-recommendations-container] .js-product_section .product_form_options").each((function() {
                0 === $(this).find("select").length && new Shopify.OptionSelectors($(this).data("select-id"),{
                    product: $(this).data("product"),
                    onVariantSelected: selectCallback,
                    enableHistoryState: $(this).data("enable-state")
                })
            }
            )),
            Shopify.PaymentButton && Shopify.PaymentButton.init(),
            $(".recommended-products-section").empty()
        } else if (e.length) {
            if (!o)
                return void s.empty();
            $.ajax({
                type: "GET",
                url: "/recommendations/products?section_id=product-recommendations&limit=" + n + "&product_id=" + i,
                success: function(t) {
                    var e = $(t).find(".product-recommendations").html();
                    s.empty(),
                    s.html(e),
                    r.length && productPage.recommendedProductsSlider(),
                    $("[data-product-recommendations-container] .js-product_section .product_form_options").each((function() {
                        new Shopify.OptionSelectors($(this).data("select-id"),{
                            product: $(this).data("product"),
                            onVariantSelected: selectCallback,
                            enableHistoryState: $(this).data("enable-state")
                        })
                    }
                    )),
                    Shopify.PaymentButton && Shopify.PaymentButton.init(),
                    0 === $("[data-recommended-product-count]").data() && $("[data-product-recommendations-container]").hide()
                }
            })
        } else
            s.hide()
    },
    productSwatches: function() {
        if ("swatches" == Shopify.theme_settings.product_form_style) {
            if ($(".js-product_section").length) {
                var t = $(".js-product_section").find(".product_form");
                t.addClass("is-visible"),
                t.each((function() {
                    var t = $(this).data("product")
                      , e = ".product-" + $(this).data("product-id") + " .js-product_section";
                    $(this).find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(t, e)
                }
                ))
            }
            $(".js-product_section").length > 1 && $("body").on("click", ".swatch-element", (function() {
                var t = $(this).data("value").toString();
                $(this).siblings('input[value="' + t.replace(/\"/g, '\\"') + '"]').prop("checked", !0).trigger("change");
                var e = $(this).parents(".product_form").data("product")
                  , i = ".product-" + $(this).parents(".product_form").data("product-id") + " .js-product_section";
                $(this).parents(".product_form").find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(e, i)
            }
            ))
        }
    },
    recommendedProductsSlider: function() {
        $(".js-recommended-products-slider .products-slider").each((function(t, e) {
            var i, n, o, a, s, r = $(this).data("products-per-slide"), l = $(this).data("products-limit"), c = $(this).data("products-available");
            i = "2" == r && c > r && l > r || "4" == r && c > r && l > r || "6" == r && c > r && l > r ? "left" : "center",
            c > r && l > r ? (n = !0,
            o = !0,
            a = !0) : (n = !1,
            o = !1,
            a = !1),
            "2" == r && c > r || "4" == r && c > r || "6" == r && c > r ? s = 0 : "3" == r && c ? s = 1 : "5" == r && c ? s = 2 : "7" == r && c && (s = 3),
            $(window).width() <= 798 && (i = "center",
            n = !0,
            o = !0,
            a = !0,
            s = 1,
            $(this).parents(".even-num-slides").removeClass("even-num-slides")),
            $(this).flickity({
                lazyLoad: 2,
                imagesLoaded: !0,
                draggable: n,
                cellAlign: i,
                prevNextButtons: o,
                wrapAround: a,
                pageDots: usePageDots,
                contain: !0,
                freeScroll: !0,
                arrowShape: arrowSize,
                initialIndex: s
            })
        }
        ))
    },
    initializeQuantityBox: function() {
        $("body").on("click", ".js-change-quantity", (function() {
            var t = $(this)
              , e = $(this).siblings("input")
              , i = parseInt(e.val())
              , n = 1e29
              , o = e.attr("min") || 0;
            return null != e.attr("max") && (n = e.attr("max")),
            isNaN(i) || i < o ? (e.val(o),
            !1) : i > n ? (e.val(n),
            !1) : ("plus" == t.data("func") ? i < n && e.val(i + 1) : (i > o && e.val(i - 1),
            t.parents(".cart_item").length && i - 1 == 0 && t.closest(".cart_item").addClass("animated fadeOutUp")),
            void e.trigger("change"))
        }
        ))
    },
    unload: function(t) {
        t.find(".products-slider").flickity("destroy"),
        $("body").off("click", ".js-change-quantity")
    }
};
var header = {
    init: function() {
        function t() {
            $("body").removeClass("is-active").removeClass("blocked-scroll"),
            $(".dropdown_link").toggleClass("active_link"),
            $(".cart_container").removeClass("active_link")
        }
        $(".dropdown_link--vertical").length && ($(".dropdown_link--vertical, .vertical-menu_submenu").on("mouseover", (function(t) {
            $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]'),
            $(this).attr("data-click-count"),
            $(".active_link").removeClass("active_link"),
            $(this).hasClass("active_link") || ($(this).children("a").addClass("active_link"),
            $(".is-absolute").parent().removeClass("feature_image"))
        }
        )),
        is_touch_device() && $(".vertical-menu .sublink a, .vertical-menu_submenu .sublink a").on("touchstart click", (function(t) {
            t.stopPropagation();
            var e = $(this);
            function i(e) {
                var i = $(e).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
                  , n = $(e).next(".vertical-menu_submenu")
                  , o = $(e).attr("data-click-count");
                return $(".dropdown_link--vertical").not(e).attr("data-click-count", 0),
                $(".dropdown_link--vertical").attr("data-no-instant", !0),
                $(".dropdown_container").hide(),
                i.show(),
                $(".vertical-menu_submenu").removeClass("is-visible"),
                n.addClass("is-visible"),
                "touchstart" == t.type && (o++,
                $(e).attr("data-click-count", o),
                o < 2) && (t.preventDefault(),
                void t.stopPropagation())
            }
            "touchstart" == t.type ? (clicked = !0,
            $(this).attr("data-click-count") < 1 && (i(e),
            t.preventDefault())) : "click" != t.type || clicked ? clicked = !1 : $(this).attr("data-click-count") < 1 && (i(e),
            t.preventDefault())
        }
        ))),
        !$(".promo_banner").length || "dismiss" != Cookies.get("promo_banner") && ($("body").addClass("promo_banner-show"),
        $(".promo_banner").on("click", ".promo_banner-close", (function() {
            $("body").removeClass("promo_banner-show"),
            Cookies.set("promo_banner", "dismiss", {
                expires: 30
            })
        }
        ))),
        $(".vertical-menu_submenu, .vertical-menu_sub-submenu").each((function() {
            $(this).is(":off-right") && $(this).addClass("vertical-menu--align-right")
        }
        )),
        $("html").on("click", (function(e) {
            !$(e.target).closest(".cart_container").length && $(".cart_content").is(":visible") && t(),
            !$(e.target).closest(".dropdown_container").length && $(".dropdown").is(":visible") && ($("body").removeClass("is-active"),
            $(".dropdown_link").removeClass("active_link"),
            $(".dropdown_container").hide(),
            $(".mobile_nav").find("div").removeClass("open"))
        }
        )),
        798 < $(window).width() ? ($(".header").hasClass("header-fixed--true") ? ($("body").on("click", '.banner a[href^="#"]', (function(t) {
            t.preventDefault();
            var e = $(this).attr("href")
              , i = $(".main_nav_wrapper.sticky_nav").outerHeight();
            $("html, body").animate({
                scrollTop: $(e).offset().top - i
            }, 2e3)
        }
        )),
        $(".main_nav_wrapper").hasClass("sticky_nav") || new Headhesive(".main_nav_wrapper",{
            offset: 700,
            throttle: 300,
            classes: {
                clone: "sticky_nav",
                stick: "sticky_nav--stick",
                unstick: "sticky_nav--unstick"
            },
            onInit: function() {
                $(".sticky_nav .secondary_logo").css("display", "none"),
                $(".sticky_nav .primary_logo").css("display", "block"),
                $(".sticky_nav .icon-search").css("display", "block"),
                $(".sticky_nav .search_container").css("display", "none"),
                $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone()),
                "inline" == Shopify.theme_settings.menu_position ? $(".sticky_nav").height() : $(".sticky_nav .nav").height()
            },
            onStick: function() {
                $(".sticky_nav .mini_cart").css("height", $(".sticky_nav .main_nav").height() + 5),
                $(".sticky_nav .cart_content").css("top", $(".sticky_nav .main_nav").height())
            },
            onUnstick: function() {
                $(".cart_container").removeClass("active_link")
            }
        })) : ($(".header-fixed--true").removeClass("header-fixed--true"),
        1 < $(".main_nav_wrapper").length && $(".main_nav_wrapper").first().remove()),
        $("img.primary_logo:visible") ? $(".logo img", $(".feature_image .header")).attr("src", $(".logo img").data("src-home")) : $(".logo img").attr("src", $(".logo img").data("src"))) : $("#header").hasClass("mobile_nav-fixed--true") ? ($("body").addClass("mobile_nav-fixed--true"),
        $("body").on("click", '.banner a[href^="#"]', (function(t) {
            t.preventDefault();
            var e = $(this).attr("href")
              , i = $("#header").outerHeight();
            $("html, body").animate({
                scrollTop: $(e).offset().top - i
            }, 2e3)
        }
        ))) : $("body").addClass("mobile_nav-fixed--false"),
        $("#header .cart_content").length < 1 && $("#header .cart_container").append($(".header .cart_content").clone()),
        is_touch_device() && $(window).width() <= 798 || $(window).width() <= 798 ? ($(".dropdown_link").attr("data-no-instant", !0),
        $("body").on("click", ".dropdown_link", (function(t) {
            if ($(".nav a").removeClass("active_link"),
            $("#header").is(":visible")) {
                var e = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
                $(this).hasClass("mini_cart") || $(".cart_container").removeClass("active_link")
            } else {
                if ($(this).hasClass("icon-search"))
                    return window.location = $(this).attr("href"),
                    !1;
                e = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
            }
            if (e.is(":visible") || void 0 === e.attr("class") ? (e.hide(),
            $("body").removeClass("is-active")) : ($(".dropdown_container").hide(),
            $(this).hasClass("cart_container") || $(".is-absolute").parent().removeClass("feature_image"),
            e.show(),
            $("body").addClass("is-active"),
            $(".mobile_nav").find("div").removeClass("open")),
            e.is(":visible"))
                return t.stopPropagation(),
                !1
        }
        )),
        $("body").on("click", ".mobile_nav", (function() {
            $(this).find("div").toggleClass("open")
        }
        )),
        "redirect_cart" != Shopify.theme_settings.cart_action && $(".mini_cart").on("click", (function(e) {
            var i, n = $(this).parent();
            n.hasClass("active_link") ? (t(),
            $("body").removeClass("blocked-scroll")) : (i = n,
            $("body").addClass("blocked-scroll"),
            $(".mobile_nav div").removeClass("open"),
            $(".dropdown_link").removeClass("active_link"),
            i.addClass("active_link"),
            $("body").addClass("blocked-scroll")),
            touch_device && e.preventDefault()
        }
        )),
        $(".cart_content__continue-shopping").on("click", (function(e) {
            t()
        }
        ))) : ($(".nav a, .logo a").not(".cart_content a").on("mouseenter", (function() {
            $(this).hasClass("active_link") || 0 != $(".dropdown_link--vertical").length || ($(".dropdown_container").hide(),
            $(".active_link").removeClass("active_link"),
            $(".is-absolute").parent().addClass("feature_image"))
        }
        )),
        $(".main_nav, .top_bar, .cart_container").on("mouseleave", (function() {
            798 < $(window).width() && $(".dropdown_container").hide(),
            $(".active_link").removeClass("active_link"),
            $(".is-absolute").parent().addClass("feature_image")
        }
        )),
        $(".dropdown_link, .dropdown_link--vertical").attr("data-click-count", 0),
        $(".dropdown_link").on("mouseover touchstart", (function(t) {
            798 < $(window).width() && $(".dropdown_container").hide();
            var e = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
              , i = $(this).attr("data-click-count");
            if ($(".active_link").removeClass("active_link"),
            $(this).hasClass("active_link") || (e.show(),
            $(this).hasClass("mini_cart") ? $(this).parent(".cart_container").addClass("active_link") : (798 < $(window).width() && $(this).addClass("active_link"),
            $(".is-absolute").parent().removeClass("feature_image"))),
            is_touch_device() && ($(".dropdown_link").not(this).attr("data-click-count", 0),
            $(".dropdown_link").attr("data-no-instant", !0),
            "touchstart" == t.type && (i++,
            $(this).attr("data-click-count", i),
            i < 2)))
                return t.preventDefault(),
                t.stopPropagation(),
                !1
        }
        )))
    },
    removeDataAttributes: function(t) {
        if ($(t).length) {
            var e, i = $(t), n = [], o = i.get(0).attributes, a = o.length;
            for (e = 0; e < a; e++)
                "data-" === o[e].name.substring(0, 5) && n.push(o[e].name);
            $.each(n, (function(t, e) {
                i.removeAttr(e)
            }
            ))
        }
    },
    loadMegaMenu: function() {
        $(".sticky_nav .mega-menu").remove(),
        $(".header .mega-menu").remove(),
        $(".mega-menu-container .mega-menu").clone().appendTo(".sticky_nav .main_nav"),
        header.removeDataAttributes(".sticky_nav .mega-menu.dropdown_container .dropdown_column"),
        $(".mega-menu-container .mega-menu").each((function(t) {
            var e = $(this).data("dropdown");
            $('[data-dropdown-rel="' + e + '"]').find("span").remove(),
            $('[data-dropdown-rel="' + e + '"]').not(".icon-search").append(' <span class="icon-down-arrow"></span>').addClass("mega-menu-parent").addClass("dropdown_link").removeClass("top_link"),
            $('[data-dropdown="' + e + '"]').each((function(t) {
                $(this).hasClass("mega-menu") || $(this).remove()
            }
            )),
            $(this).clone().appendTo(".header .main_nav")
        }
        )),
        $(".dropdown_link--vertical").length && ($(".dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu").remove(),
        $(".dropdown_link--vertical:not(.mega-menu-parent)").each((function(t) {
            var e = $(this).data("dropdown-rel");
            $('[data-dropdown="' + e + '"]').remove()
        }
        ))),
        $(".mega-menu-parent").on("mouseenter", (function() {
            $(this).hasClass("active_link") || ($(".dropdown_container").hide(),
            $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]').toggle(),
            $(this).addClass("active_link"),
            $(".is-absolute").parent().removeClass("feature_image"))
        }
        )),
        header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column"),
        (is_touch_device() || $(window).width() <= 798) && $(".dropdown_link").attr("data-no-instant", !0),
        header.loadMobileMegaMenu()
    },
    loadMobileMegaMenu: function() {
        $(".mega-menu-container .mobile-mega-menu").each((function(t) {
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find("span").remove(),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr("data-no-instant", "true"),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass("mobile-mega-menu-parent sublink"),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each((function(t) {
                $(this).hasClass("mobile-mega-menu") || $(this).remove()
            }
            ))
        }
        ))
    },
    unloadMegaMenu: function() {
        $(".header .mega-menu").remove(),
        $(".mega-menu-container .mega-menu").each((function(t) {
            $(this).data("dropdown"),
            $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find(".icon-down-arrow").remove()
        }
        ))
    },
    unload: function() {
        $("body").off("click", ".mobile_nav"),
        $("body").off("click", ".dropdown_link"),
        $("html").off("click"),
        $(".mini_cart").off("click"),
        $(".cart_content__continue-shopping").off("click"),
        $("body").off("click", '.banner a[href^="#"]'),
        $(".main_nav_wrapper.sticky_nav").remove()
    }
};
var social = {
    twitter: function() {
        $(".twitter-timeline").length && (window.twttr ? window.twttr.ready((function(t) {
            t.widgets.load(document.getElementById("twitter-timeline"))
        }
        )) : window.twttr = function(t, e, i) {
            var n, o, a = t.getElementsByTagName(e)[0];
            if (!t.getElementById(i))
                return (o = t.createElement(e)).id = i,
                o.src = "https://platform.twitter.com/widgets.js",
                a.parentNode.insertBefore(o, a),
                window.twttr || (n = {
                    _e: [],
                    ready: function(t) {
                        n._e.push(t)
                    }
                })
        }(document, "script", "twitter-wjs"))
    },
    unload: function() {}
};
var instagram = {
    loadContent: function(t) {
        if (t.clientID) {
            var e = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + t.clientID;
            $.ajax({
                type: "GET",
                url: e,
                dataType: "jsonp",
                success: function(e) {
                    if (200 === e.meta.code && e.data.length) {
                        e = e.data;
                        var i = 0;
                        t.el.empty();
                        for (var n = 0; n < e.length; n++) {
                            var o, a = e[n], s = a.images.low_resolution.url;
                            if (-1 < !a.images.low_resolution.url.indexOf("null") && (o = '<div class="il-photo__img instagram__bg" style="background-image:url(' + s + ')" data-filter="' + a.filter + '" /></div>',
                            o = '<a href="' + a.link + '" target="_blank" class="instagram__link">' + o + "</a>"),
                            a.videos && (o = '<div class="instagram__video instagram__bg" style="background-image:url(' + s + ')" data-filter="' + a.filter + '" /></div>',
                            o = '<a href="' + a.link + '" target="_blank" class="instagram__link instagram__video-link">' + o + "</a>"),
                            "" !== (o = o && '<div class="' + t.column + ' columns instagram__item small-down--one-whole">' + o + "</div>") && (t.el.append(o),
                            i++),
                            i == t.limit)
                                break
                        }
                    }
                },
                error: function() {}
            })
        }
    }
};
$(".social-feeds-wrap").each((function(t, e) {
    social.twitter();
    var i = $(this).find(".js-instafeed");
    instagram.loadContent({
        el: i,
        clientID: i.data("client-id"),
        limit: i.data("count"),
        column: i.data("column")
    })
}
));
var mapFunction = {
    init: function() {
        if (0 < $(".lazymap").length && lazyframe(".lazymap"),
        $(".maps").hasClass("js-api-map")) {
            var t = [];
            $(".map").each((function(e, i) {
                t.push(this),
                t[e].sectionid = $(this).data("id"),
                t[e].address = $(this).data("address"),
                t[e].directions = $(this).data("directions-address"),
                t[e].zoom = $(this).data("zoom"),
                t[e].mapstyle = $(this).data("style"),
                t[e].showpin = $(this).data("pin"),
                t[e].apikey = $(this).data("api-key")
            }
            )),
            $.each(t, (function(e, i) {
                $.ajaxSetup({
                    cache: !0
                }),
                $.getScript("https://maps.googleapis.com/maps/api/js?key=" + t[e].apikey).then((function() {
                    mapFunction.findLocation(t[e]),
                    $.ajaxSetup({
                        cache: !1
                    })
                }
                ))
            }
            ))
        }
    },
    findLocation: function(t) {
        var e, i, n;
        (new google.maps.Geocoder).geocode({
            address: t.address
        }, (function(n, o) {
            o == google.maps.GeocoderStatus.OK ? (e = n[0].geometry.location.lat(),
            i = n[0].geometry.location.lng(),
            mapFunction.initMap(e, i, t)) : console.log("Error:" + o)
        }
        ))
    },
    initMap: function(t, e, i) {
        var n = {
            lat: t,
            lng: e
        }
          , o = [];
        o = "aubergine" == i.mapstyle ? [{
            elementType: "geometry",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#8ec3b9"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1a3646"
            }]
        }, {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#4b6878"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#64779e"
            }]
        }, {
            featureType: "administrative.province",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#4b6878"
            }]
        }, {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#334e87"
            }]
        }, {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{
                color: "#023e58"
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#283d6a"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#6f9ba5"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{
                color: "#023e58"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#3C7680"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#304a7d"
            }]
        }, {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#98a5be"
            }]
        }, {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#2c6675"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#255763"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#b0d5ce"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#023e58"
            }]
        }, {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#98a5be"
            }]
        }, {
            featureType: "transit",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            featureType: "transit.line",
            elementType: "geometry.fill",
            stylers: [{
                color: "#283d6a"
            }]
        }, {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{
                color: "#3a4762"
            }]
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#0e1626"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#4e6d70"
            }]
        }] : "retro" == i.mapstyle ? [{
            elementType: "geometry",
            stylers: [{
                color: "#ebe3cd"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#523735"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#f5f1e6"
            }]
        }, {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#c9b2a6"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#dcd2be"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#ae9e90"
            }]
        }, {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#93817c"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{
                color: "#a5b076"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#447530"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#f5f1e6"
            }]
        }, {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{
                color: "#fdfcf8"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#f8c967"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#e9bc62"
            }]
        }, {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{
                color: "#e98d58"
            }]
        }, {
            featureType: "road.highway.controlled_access",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#db8555"
            }]
        }, {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#806b63"
            }]
        }, {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "transit.line",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#8f7d77"
            }]
        }, {
            featureType: "transit.line",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#ebe3cd"
            }]
        }, {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{
                color: "#b9d3c2"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#92998d"
            }]
        }] : "silver" == i.mapstyle ? [{
            elementType: "geometry",
            stylers: [{
                color: "#f5f5f5"
            }]
        }, {
            elementType: "labels.icon",
            stylers: [{
                visibility: "off"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#616161"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#f5f5f5"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#bdbdbd"
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#eeeeee"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#757575"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{
                color: "#e5e5e5"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9e9e9e"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#ffffff"
            }]
        }, {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#757575"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#dadada"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#616161"
            }]
        }, {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9e9e9e"
            }]
        }, {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{
                color: "#e5e5e5"
            }]
        }, {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{
                color: "#eeeeee"
            }]
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#c9c9c9"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9e9e9e"
            }]
        }] : "night" == i.mapstyle ? [{
            elementType: "geometry",
            stylers: [{
                color: "#242f3e"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#746855"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#242f3e"
            }]
        }, {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#d59563"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#d59563"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{
                color: "#263c3f"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#6b9a76"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#38414e"
            }]
        }, {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#212a37"
            }]
        }, {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#746855"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#1f2835"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#f3d19c"
            }]
        }, {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{
                color: "#2f3948"
            }]
        }, {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#d59563"
            }]
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#17263c"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#515c6d"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#17263c"
            }]
        }] : [],
        $(".js-map-link").attr("href", "https://www.google.com/maps/place/" + i.directions + "/@" + t + "," + e);
        var a = {
            zoom: i.zoom,
            center: n,
            styles: o,
            disableDefaultUI: !1
        }
          , s = new google.maps.Map(document.getElementById(i.sectionid),a);
        if (1 == i.showpin)
            var r = new google.maps.Marker({
                position: n,
                map: s
            })
    }
};
var faqAccordion = {
    init: function() {
        var t = 0
          , i = $(".faqAccordion > dt > button");
        $(".faqAccordion > dd").attr("aria-hidden", !0),
        i.attr("aria-expanded", !1),
        i.on("click activate", (function() {
            if (t)
                return !1;
            t = 1;
            var e = "false" === $(this).attr("aria-expanded");
            return $(this).attr("aria-expanded", e),
            $(this).parent().next().slideToggle((function() {
                t = 0
            }
            )),
            $(this).parent().next().attr("aria-hidden", !e),
            !1
        }
        )),
        i.on("keydown", (function(t) {
            13 === (t.keyCode || e.which) && $(this).trigger("activate")
        }
        ))
    }
};
var usePageDots = Shopify.theme_settings.page_dots_enabled
  , imageFunctions = {
    zoom: function(t, e, i) {
        $(t).data("zoom") && $(t + " img").wrap('<span style="display:inline-block"></span>').css("display", "block").parent().zoom({
            touch: e,
            magnify: i || 1
        })
    },
    linkGalleryAndCarousel: function(t, e) {
        e.find(".gallery-cell:nth-child(1)").addClass("is-nav-selected"),
        e.on("click", ".gallery-cell", (function() {
            var i = $(this).index();
            e.find(".is-nav-selected").removeClass("is-nav-selected"),
            $(this).addClass("is-nav-selected"),
            t.flickity("select", i)
        }
        )),
        t.on("select.flickity", (function() {
            var t = $(this).data("flickity");
            t && (e.find(".is-nav-selected").removeClass("is-nav-selected"),
            e.find(".gallery-cell:nth-child(" + (t.selectedIndex + 1) + ")").addClass("is-nav-selected"))
        }
        ))
    },
    fullWidth: function(t, e) {
        $(t).each((function() {
            var t = $(this)
              , i = t.attr("alt")
              , n = t.attr("src");
            if (0 <= i.indexOf("[")) {
                t.remove();
                var o = i.match(/\[(.*?)\]/gi);
                i = i.replace(/\[(.*?)\]/gi, "");
                var a = $.map(o, (function(t, e) {
                    return t = t.replace(/[\[\]']+/g, "")
                }
                ))
                  , s = ['<div class="position-' + (a.length ? a : "center") + ' caption js-caption">', '<div class="caption-content caption-background-false align-' + (a.length ? a : "center") + '">', '<p class="headline">' + i + "</p>", "</div>", "</div>"].join("");
                t.attr({
                    alt: i,
                    class: "lazyload {{ settings.image_loading_style }}",
                    src: n,
                    dataSizes: "auto"
                });
                var r = '<div class="banner">' + t.prop("outerHTML") + s + "</div>";
                $(e).append(r)
            }
        }
        ))
    },
    showSecondaryImage: function() {
        798 < $(window).width() && ($("body").on("mouseenter", ".swap-true", (function() {
            $(this).toggleClass("toggle-images")
        }
        )),
        $("body").on("mouseleave", ".swap-true", (function() {
            $(this).toggleClass("toggle-images")
        }
        )))
    },
    flickityIosFix: function() {
        var t, e = !1;
        document.body.addEventListener("touchstart", (function(i) {
            i.target.closest(".flickity-slider") ? (e = !0,
            t = {
                x: i.touches[0].pageX,
                y: i.touches[0].pageY
            }) : e = !1
        }
        )),
        document.body.addEventListener("touchmove", (function(i) {
            if (e && i.cancelable) {
                var n = {
                    x: i.touches[0].pageX - t.x,
                    y: i.touches[0].pageY - t.y
                };
                7 < Math.abs(n.x) && i.preventDefault()
            }
        }
        ), {
            passive: !1
        })
    }
};
var recentlyViewed = {
    init: function() {
        var t, e, i, n, o;
        if ($(".js-product_section[data-rv-handle]").length ? (t = $(".js-product_section").data("rv-handle").toString(),
        e = Cookies.get("recentlyViewed"),
        i = recentlyViewed.getCookieProducts(e, t)) : ($(".recently-viewed__section").length || $(".js-sidebar-recently-viewed").length) && (e = Cookies.get("recentlyViewed"),
        i = recentlyViewed.getCookieProducts(e, t)),
        i && (o = unescape(i).split(",")),
        t ? (-1 !== !$.inArray(t, o) && (n = [],
        o.unshift(t),
        $.each(o, (function(t, e) {
            -1 === $.inArray(e, n) && n.push(e)
        }
        ))),
        recentlyViewed.setCookieProducts(n)) : n = o,
        $(".recently-viewed__section").length) {
            var a = ".recently-viewed__section";
            recentlyViewed.getProductInformation(a, n, t)
        } else
            $(".js-recently-viewed .rv-main").length && (a = ".js-recently-viewed",
            recentlyViewed.getProductInformation(a, n, t));
        $(".sidebar .js-sidebar-recently-viewed").length && (a = ".sidebar .js-sidebar-recently-viewed",
        t ? recentlyViewed.getProductInformation(a, n, t) : recentlyViewed.getProductInformation(a, n))
    },
    getCookieProducts: function(t, e) {
        return !t && e && Cookies.set("recentlyViewed", e, {
            expires: 30,
            path: "/"
        }),
        t = Cookies.get("recentlyViewed")
    },
    setCookieProducts: function(t) {
        Cookies.set("recentlyViewed", escape(t.join(",")), {
            expires: 30,
            path: "/"
        })
    },
    getProductInformation: function(t, e, i) {
        i && e.splice($.inArray(i, e), 1);
        var n = $(t).data("visible-products");
        n && e && (e = e.slice(0, n)),
        $.each(e, (function(i, o) {
            o && ($(t).removeClass("hidden"),
            $(t).parents(".sidebar-block").show(),
            $.ajax({
                type: "GET",
                url: "/products/" + o + "?view=rv",
                success: function(e) {
                    var n = $(e).find(".js-recently-viewed-product");
                    $(t).find(" .rv-box-" + i).append(n),
                    Shopify.theme_settings.show_multiple_currencies && convertCurrencies()
                },
                error: function(t, e, i) {
                    console.log(t),
                    console.log(e),
                    console.log(i)
                },
                dataType: "html"
            })),
            $(t).find(".rv-main").hasClass("js-rv-slider") ? (e.length <= n ? $(".js-rv-slider .gallery-cell").eq(e.length).nextAll().addBack().remove() : $(".js-rv-slider .gallery-cell").eq(n).nextAll().addBack().remove(),
            recentlyViewed.createSlider(t, n)) : $(t).find(".rv-main").hasClass("js-rv-grid") && (e.length <= n ? $(".js-rv-grid .thumbnail").eq(e.length).nextAll().addBack().remove() : $(".js-rv-grid .thumbnail").eq(n).nextAll().addBack().remove())
        }
        ))
    },
    createSlider: function(t, e) {
        var i, n, o, a, s, r = $(".js-rv-slider").data("products-per-slide"), l = $(".js-rv-slider").data("products-limit"), c = e, d = $(".js-rv-slider").find(".gallery-cell");
        i = "2" == r && r < c && r < l || "4" == r && r < c && r < l || "6" == r && r < c && r < l ? "left" : "center",
        a = o = n = r < c && r < l,
        "2" == r && r < c || "4" == r && r < c || "6" == r && r < c ? s = 0 : "3" == r && c ? s = 1 : "5" == r && c ? s = 2 : "7" == r && c && (s = 3),
        $(window).width() <= 798 && (i = "center",
        s = 1,
        a = o = n = !(d.length <= 2) && 3 < c && 3 < l,
        $(".js-rv-slider").parents(".even-num-slides").removeClass("even-num-slides")),
        $(".js-rv-slider").flickity({
            lazyLoad: 2,
            imagesLoaded: !0,
            draggable: n,
            prevNextButtons: o,
            wrapAround: a,
            cellAlign: i,
            pageDots: usePageDots,
            contain: !0,
            freeScroll: !0,
            arrowShape: arrowSize,
            initialIndex: s
        }),
        $(".js-rv-slider").addClass("slider-initialized")
    }
};
var enableLoadMoreProducts = function() {
    $("body").on("click", ".js-load-more a", (function(t) {
        return enableInfiniteScroll(),
        t.stopPropagation(),
        !1
    }
    ))
}
  , enableInfiniteScroll = function() {
    $(".collection-matrix").length && new Waypoint.Infinite({
        element: $(".collection-matrix")[0],
        items: ".collection-matrix",
        more: ".load-more__btn",
        loadingClass: "loading-in-progress",
        onBeforePageLoad: function() {
            $(".js-load-more").hide()
        },
        onAfterPageLoad: function(t) {
            $(".collection-matrix > .collection-matrix .thumbnail").unwrap(".collection-matrix"),
            Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges && SPR.$(document).ready((function() {
                return SPR.registerCallbacks(),
                SPR.initRatingHandler(),
                SPR.initDomEls(),
                SPR.loadProducts(),
                SPR.loadBadges()
            }
            )),
            Shopify.theme_settings.show_multiple_currencies && convertCurrencies(),
            Shopify.PaymentButton && Shopify.PaymentButton.init(),
            productPage.init(),
            Shopify.theme_settings.quick_shop_enabled && quickShop.init(),
            hideNoScript()
        }
    })
}
  , enableLoadMoreSearch = function() {
    $("body").on("click", ".js-load-more a", (function(t) {
        return enableInfiniteSearchScroll(),
        t.stopPropagation(),
        !1
    }
    ))
}
  , enableInfiniteSearchScroll = function() {
    $(".search-matrix").length && new Waypoint.Infinite({
        element: $(".search-matrix")[0],
        items: ".search-matrix",
        more: ".load-more__btn",
        loadingClass: "loading-in-progress",
        onBeforePageLoad: function() {
            $(".js-load-more").hide()
        },
        onAfterPageLoad: function(t) {
            $(".search-matrix > .search-matrix .thumbnail").unwrap(".search-matrix"),
            Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges && SPR.$(document).ready((function() {
                return SPR.registerCallbacks(),
                SPR.initRatingHandler(),
                SPR.initDomEls(),
                SPR.loadProducts(),
                SPR.loadBadges()
            }
            )),
            Shopify.theme_settings.show_multiple_currencies && convertCurrencies(),
            Shopify.PaymentButton && Shopify.PaymentButton.init(),
            productPage.init(),
            Shopify.theme_settings.quick_shop_enabled && quickShop.init(),
            hideNoScript()
        }
    })
}
  , hideNoScript = function() {
    $(".image__container noscript").addClass("hidden")
};
if (Shopify.queryParams = {},
location.search.length)
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++)
        1 < (aKeyValue = aCouples[i].split("=")).length && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
var quickFilter = {
    init: function() {
        var t = []
          , e = ""
          , i = ""
          , n = ($.url("hostname"),
        $.url("1") ? "/" + $.url("1") + "/" : "")
          , o = $.url("2") ? $.url("2") + "/" : ""
          , a = ($.url("3"),
        n + o);
        e = $("#sort-by").length ? $("#sort-by").val() : url("?sort_by"),
        $("#tag_filter").length && $("#tag_filter").data("default-collection") != $("#tag_filter").val() && (urlTag = $("#tag_filter").val().substr($("#tag_filter").val().lastIndexOf("/") + 1),
        "all" != urlTag && (-1 < $.inArray(urlTag, t) || t.unshift(urlTag))),
        $("[data-option-filter] input:checked").each((function() {
            t.push($(this).val())
        }
        )),
        t = $.makeArray(t),
        $.each(t, (function(e, n) {
            e != t.length - 1 ? i += t[e] + "+" : i += t[e]
        }
        )),
        Shopify.queryParams.sort_by = e,
        e = "?" + $.param(Shopify.queryParams),
        quickFilter.processUrl(a, i, e)
    },
    updateView: function(t) {
        $.ajax({
            type: "GET",
            url: t,
            beforeSend: function() {
                $(".collection-matrix").addClass("fadeOut animated loading-in-progress filter-loading"),
                Waypoint.destroyAll()
            },
            success: function(e) {
                $(".collection-matrix").removeClass("loading-in-progress"),
                $(".collection-matrix").removeClass("filter-loading");
                var i = $(e).find(".breadcrumb_text").html();
                $(".breadcrumb_text").html(i);
                var n = $(e).find(".paginate").html();
                $(".paginate").html(n);
                var o = $(e).find(".sidebar").html();
                $(".sidebar").html(o);
                var a = $(e).find(".paginate").html();
                $(".paginate").empty(),
                $(".paginate").html(a);
                var s = $(e).find(".collection-matrix");
                $(".collection-matrix").remove(),
                s.insertBefore($(".load-more__icon")),
                window.history && window.history.pushState && window.history.pushState("", "", t),
                $(".sidebar__collection-filter").length && collectionSidebarFilter.init(),
                "infinite_scroll" == Shopify.theme_settings.pagination_type && enableInfiniteScroll(),
                Shopify.theme_settings.show_multiple_currencies && convertCurrencies(),
                Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges && SPR.$(document).ready((function() {
                    return SPR.registerCallbacks(),
                    SPR.initRatingHandler(),
                    SPR.initDomEls(),
                    SPR.loadProducts(),
                    SPR.loadBadges()
                }
                )),
                recentlyViewed.init(),
                $(".js-product_section .product_form_options").each((function() {
                    new Shopify.OptionSelectors($(this).data("select-id"),{
                        product: $(this).data("product"),
                        onVariantSelected: selectCallback,
                        enableHistoryState: $(this).data("enable-state")
                    })
                }
                )),
                Shopify.PaymentButton && Shopify.PaymentButton.init()
            },
            error: function(e, i, n) {
                console.log(e),
                console.log(i),
                console.log(n),
                location.replace(location.protocol + "//" + location.host + t)
            },
            dataType: "html"
        })
    },
    processUrl: function(t, e, i) {
        var n;
        n = t + e + (i = i.replace(/\page=(\w+)&/, "")),
        quickFilter.updateView(n)
    }
};
var searchAutocomplete = {
    init: function() {
        var t = null
          , e = $("body").data("shop-url");
        if ("products" == Shopify.theme_settings.search_option)
            var n = e + "/search?type=product&q=";
        else
            n = e + "/search?q=";
        $(".search_form, .search__form, .header_search_form").on("submit", (function(t) {
            var e = $(this).find('input[name="q"]').val()
              , i = encodeURI(e);
            t.preventDefault(),
            window.location.href = null == i ? "/search" : n + i + "*"
        }
        )),
        $("form.search_form, form.search, form.header_search_form").each((function() {
            var e = $(this).find('input[name="q"]');
            $('<div class="search__results-wrapper"><ul class="search__results"></ul></div>').appendTo($(this)),
            e.attr("autocomplete", "off").bind("keyup change", (function() {
                "" == e.val() && ($(".search__results").hide(),
                $(".search__results").empty());
                var o = $(this).val()
                  , a = encodeURI(o)
                  , s = $(this).closest("form")
                  , r = n + a
                  , l = s.find(".search__results");
                3 <= o.length && (null != t && t.abort(),
                t = $.getJSON(r + "*&view=json", (function(t) {
                    l.empty(),
                    0 == t.results_count ? l.hide() : ($.each(t.results, (function(t, e) {
                        if (t >= Shopify.theme_settings.search_items_to_display)
                            return !1;
                        var n = $("<a></a>").attr("href", e.url);
                        if ("product" == e.object_type) {
                            var o = [];
                            for (i = 0; i < e.collections.length; i++)
                                o.push(e.collections[i].handle);
                            if (-1 != $.inArray("coming-soon", o))
                                var a = Shopify.translation.coming_soon_text;
                            else
                                a = 1 == e.available ? e.raw_compare > e.raw_price ? '<span class="was_price">' + e.compare + "</span> " + e.price : e.price_varies && 0 < e.price_min ? Shopify.translation.from_text + " " + e.price : 0 < e.price || 0 < e.raw_price ? e.price : Shopify.theme_settings.free_text : Shopify.theme_settings.display_sold_out_price ? e.price + ' <span class="sold-out-text">' + Shopify.theme_settings.sold_out_text + "</span>" : '<span class="sold-out-text">' + Shopify.theme_settings.sold_out_text + "</span>";
                            "NULL" != e.thumbnail && n.append('<div class="thumbnail"><img class="lazyload {{ settings.image_loading_style }}" src="' + e.thumbnail + '" /></div>'),
                            n.append('<div class="title">' + e.title + '<br><span class="item-pricing">' + a + "</span></div>")
                        } else
                            "article" == e.object_type ? ("NULL" != e.thumbnail && n.append('<div class="thumbnail"><img class="lazyload {{ settings.image_loading_style }}" src="' + e.thumbnail + '" /></div>'),
                            n.append('<div class="title">' + e.title + '<br><span class="item-pricing">' + e.text_content + "</span></div>")) : "page" == e.object_type && n.append('<div class="title">' + e.title + '<br><span class="item-pricing">' + e.text_content + "</span></div>");
                        n.wrap('<li class="item-result result--' + e.object_type + '"></li>'),
                        l.append(n.parent())
                    }
                    )),
                    t.results_count >= Shopify.theme_settings.search_items_to_display && l.append('<li class="all-results"><span class="title see-all"><a href="' + r + '*">' + Shopify.translation.all_results + " (" + t.results_count + ")</a></span></li>"),
                    l.fadeIn(200))
                }
                )))
            }
            ))
        }
        )),
        $(document).on("click", (function(t) {
            var e = $("[data-autocomplete-true]");
            e.is(t.target) || 0 !== e.has(t.target).length || $("[data-autocomplete-true]").find(".search__results-wrapper").hide()
        }
        )),
        $("[data-autocomplete-true] input").on("focus", (function() {
            $(".search__results-wrapper").hide(),
            $(this).parents("[data-autocomplete-true]").find(".search__results-wrapper").show()
        }
        ))
    },
    unload: function() {
        $("body").off("focus", "[data-autocomplete-true] input")
    }
};
var collectionSidebarFilter = {
    init: function() {
        $(".filter-active-tag input:checked").parents(".filter-active-tag").siblings(".filter-all-tags").hide(),
        $(".toggle-all--true .toggle_list .filter-active-tag input:checked").parents("ul.toggle_list").prev().click(),
        0 < window.location.search.indexOf("sort_by") && $(".toggle-all--true .toggle_list .filter-active-tag input").attr("checked") && $(".sidebar__collection-filter > h4").addClass("active"),
        "types" !== $.url(2) && "vendors" !== $.url(2) || $(".sidebar__collection-filter").remove(),
        $(".sidebar-block:empty").prev().css("border-bottom", "none"),
        recentlyViewed.init()
    },
    clearAllFilters: function() {
        $("[data-option-filter] input").attr("checked", !1),
        $("[data-option-filter] input").trigger("change"),
        recentlyViewed.init()
    },
    clearSelectedFilter: function(t) {
        t.find("[data-option-filter] input").attr("checked", !1),
        t.find("[data-option-filter] input").trigger("change"),
        recentlyViewed.init()
    }
};
if ("bold" == Shopify.theme_settings.slideshow_arrow_size)
    var arrowSize = {
        x0: 10,
        x1: 40,
        y1: 50,
        x2: 80,
        y2: 50,
        x3: 50
    }
      , svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow"></path></svg>'
      , svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>';
else
    "light" == Shopify.theme_settings.slideshow_arrow_size ? (arrowSize = {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 62,
        y2: 40,
        x3: 22
    },
    svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>',
    svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>') : "regular" == Shopify.theme_settings.slideshow_arrow_size && (arrowSize = {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 70,
        y2: 40,
        x3: 30
    },
    svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
    svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>');
var utils = {
    createAccordion: function(t, e, i) {
        var n = $(t)
          , o = $(t).find(e)
          , a = $(t).find(i)
          , s = t + " " + e;
        if (0 <= t.indexOf(".accordion-tabs")) {
            var r = $.map(o, (function(t, e) {
                return [t, a[e]]
            }
            ));
            n.empty(),
            $.each(r, (function(t, e) {
                n.append(this)
            }
            )),
            a.removeClass("active"),
            n.find(".active").next().slideToggle(),
            e = t + "> a"
        }
        $(t).children("a").each((function(t, e) {
            var i = (e = $(this)).attr("href");
            e.attr("data-tab-value", i),
            e.removeAttr("href")
        }
        )),
        $(t).find(e + ".active").next().slideToggle(),
        $("body").on("click", s, (function(t) {
            t.preventDefault(),
            $(this).toggleClass("active"),
            $(this).next().slideToggle()
        }
        ))
    },
    mobileAccordion: function(t, e, i) {
        $container = $(t),
        $tab = $(t).find(e),
        $content = $(t).find(i),
        $(e + ".active").next().slideToggle(),
        $("body").on("click", e, (function(t) {
            t.preventDefault(),
            $(this).toggleClass("active"),
            $(this).next().slideToggle()
        }
        ))
    },
    mobileParentActiveAccordion: function(t, e, i) {
        $container = $(t),
        $tab = $(t).find(e),
        $content = $(t).find(i),
        $(e + ".active").parent().next().slideToggle(),
        $("body").on("click", e, (function(t) {
            t.preventDefault(),
            $(this).toggleClass("active"),
            $(this).parent().next().slideToggle()
        }
        ))
    },
    initializeTabs: function() {
        $("ul.tabs > li > a").attr("data-no-instant", !0),
        $("body").on("click", "ul.tabs > li > a", (function(t) {
            var e = $(this).attr("href");
            "#" == e.charAt(0) && ($("ul.tabs > li > a.active").removeClass("active"),
            $(this).addClass("active"),
            $(this).parents("ul.tabs").next().find(e).show().css({
                display: "block"
            }).addClass("active").siblings().hide().removeClass("active"))
        }
        ))
    },
    pageBannerCheck: function() {
        0 < !$(".page_banner").length || $(".header").hasClass("header-background--solid") ? ($(".feature_image").removeClass("feature_image"),
        $(".header.is-absolute").removeClass("is-absolute"),
        $(".secondary_logo--true").find(".secondary_logo").css("display", "none"),
        $(".secondary_logo--true").find(".primary_logo").css("display", "block")) : ($(".header").parent().addClass("feature_image"),
        $(".header").addClass("is-absolute"),
        $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").css("display", "block"),
        $(".secondary_logo--true").find(".primary_logo").css("display", "none"))),
        $(".index-sections").children().first(".under-menu").find(".full-width--true").length ? ($(".header").hasClass("header-background--solid") || ($(".index .header").parent().addClass("feature_image"),
        $(".index .header").addClass("is-absolute")),
        $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").show(),
        $(".secondary_logo--true").find(".primary_logo").hide())) : ($(".index .feature_image").removeClass("feature_image"),
        $(".index .header.is-absolute").removeClass("is-absolute"),
        $("header.feature_image").hasClass("secondary_logo--true") || ($(".secondary_logo--true").find(".secondary_logo").hide(),
        $(".secondary_logo--true").find(".primary_logo").show())),
        $(".detail-sections").children().first().hasClass("under-menu") ? ($(".header").hasClass("header-background--solid") || ($('[class^="page-details"] .header').parent().addClass("feature_image"),
        $('[class^="page-details"] .header').addClass("is-absolute")),
        $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").show(),
        $(".secondary_logo--true").find(".primary_logo").hide())) : ($('[class^="page-details"] .feature_image').removeClass("feature_image"),
        $('[class^="page-details"] .header.is-absolute').removeClass("is-absolute"),
        $("header.feature_image").hasClass("secondary_logo--true") || ($(".secondary_logo--true").find(".secondary_logo").hide(),
        $(".secondary_logo--true").find(".primary_logo").show()))
    },
    resizeActionButtons: function() {
        $(".js-caption:visible").each((function() {
            var t = 0;
            $(this).find(".action_button").each((function() {
                $button = $(this),
                $(this).width() > t && (t = $(this).width())
            }
            )),
            $(this).find(".action_button").width(t)
        }
        ))
    }
}
  , sliderBlock = {
    select: function(t, e) {
        var i = e.find(".gallery-cell").map((function() {
            return String($(this).data("block-id"))
        }
        ))
          , n = e.find("[data-slider-id]")
          , o = (n.data("slideshow-text-animation"),
        n.data("flickity"));
        n.flickity("pausePlayer");
        for (var a = 0; a < i.length; a++)
            i[a] === t && a !== o.selectedIndex && n.flickity("select", parseInt(a), !1, !0)
    },
    deselect: function(t) {
        var e = t.find(".flexslider").data("flexslider");
        e && e.flickity("unpausePlayer")
    }
};
var globalQuickShopProduct, quickShop = {
    init: function() {
        $("body").on("click", ".js-quick-shop-link", (function(t) {
            t.stopImmediatePropagation(),
            t.preventDefault();
            const e = {
                handle: $(this).data("handle"),
                product_id: $(this).data("id"),
                single_variant: $(this).attr("data-single-variant"),
                product_in_collection_url: $(this).data("url"),
                escaped_title: $(this).data("title").replace('"', ""),
                details_text: $(this).data("details-text"),
                full_description: $(this).data("full-description"),
                regular_description: $(this).data("regular-description"),
                feat_img: $(this).data("feat-img"),
                image_array: quickShop.createImageObjects($(this).data("images")),
                collection_handles: $(this).data("collection-handles").trim(",").split(","),
                money_format: $("body").data("money-format")
            }
              , i = $(this).next(".js-quickshop-forms__container").find(".notify_form")
              , n = $(this).next(".js-quickshop-forms__container").find(".product_form");
            $.fancybox.open($(".js-quick-shop"), {
                baseClass: "quick-shop__lightbox product-" + e.product_id,
                hash: !1,
                infobar: !1,
                toolbar: !1,
                loop: !1,
                smallBtn: !0,
                mobile: {
                    preventCaptionOverlap: !1,
                    toolbar: !0,
                    buttons: ["close"]
                },
                beforeLoad: function() {
                    quickShop.beforeOpen(e)
                },
                afterLoad: function() {
                    quickShop.afterContent(n, i, e)
              setTimeout(function(){
if (window.BOLD && BOLD.options && BOLD.common && BOLD.options.app && BOLD.options.app.unload && BOLD.options.app.boot){
BOLD.options.app.unload();
BOLD.options.app.boot();
}
}, 750)
                },
                beforeClose: function() {
                    quickShop.beforeClose(e)
                }
            })
        }
        )),
        $(".swatch_options input").each((function() {
            $(this).is(":checked") && quickShop.toggleSwatchImages($(this))
        }
        )),
        $(".swatch_options label").on("click", (function() {
            quickShop.toggleSwatchImages($(this))
        }
        ))
    },
    toggleSwatchImages: function(t) {
        var e = $(t).data("image")
          , i = $(t).parents(".thumbnail").find(".image__container img");
        i.attr("src", e),
        i.attr("srcset", e)
    },
    createImageObjects: function(t) {
        return t.split("~").map((function(t) {
            var e = t.split("^");
            return {
                path: e[0],
                alt: e[1],
                id: e[2]
            }
        }
        ))
    },
    beforeOpen: function(t) {
        quickShop.populateGallery(t),
        $(".js-sale-banner, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-banner, .js-pre-order-banner").empty(),
        $(".modal_price, .js-notify-form").show(),
        t.image_array.length > 1 ? ($(".js-gallery-modal").addClass("multi-image"),
        $(".js-gallery-modal").removeClass("single-image"),
        $(".js-gallery-modal").addClass("is-draggable")) : ($(".js-gallery-modal").addClass("single-image"),
        $(".js-gallery-modal").removeClass("multi-image"))
    },
    afterContent: function(t, e, i) {
        quickShop.retrieveProductInfo(i);
        var n = !1;
        if (i.image_array.length > 1 ? (!0,
        n = !0) : (!1,
        n = !1),
        $(".js-gallery-modal").flickity({
            adaptiveHeight: !0,
            wrapAround: "true",
            cellAlign: "left",
            draggable: n,
            contain: !0,
            imagesLoaded: !0,
            lazyLoad: 2,
            pageDots: !1,
            dragThreshold: 10,
            arrowShape: arrowSize
        }),
        "bottom-slider" == Shopify.theme_settings.quick_shop_thumbnail_position && $(".js-gallery-carousel").flickity({
            adaptiveHeight: !0,
            cellAlign: "center",
            draggable: !1,
            contain: !0,
            imagesLoaded: !0,
            lazyLoad: 2,
            pageDots: !1,
            dragThreshold: 10,
            arrowShape: arrowSize
        }),
        $(".quick-shop__lightbox .js-notify-form").append(e),
        $(".quick-shop__lightbox .js-product-form").append(t),
        t.hasClass("product_form_options") && 0 == t.hasClass("viewed") ? new Shopify.OptionSelectors(t.data("select-id"),{
            product: t.data("product"),
            onVariantSelected: selectCallback,
            enableHistoryState: t.data("enable-state")
        }) : Shopify.theme_settings.show_multiple_currencies && convertCurrencies(),
        "swatches" == Shopify.theme_settings.product_form_style) {
            const e = t.data("product")
              , n = ".product-" + i.section_id + " .js-product_section";
            t.find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(e, n)
        }
        $('.js-quick-shop select[name="id"]').trigger("change"),
        utils.initializeTabs(),
        $(".js-quick-shop .text-modal-wrap iframe[src*=youtube], .js-quick-shop .text-modal-wrap iframe[src*=vimeo]").mediaWrapper({
            intrinsic: !0
        }),
        productPage.productSwatches()
    },
    beforeClose: function(t) {
        const e = $(".quick-shop__lightbox .notify_form")
          , i = $(".quick-shop__lightbox .product_form");
        $(".js-quickshop-forms--" + t.product_id).append(i),
        $(".js-quickshop-forms--" + t.product_id).append(e),
        $(".js-quickshop-forms--" + t.product_id + " .product_form").addClass("viewed"),
        $(".js-quickshop-forms--" + t.product_id + " .notify_form").addClass("viewed");
        const n = $(".js-gallery-modal")
          , o = $(".js-gallery-carousel");
        $(".js-gallery-carousel .gallery-cell").off("click"),
        n.flickity("remove", $(".gallery-cell", n)),
        n.flickity("destroy"),
        o.hasClass("flickity-enabled") ? (o.flickity("remove", $(".gallery-cell", o)),
        o.flickity("destroy")) : o.find(".gallery-cell").remove();
        const a = $(".js-current-price .money").text();
        $(".js-quick-shop-link[data-id=" + t.product_id + "]").attr("data-initial-modal-price", a),
        $(".js-current-price, .js-was-price, .js-savings").empty()
    },
    retrieveProductInfo: function(t) {
        $.ajax({
            dataType: "json",
            async: !1,
            cache: !1,
            url: "/products/" + t.handle + ".js",
            success: function(e) {
                e = $.extend({}, e, t),
                globalQuickShopProduct = e,
                quickShop.updateVariant(e.variants[0].id.toString(), e)
            }
        })
    },
    updateVariant: function(t) {
        if ("undefined" != globalQuickShopProduct) {
            var e = globalQuickShopProduct;
            $(".js-current-price").html(""),
            $(".js-was-price").html(""),
            $(".js-savings").html(""),
            $(".js-product-title").html('<a href="' + e.product_in_collection_url + '" title="' + e.escaped_title + '">' + e.title + "</a>"),
            $(".js-product-vendor").html('<a href="/collections/vendors?q=' + e.vendor + '">' + e.vendor + "</a>"),
            $(".js-full-description").html(e.full_description),
            $(".js-regular-description").html(e.regular_description);
            var i = '<a href="' + e.product_in_collection_url + '" class="secondary_button" title="' + e.escaped_title + ' Details">' + e.details_text + "</a>";
            if ($(".js-product-details").html(i),
            $.each(e.collection_handles, (function(t, i) {
                "new" == this.toString() && $(".js-new-banner").html(Shopify.translation.new_text),
                "pre-order" == this.toString() && $(".js-pre-order-banner").html(Shopify.translation.pre_order_text),
                "coming-soon" == this.toString() && (e.price = Shopify.translation.coming_soon_text)
            }
            )),
            "true" == e.single_variant)
                Shopify.theme_settings.sale_banner_enabled && e.compare_at_price > e.price && $(".js-sale-banner").html(Shopify.translation.sale_text),
                e.compare_at_price > e.price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"),
                0 == e.available ? e.price == Shopify.translation.coming_soon_text ? $(".js-sold-out").html(Shopify.translation.coming_soon_text) : $(".js-sold-out").html(Shopify.theme_settings.sold_out_text) : $(".js-sold-out").html(""),
                (1 == e.available || 0 == e.available && Shopify.theme_settings.display_sold_out_price) && (e.compare_at_price > e.price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(e.variants[0].compare_at_price, e.money_format) + "</span>"),
                $(".js-savings").html(Shopify.translation.savings_text + " " + parseInt(100 * (e.variants[0].compare_at_price - e.variants[0].price) / e.variants[0].compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(e.variants[0].compare_at_price - e.variants[0].price, e.money_format) + "</span>)")),
                e.price == Shopify.translation.coming_soon_text ? $(".js-current-price").html(Shopify.translation.coming_soon_text) : e.price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(e.variants[0].price, e.money_format) + "</span>") : $(".js-current-price").html(Shopify.theme_settings.free_text)),
                1 == e.available ? $(".js-notify-form").hide() : $(".js-notify-form").show();
            else
                for (var n = 0; n < e.variants.length; n++)
                    t == e.variants[n].id.toString() && (Shopify.theme_settings.sale_banner_enabled && e.variants[n].compare_at_price > e.variants[n].price && $(".js-sale-banner").html(Shopify.translation.sale_text),
                    e.variants[n].compare_at_price > e.variants[n].price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"),
                    0 == e.variants[n].available ? e.price == Shopify.translation.coming_soon_text ? $(".js-sold-out").html(Shopify.translation.coming_soon_text) : $(".js-current-price").parents(".modal_price").hasClass("variant-unavailable") ? $(".js-sold-out").html(Shopify.translation.unavailable_text) : $(".js-sold-out").html(Shopify.theme_settings.sold_out_text) : $(".js-sold-out").html(""),
                    $(".js-current-price").parents(".modal_price").hasClass("variant-unavailable") && $(".js-sold-out").html(Shopify.translation.unavailable_text),
                    1 == e.variants[n].available ? $(".js-notify-form").hide() : $(".js-notify-form").show(),
                    (1 == e.variants[n].available || 0 == e.variants[n].available && Shopify.theme_settings.display_sold_out_price) && (e.variants[n].compare_at_price > e.variants[n].price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(e.variants[n].compare_at_price, e.money_format) + "</span>"),
                    $(".js-savings").html(Shopify.translation.savings_text + " " + parseInt(100 * (e.variants[n].compare_at_price - e.variants[n].price) / e.variants[n].compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(e.variants[n].compare_at_price - e.variants[n].price, e.money_format) + "</span>)")),
                    e.price == Shopify.translation.coming_soon_text ? $(".js-current-price").html(Shopify.translation.coming_soon_text) : e.variants[n].price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(e.variants[n].price, e.money_format) + "</span>") : $(".js-current-price").html(Shopify.theme_settings.free_text)))
        }
        Shopify.theme_settings.show_multiple_currencies && convertCurrencies()
    },
    populateGallery: function(t) {
        const e = $(".js-gallery-modal")
          , i = $(".js-gallery-carousel");
        $.each(t.image_array, (function(e, i) {
            if ("" == i.path)
                var n = t.feat_img
                  , o = "";
            else
                n = i.path,
                o = i.alt;
            var a;
            n.replace(/(\.[^.]*)$/, "_2048x2048$1").replace("http:", ""),
            a = o.indexOf("youtube") >= 0 ? '<div class="video-container youtube"><div>' + o + "</div></div>" : o.indexOf("vimeo") >= 0 ? '<div class="video-container vimeo"><div>' + o + "</div></div>" : '<img src="' + n + '" alt="' + o + '" data-image-id="' + i.id + '" data-index="' + e + '" />';
            var s = $('<div class="gallery-cell">' + a + "</div>");
            $(".js-gallery-modal").append(s)
        }
        )),
        function() {
            if ($.each(t.image_array, (function(t, e) {
                if ("" != e.path) {
                    var n = '<img src="' + e.path.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", "") + '" alt="' + escape(e.alt) + '" />'
                      , o = $('<div class="gallery-cell">' + n + "</div>");
                    i.append(o)
                }
            }
            )),
            imageFunctions.linkGalleryAndCarousel(e, i),
            "bottom-slider" == Shopify.theme_settings.quick_shop_thumbnail_position) {
                var n = !0
                  , o = !1
                  , a = !1;
                $(".product_gallery_nav .gallery-cell").length >= 7 && (n = !1,
                o = !0,
                a = !0),
                $(".product_gallery_nav.product_gallery_nav--bottom-slider").flickity({
                    asNavFor: ".product_gallery",
                    adaptiveHeight: !1,
                    wrapAround: a,
                    cellAlign: "center",
                    draggable: !0,
                    groupCells: n,
                    prevNextButtons: o,
                    pageDots: !1,
                    lazyLoad: 2,
                    dragThreshold: 10,
                    arrowShape: arrowSize
                })
            }
        }(),
        imageFunctions.zoom(".js-gallery-modal", !1)
    }
};
var newsletter_popup = {
    init: function() {
        var t = Cookies.get("popup")
          , e = parseInt(Shopify.theme_settings.newsletter_popup_days)
          , i = 0 != e;
        if (i && "open" == t)
            return !1;
        newsletter_popup.open(),
        i && Cookies.set("popup", "open", {
            expires: e
        })
    },
    open: function() {
        var t = parseInt(Shopify.theme_settings.newsletter_popup_seconds);
        (Shopify.theme_settings.newsletter_popup_mobile || 798 < $(window).width()) && setTimeout((function() {
            $.fancybox.open($(".js-newsletter-popup"), {
                baseClass: "newsletter__lightbox",
                hash: !1,
                infobar: !1,
                toolbar: !1,
                loop: !0,
                smallBtn: !0,
                mobile: {
                    preventCaptionOverlap: !1,
                    toolbar: !0,
                    buttons: ["close"]
                }
            })
        }
        ), 1e3 * t)
    }
};
function htmlEncode(t) {
    return t ? $("<div/>").text(t).html() : ""
}
function is_touch_device() {
    return "ontouchstart"in window || navigator.maxTouchPoints
}
$((function() {
    var oldFlickityCreate = window.Flickity.prototype._create;
    var resizeTimeout;
    window.Flickity.prototype._create = function() {
        var t = this;
        return this.element.addEventListener && this.element.addEventListener("load", (function() {
            t.onresize()
        }
        ), !0),
        this._create = oldFlickityCreate,
        oldFlickityCreate.apply(this, arguments)
    }
    ,
    imageFunctions.flickityIosFix(),
    objectFitImages(),
    header.loadMegaMenu(),
    header.init(),
    Shopify.theme_settings.enable_autocomplete && searchAutocomplete.init(),
    utils.pageBannerCheck(),
    slideshow.init(),
    testimonial.init(),
    videoSection.init(),
    gallery.init(),
    featuredPromotions.init(),
    featuredCollectionSection.init(),
    collectionSidebarFilter.init(),
    cart.init(),
    mapFunction.init(),
    productPage.initializeQuantityBox(),
    productPage.init(),
    recentlyViewed.init(),
    window.addEventListener("resize", (function(t) {
        resizeTimeout || (resizeTimeout = setTimeout((function() {
            resizeTimeout = null,
            $(window).width() <= 798 && (cart.init(),
            header.unload(),
            header.init())
        }
        ), 66))
    }
    ), !1);
    $.fancybox.defaults.animationEffect = "fade",
    $.fancybox.defaults.transitionEffect = "fade",
    $.fancybox.defaults.hash = !1,
    $.fancybox.defaults.infobar = !1,
    $.fancybox.defaults.toolbar = !1,
    $.fancybox.defaults.arrows = !1,
    $.fancybox.defaults.loop = !0,
    $.fancybox.defaults.smallBtn = !0,
    $.fancybox.defaults.live = !1,
    $.fancybox.defaults.zoom = !1,
    $.fancybox.defaults.mobile.preventCaptionOverlap = !1,
    $.fancybox.defaults.mobile.toolbar = !0,
    $.fancybox.defaults.mobile.buttons = ["close"],
    $.fancybox.defaults.mobile.clickSlide = "close",
    $.fancybox.defaults.mobile.clickContent = "zoom",
    $.fancybox.defaults.afterLoad = function(t, e) {
        "image" == t.current.type && e.$content.wrapInner("<div class='fancybox-image-wrap'></div>"),
        t.group.length > 1 && e.$content.find(".fancybox-image-wrap").append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>' + svgArrowSizeLeft + '</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>' + svgArrowSizeRight + "</span></a>")
    }
    ,
    $('.lightbox[rel="gallery"]').fancybox(),
    $(".shopify-policy__container").parent().prepend('<a name="pagecontent" id="pagecontent"></a>');
    var currentValue = $(".search_form input[name='q']").val();
    $(".search_form input[name='q']").length > 0 && $(".search_form input[name='q']").val(currentValue.replace("*", "")),
    $("#sort-by").val($("#sort-by").data("default-sort")),
    $("body").on("change", "#tag_filter, #sort-by", (function() {
        quickFilter.init()
    }
    )),
    $("body").on("change", "#blog_filter", (function() {
        var t = $(this).val();
        window.location = t
    }
    )),
    $("input, select, textarea").on("focus blur", (function(t) {
        $("meta[name=viewport]").attr("content", "width=device-width,initial-scale=1,maximum-scale=" + ("blur" == t.type ? 10 : 1))
    }
    )),
    $("body").on("change", "[data-option-filter] input", (function() {
        quickFilter.init(),
        $("html, body").animate({
            scrollTop: $("#pagecontent").offset().top
        }, 500)
    }
    )),
    $("body").on("click", "[data-reset-filters]", (function() {
        collectionSidebarFilter.clearAllFilters()
    }
    )),
    $("body").on("click", "[data-clear-filter]", (function() {
        var t = $(this).parents(".filter-active-tag");
        collectionSidebarFilter.clearSelectedFilter(t)
    }
    )),
    $("body").on("change", ".currencies", (function(t) {
        $("[data-initial-modal-price]").attr("data-initial-modal-price", "")
    }
    )),
    $("body").on("change", ".js-quick-shop select", (function(t) {
        var e = $('.js-quick-shop select[name="id"]').val();
        e && globalQuickShopProduct && quickShop.updateVariant(e)
    }
    )),
    Shopify.theme_settings.quick_shop_enabled && quickShop.init();
    var touchStartPos = 0;
    if ($(document).bind("touchstart", (function(t) {
        touchStartPos = $(window).scrollTop()
    }
    )).bind("touchend", (function(t) {
        var e = touchStartPos - $(window).scrollTop();
        (e > 20 || e < -20) && t.preventDefault
    }
    )),
    $("body").on("click", ".sidebar .parent-link--false", (function(t) {
        t.preventDefault(),
        $menu = $(this).parent("li"),
        $menu.find(".menu-toggle").toggleClass("active"),
        $menu.find("ul").slideToggle()
    }
    )),
    Shopify.theme_settings.newsletter_popup && newsletter_popup.init(),
    -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
        scrollTop: $("#new-comment").offset().top - 140
    }, "slow"),
    $("body").on("mouseenter", ".icon-search", (function() {
        $(".search-terms").focus()
    }
    )),
    $("body").on("click", ".icon-search", (function() {
        $("input.search-terms").focus()
    }
    )),
    $("body").on("click", ".search-submit", (function() {
        $(this).parent().submit()
    }
    )),
    $(window).width() > 798 && ($(".animate_right").waypoint((function() {
        $(this.element).addClass("animated fadeInRight")
    }
    ), {
        offset: "70%"
    }),
    $(".animate_left").waypoint((function() {
        $(this.element).addClass("animated fadeInLeft")
    }
    ), {
        offset: "70%"
    }),
    $(".animate_up").waypoint((function() {
        $(this.element).addClass("animated fadeInUp")
    }
    ), {
        offset: "70%"
    }),
    $(".animate_down").waypoint((function() {
        $(this.element).addClass("animated fadeInDown")
    }
    ), {
        offset: "70%"
    })),
    $(".slider, .flexslider").find("li").unwrap(),
    $(".slider, .flexslider").flickity({
        pageDots: usePageDots,
        imagesLoaded: !0,
        arrowShape: arrowSize,
        lazyLoad: 2
    }),
    utils.createAccordion(".toggle-all--true", "h4.toggle", "ul.toggle_list"),
    utils.createAccordion(".footer_menu", "h6", "ul"),
    utils.createAccordion(".footer_content", "h6", "div.toggle_content"),
    utils.createAccordion(".product_section .accordion-tabs", ".tabs li > a", ".tabs-content li"),
    utils.mobileParentActiveAccordion("#mobile_menu", "li.sublink > a.parent-link--true span", "li.sublink ul"),
    utils.mobileAccordion("#mobile_menu", "li.sublink > a.parent-link--false", "li.sublink ul"),
    utils.initializeTabs(),
    utils.resizeActionButtons(),
    faqAccordion.init(),
    $(window).on("resize", (function() {
        utils.resizeActionButtons()
    }
    )),
    $(window).width() <= 798 && utils.createAccordion(".toggle-all--false", "h4.toggle", "ul.toggle_list"),
    $("body").on("click", ".menu-toggle", (function(t) {
        var e;
        $(this).next("ul").slideToggle(),
        $(this).toggleClass("active"),
        $(this).attr("aria-expanded", "true" == $(this).attr("aria-expanded") ? "false" : "true")
    }
    )),
    $(window).width() >= 959) {
        var modal_width = "870px";
        ($(window).width() >= 1200 || $("html").hasClass("ie")) && (modal_width = "1110px")
    }
    Shopify.theme_settings.collection_swatches && $(window).width() > 798 && ($("body").on("mouseenter", ".collection_swatches", (function() {
        $(".swatch span", $(this)).each((function() {
            -1 == $(this).data("image").indexOf("no-image") && ($("<img/>")[0].src = $(this).data("image"))
        }
        ))
    }
    )),
    $("body").on("mouseenter", ".swatch span", (function() {
        -1 == $(this).data("image").indexOf("no-image") && ($(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("src", $(this).data("image")),
        $(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("srcset", $(this).data("image")))
    }
    ))),
    Shopify.theme_settings.display_tos_checkbox && $("body").on("click touchstart", ".cart_content .tos_label", (function() {
        $(this).prev("input").prop("checked", !0)
    }
    )),
    Shopify.theme_settings.display_tos_checkbox && Shopify.theme_settings.go_to_checkout ? $("body").on("click", ".cart_content .action_button", (function(t) {
        if (!$(this).parents("form").find(".tos_agree").is(":checked")) {
            var e = '<p class="warning animated bounceIn">' + Shopify.translation.agree_to_terms_warning + "</p>";
            return 0 == $("p.warning").length && $(this).before(e),
            !1
        }
        Shopify.theme_settings.go_to_checkout ? $(this).submit() : (t.preventDefault(),
        document.location.href = "/cart")
    }
    )) : Shopify.theme_settings.go_to_checkout || $("body").on("click", ".cart_content .action_button", (function(t) {
        t.preventDefault(),
        document.location.href = "/cart"
    }
    )),
    Shopify.theme_settings.collection_secondary_image && imageFunctions.showSecondaryImage();
    var $contact_form = $(".newsletter .contact-form");
    function ajaxSubmitCart(t) {
        $cart = t,
        $.ajax({
            url: "/cart/update.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $cart.serialize(),
            success: function(t) {
                refreshCart(t)
            }
        })
    }
    function updateCartItemQuantity(t) {
        $.ajax({
            url: "/cart/change.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: {
                quantity: t.quantity,
                line: t.lineID
            },
            success: function(e) {
                "undefined" != typeof window.BOLD && "undefined" != typeof window.BOLD.common && "undefined" != typeof window.BOLD.common.cartDoctor && (e = window.BOLD.common.cartDoctor.fix(e),
                setTimeout((function() {
                    BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded")
                }
                ), 250));
                var i = e.items
                  , n = t.lineID - 1
                  , o = t.parentCartForm.find("[data-variant-id]").length
                  , a = t.parentCartForm.find('[data-variant-id="' + t.variantID + '"] input')
                  , s = 0
                  , r = 0
                  , l = void 0 !== e.items[n] ? e.items[n].quantity : 0;
                if (1 < a.length ? ($.each(a, (function(t, e) {
                    s += parseInt($(e).val())
                }
                )),
                i.forEach((function(e) {
                    e.variant_id === t.variantID && (r += e.quantity)
                }
                ))) : (s = parseInt(a.val()),
                r = void 0 !== e.items[n] ? e.items[n].quantity : 0),
                0 < s && r < s)
                    if (items_left_text = 1 == r ? Shopify.translation.one_item_left : Shopify.translation.items_left_text,
                    $(".warning--quantity").remove(),
                    o < i.length)
                        "cart-template" === t.parentCartForm.data("cart-form") ? t.parentCartForm.submit() : refreshCart(e);
                    else {
                        var c = '<p class="warning warning--quantity animated bounceIn">' + r + " " + items_left_text + "</p>";
                        t.parentCartForm.find("[data-line-id='" + t.lineID + "'] input").parent().after(c),
                        t.parentCartForm.find("[data-line-id='" + t.lineID + "'] input").val(l)
                    }
                else
                    "cart-template" === t.parentCartForm.data("cart-form") ? t.parentCartForm.submit() : refreshCart(e)
            }
        })
    }
    function refreshCartID() {
        for (var t = document.querySelectorAll(".cart__item"), e = 0; e < t.length; e++)
            for (var i = e + 1, n = t[e].querySelectorAll("[data-line-id]"), o = 0; o < n.length; o++)
                n[o].dataset.lineId = i
    }
    function refreshCart(t) {
        $(".cart_count").empty(),
        $cartBtn = $(".cart_count");
        var e = $cartBtn.text() || "0"
          , n = ""
          , o = ""
          , a = ""
          , s = ""
          , r = $("[data-cart-form]")
          , l = !1
          , c = 0
          , d = 0;
        if (r.data("total-discount", t.total_discount),
        $cartBtn.text(e.replace(/[0-9]+/, t.item_count)),
        0 == t.item_count)
            $(".js-empty-cart__message").removeClass("hidden"),
            r.addClass("hidden");
        else {
            $(".js-empty-cart__message").addClass("hidden"),
            r.removeClass("hidden");
            var u = 0
              , p = 0;
            $.each(t.items, (function(t, e) {
                var o = e.discounts
                  , a = "";
                for (i = 0; i < o.length; i++)
                    Shopify.formatMoney(o[i].amount, $("body").data("money-format")),
                    a = '<p class="notification-discount meta">' + o[i].title + "</p>";
                var s = t + 1;
                if (n += '<li class="mini-cart__item clearfix" data-cart-item data-line-id="' + s + '" data-variant-id="' + e.id + '"><a href="' + e.url + '">',
                e.image && (n += '<div class="cart_image"><img src="' + e.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "") + '" alt="' + htmlEncode(e.title) + '" /></div></a>'),
                n += '<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title"><a href="' + e.url + '">' + e.title + "</a></div>",
                e.properties && $.each(e.properties, (function(t, e) {
                    e && (n += '<div class="line-item">' + t + ": " + e + " </div>")
                }
                )),
                n += '<strong class="right price">',
                $.ajax({
                    dataType: "json",
                    async: !1,
                    cache: !1,
                    url: "/products/" + e.handle + ".js",
                    success: function(t) {
                        if (t.variants) {
                            var i = t.variants;
                            if (1 < i.length)
                                for (v = 0; v < i.length; v++)
                                    i[v].id == e.id && (t = i[v])
                        }
                        t.compare_at_price ? t.compare_at_price > t.price && (l = !0,
                        c = t.compare_at_price,
                        d = t.price) : l = !1
                    }
                }),
                1 == l) {
                    var r = Shopify.formatMoney(d, $("body").data("money-format")) + ' </span><span class="money was_price">' + Shopify.formatMoney(c, $("body").data("money-format")) + "</span>";
                    n += '<span class="money sale boldt"><span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" boldtestattr test2 data-item-key="' + e.key + '" style="display:none !important;"></span>' + r + "</strong>",
                    p = (c - d) * e.quantity,
                    u = p + u
                } else
                    e.price > e.final_price ? (r = Shopify.formatMoney(e.final_price, $("body").data("money-format")) + ' </span><span class="money was_price">' + Shopify.formatMoney(e.price, $("body").data("money-format")) + "</span>",
                    n += '<span class="money sale">' + r + "</strong>") : (r = Shopify.formatMoney(e.price, $("body").data("money-format")),
                    n += '<span class="money">' + r + "</span></strong>");
                e.price > e.final_price && (n += a),
                n += '<div class="left product-quantity-box">',
                n += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>',
                n += '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + e.id + '" value="' + e.quantity + '" data-cart-quantity-input="mini-cart" />',
                n += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>',
                n += "</div></div></div>",
                n += '<a href="/cart/change?line=' + s + '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' + s + '" data-remove-item="mini-cart"><span class="remove-icon"></span></a>'
            }
            ));
            var h = t.cart_level_discount_applications;
            for (i = 0; i < h.length; i++) {
                var f = Shopify.formatMoney(h[i].total_allocated_amount, $("body").data("money-format"));
                o += '<span class="cart_discounts--title">' + h[i].title + "</span>",
                o += '<span class="cart_discounts--price">',
                o += '-<span class="money">' + f + "</span></span>"
            }
            a += '<span class="right"><span class="money">' + Shopify.formatMoney(t.total_price, $("body").data("money-format")) + "</span></span><span>" + Shopify.translation.cart_subtotal_text + "</span>",
            u += t.total_discount,
            s = Shopify.theme_settings.display_savings && 0 < u ? '<span class="right"><span class="money">' + Shopify.formatMoney(u, $("body").data("money-format")) + "</span></span><span>" + Shopify.translation.cart_savings_text + "</span>" : ""
        }
        $(".js-cart_items").html(n),
        $(".js-cart_discounts").html(o),
        $(".js-cart_subtotal").html(a),
        $(".js-cart_savings").html(s),
        Shopify.theme_settings.show_multiple_currencies && convertCurrencies()
    }
    $contact_form.each((function() {
        var t = $(this);
        t.on("submit", (function(e) {
            "true" !== $('input[name="challenge"]', t).val() && ($.ajax({
                type: t.attr("method"),
                url: t.attr("action"),
                data: t.serialize(),
                success: function(e) {
                    t.fadeOut("slow", (function() {
                        t.prev(".message").html(Shopify.translation.newsletter_success_text)
                    }
                    ))
                },
                error: function(e) {
                    $('input[name="challenge"]', t).val("true"),
                    t.submit()
                }
            }),
            e.preventDefault())
        }
        ))
    }
    )),
    $(".maps").click((function() {
        $(".maps iframe").css("pointer-events", "auto")
    }
    )),
    "load_more" == Shopify.theme_settings.pagination_type && enableLoadMoreProducts(),
    "infinite_scroll" == Shopify.theme_settings.pagination_type && enableInfiniteScroll(),
    "load_more" == Shopify.theme_settings.search_pagination_type && enableLoadMoreSearch(),
    "infinite_scroll" == Shopify.theme_settings.search_pagination_type && enableInfiniteSearchScroll(),
    $("body").on("change", "[data-cart-quantity-input]", (function() {
        var t = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
            quantity: $(this).val(),
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]")
        };
        $(this).parents(".product-quantity-box").find(".js-change-quantity").addClass("is-disabled"),
        updateCartItemQuantity(t)
    }
    )),
    $("body").on("click", "[data-remove-item]", (function(t) {
        t.preventDefault();
        var e = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
            quantity: 0,
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]")
        };
        e.$element.addClass("animated fadeOutLeft"),
        updateCartItemQuantity(e),
        "cart-template" === e.parentCartForm.data("cart-form") && (e.$element.find("input").val("0"),
        e.parentCartForm.submit()),
        "mini-cart" === e.parentCartForm.data("cart-form") && e.$element.find("input").val("0")
    }
    )),
    "ajax" == Shopify.theme_settings.cart_action && $(document).on("click", ".ajax-submit", (function(e) {
        e.preventDefault();
        var $addToCartForm = $(this).closest("form")
          , $addToCartBtn = $addToCartForm.find(".add_to_cart");
        return $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $addToCartForm.serialize(),
            beforeSend: function() {
                $addToCartBtn.attr("disabled", "disabled").addClass("disabled"),
                $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")
            },
            success: function(t) {
                $addToCartBtn.find(".checkmark").addClass("checkmark-active"),
                window.setTimeout((function() {
                    $addToCartBtn.removeAttr("disabled").removeClass("disabled"),
                    $addToCartBtn.find(".checkmark").removeClass("checkmark-active"),
                    $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")
                }
                ), 1e3),
                $.ajax({
                    url: "/cart.js",
                    dataType: "json",
                    cache: !1,
                    success: function(t) {
                        setTimeout((function() {
                            refreshCart(t),
                            $("body").hasClass("fancybox-active") && $.fancybox.close(),
                            $("#header").is(":visible") ? $("#header .cart_container").addClass("active_link") : $(".sticky_nav--stick").length ? $(".sticky_nav .cart_container").addClass("active_link") : $(".top_bar .cart_container").addClass("active_link"),
                            $(window).width() <= 798 && ($(this).parent().hasClass("active_link"),
                            $("body").addClass("blocked-scroll"))
                        }
                        ), 500)
                    }
                })
            },
            error: function(XMLHttpRequest) {
                var response = eval("(" + XMLHttpRequest.responseText + ")");
                response = response.description,
                $(".warning").remove();
                var warning = '<p class="warning animated bounceIn">' + response.replace("All 1 ", "All ") + "</p>";
                $addToCartForm.after(warning),
                $addToCartBtn.removeAttr("disabled").removeClass("disabled"),
                $addToCartBtn.find("span").text(Shopify.translation.add_to_cart).removeClass("zoomOut").addClass("zoomIn")
            }
        }),
        !1
    }
    )),
    productPage.productSwatches()
}
)),
Shopify.updateOptionsInSelector = function(t, e) {
    switch (t) {
    case 0:
        var i = "root";
        $(e + " .single-option-selector:eq(0)");
        break;
    case 1:
        i = $(e + " .single-option-selector:eq(0)").val(),
        $(e + " .single-option-selector:eq(1)");
        break;
    case 2:
        i = $(e + " .single-option-selector:eq(0)").val(),
        i += " / " + $(e + " .single-option-selector:eq(1)").val(),
        $(e + " .single-option-selector:eq(2)")
    }
    var n = Shopify.optionsMap[i];
    $(e + ' .swatch[data-option-index="' + t + '"] .swatch-element').each((function() {
        -1 !== $.inArray($(this).attr("data-value"), n) ? $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
    }
    ))
}
,
Shopify.linkOptionSelectors = function(t, e) {
    Shopify.optionsMap = {};
    for (var i = 0; i < t.variants.length; i++) {
        var n = t.variants[i];
        if (n.available) {
            if (Shopify.optionsMap.root = Shopify.optionsMap.root || [],
            Shopify.optionsMap.root.push(n.option1),
            Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root),
            1 < t.options.length) {
                var o = n.option1;
                Shopify.optionsMap[o] = Shopify.optionsMap[o] || [],
                Shopify.optionsMap[o].push(n.option2),
                Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o])
            }
            3 === t.options.length && (o = n.option1 + " / " + n.option2,
            Shopify.optionsMap[o] = Shopify.optionsMap[o] || [],
            Shopify.optionsMap[o].push(n.option3),
            Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o]))
        }
    }
    Shopify.updateOptionsInSelector(0, e),
    1 < t.options.length && Shopify.updateOptionsInSelector(1, e),
    3 === t.options.length && Shopify.updateOptionsInSelector(2, e),
    $(e + " .single-option-selector:eq(0)").change((function() {
        return Shopify.updateOptionsInSelector(1, e),
        3 === t.options.length && Shopify.updateOptionsInSelector(2, e),
        !0
    }
    )),
    $(e + " .single-option-selector:eq(1)").change((function() {
        return 3 === t.options.length && Shopify.updateOptionsInSelector(2, e),
        !0
    }
    ))
}
;
var touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
function floatToString(t, e) {
    var i = t.toFixed(e).toString();
    return i.match(/^\.\d+/) ? "0" + i : i
}
if ("undefined" == typeof Shopify)
    var Shopify = {};
Shopify.each = function(t, e) {
    for (var i = 0; i < t.length; i++)
        e(t[i], i)
}
,
Shopify.map = function(t, e) {
    for (var i = [], n = 0; n < t.length; n++)
        i.push(e(t[n], n));
    return i
}
,
Shopify.arrayIncludes = function(t, e) {
    for (var i = 0; i < t.length; i++)
        if (t[i] == e)
            return !0;
    return !1
}
,
Shopify.uniq = function(t) {
    for (var e = [], i = 0; i < t.length; i++)
        Shopify.arrayIncludes(e, t[i]) || e.push(t[i]);
    return e
}
,
Shopify.isDefined = function(t) {
    return "undefined" != typeof t
}
,
Shopify.getClass = function(t) {
    return Object.prototype.toString.call(t).slice(8, -1)
}
,
Shopify.extend = function(t, e) {
    function i() {}
    i.prototype = e.prototype,
    t.prototype = new i,
    t.prototype.constructor = t,
    t.baseConstructor = e,
    t.superClass = e.prototype
}
,
Shopify.locationSearch = function() {
    return window.location.search
}
,
Shopify.locationHash = function() {
    return window.location.hash
}
,
Shopify.replaceState = function(t) {
    window.history.replaceState({}, document.title, t)
}
,
Shopify.urlParam = function(t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "))
}
,
Shopify.newState = function(t, e) {
    var i;
    return (i = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e) + Shopify.locationHash()
}
,
Shopify.setParam = function(t, e) {
    Shopify.replaceState(Shopify.newState(t, e))
}
,
Shopify.Product = function(t) {
    Shopify.isDefined(t) && this.update(t)
}
,
Shopify.Product.prototype.update = function(t) {
    for (property in t)
        this[property] = t[property]
}
,
Shopify.Product.prototype.optionNames = function() {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}
,
Shopify.Product.prototype.optionValues = function(t) {
    if (!Shopify.isDefined(this.variants))
        return null;
    var e = Shopify.map(this.variants, (function(e) {
        var i = "option" + (t + 1);
        return null == e[i] ? null : e[i]
    }
    ));
    return null == e[0] ? null : Shopify.uniq(e)
}
,
Shopify.Product.prototype.getVariant = function(t) {
    var e = null;
    return t.length != this.options.length || Shopify.each(this.variants, (function(i) {
        for (var n = !0, o = 0; o < t.length; o++) {
            var a;
            i["option" + (o + 1)] != t[o] && (n = !1)
        }
        return 1 == n ? void (e = i) : void 0
    }
    )),
    e
}
,
Shopify.Product.prototype.getVariantById = function(t) {
    for (var e = 0; e < this.variants.length; e++) {
        var i = this.variants[e];
        if (t == i.id)
            return i
    }
    return null
}
,
Shopify.money_format = "${{amount}}",
Shopify.formatMoney = function(t, e) {
    function i(t, e) {
        return "undefined" == typeof t ? e : t
    }
    function n(t, e, n, o) {
        if (e = i(e, 2),
        n = i(n, ","),
        o = i(o, "."),
        isNaN(t) || null == t)
            return 0;
        var a = (t = (t / 100).toFixed(e)).split("."), s, r;
        return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (a[1] ? o + a[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = ""
      , a = /\{\{\s*(\w+)\s*\}\}/
      , s = e || this.money_format;
    switch (s.match(a)[1]) {
    case "amount":
        o = n(t, 2);
        break;
    case "amount_no_decimals":
        o = n(t, 0);
        break;
    case "amount_with_comma_separator":
        o = n(t, 2, ".", ",");
        break;
    case "amount_with_apostrophe_separator":
        o = n(t, 2);
        break;
    case "amount_no_decimals_with_comma_separator":
        o = n(t, 0, ".", ",")
    }
    return s.replace(a, o)
}
,
Shopify.OptionSelectors = function(t, e) {
    return this.selectorDivClass = "selector-wrapper",
    this.selectorClass = "single-option-selector",
    this.variantIdFieldIdSuffix = "-variant-id",
    this.variantIdField = null,
    this.historyState = null,
    this.selectors = [],
    this.domIdPrefix = t,
    this.product = new Shopify.Product(e.product),
    this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function() {}
    ,
    this.replaceSelector(t),
    this.initDropdown(),
    e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
    !0
}
,
Shopify.OptionSelectors.prototype.initDropdown = function() {
    var t = {
        initialLoad: !0
    }, e;
    if (!this.selectVariantFromDropdown(t)) {
        var i = this;
        setTimeout((function() {
            i.selectVariantFromParams(t) || i.fireOnChangeForFirstDropdown.call(i, t)
        }
        ))
    }
}
,
Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(t) {
    this.selectors[0].element.onchange(t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(t) {
    var e;
    this.selectVariantFromParams(t) || this.selectVariantFromDropdown(t)
}
,
Shopify.OptionSelectors.prototype.replaceSelector = function(t) {
    var e = document.getElementById(t)
      , i = e.parentNode;
    Shopify.each(this.buildSelectors(), (function(t) {
        i.insertBefore(t, e)
    }
    )),
    e.style.display = "none",
    this.variantIdField = e
}
,
Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(t) {
    var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),
    !e)
        return !1;
    var i = e.value;
    return this.selectVariant(i, t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParams = function(t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t)
}
,
Shopify.OptionSelectors.prototype.selectVariant = function(t, e) {
    var i = this.product.getVariantById(t);
    if (null == i)
        return !1;
    for (var n = 0; n < this.selectors.length; n++) {
        var o = this.selectors[n].element, a, s = i[o.getAttribute("data-option")];
        null != s && this.optionExistInSelect(o, s) && (o.value = s)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e),
    !0
}
,
Shopify.OptionSelectors.prototype.optionExistInSelect = function(t, e) {
    for (var i = 0; i < t.options.length; i++)
        if (t.options[i].value == e)
            return !0
}
,
Shopify.OptionSelectors.prototype.insertSelectors = function(t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e),
    this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var i = document.getElementById(t);
    Shopify.each(this.buildSelectors(), (function(t) {
        i.appendChild(t)
    }
    ))
}
,
Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var t = 0; t < this.product.optionNames().length; t++) {
        var e = new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));
        e.element.disabled = !1,
        this.selectors.push(e)
    }
    var i = this.selectorDivClass, n = this.product.optionNames(), o;
    return Shopify.map(this.selectors, (function(t) {
        var e = document.createElement("div");
        if (e.setAttribute("class", i),
        n.length > 1) {
            var o = document.createElement("label");
            o.htmlFor = t.element.id,
            o.innerHTML = t.name,
            e.appendChild(o)
        }
        return e.appendChild(t.element),
        e
    }
    ))
}
,
Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
        var i = this.selectors[e].element.value;
        t.push(i)
    }
    return t
}
,
Shopify.OptionSelectors.prototype.updateSelectors = function(t, e) {
    var i = this.selectedValues()
      , n = this.product.getVariant(i);
    n ? (this.variantIdField.disabled = !1,
    this.variantIdField.value = n.id) : this.variantIdField.disabled = !0,
    this.onVariantSelected(n, this, e),
    null != this.historyState && this.historyState.onVariantChange(n, this, e)
}
,
Shopify.OptionSelectorsFromDOM = function(t, e) {
    var i = e.optionNames || []
      , n = e.priceFieldExists || !0
      , o = e.delimiter || "/"
      , a = this.createProductFromSelector(t, i, n, o);
    e.product = a,
    Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
}
,
Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(t, e, i, n) {
    if (!Shopify.isDefined(i))
        var i = !0;
    if (!Shopify.isDefined(n))
        var n = "/";
    var o = document.getElementById(t)
      , a = o.childNodes
      , s = (o.parentNode,
    e.length)
      , r = [];
    Shopify.each(a, (function(t, o) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
            var a = t.innerHTML.split(new RegExp("\\s*\\" + n + "\\s*"));
            0 == e.length && (s = a.length - (i ? 1 : 0));
            var l = a.slice(0, s)
              , c = i ? a[s] : ""
              , d = (t.getAttribute("value"),
            {
                available: !t.disabled,
                id: parseFloat(t.value),
                price: c,
                option1: l[0],
                option2: l[1],
                option3: l[2]
            });
            r.push(d)
        }
    }
    ));
    var l = {
        variants: r
    };
    if (0 == e.length) {
        l.options = [];
        for (var c = 0; s > c; c++)
            l.options[c] = "option " + (c + 1)
    } else
        l.options = e;
    return l
}
,
Shopify.SingleOptionSelector = function(t, e, i, n) {
    this.multiSelector = t,
    this.values = n,
    this.index = e,
    this.name = i,
    this.element = document.createElement("select");
    for (var o = 0; o < n.length; o++) {
        var a = document.createElement("option");
        a.value = n[o],
        a.innerHTML = n[o],
        this.element.appendChild(a)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass),
    this.element.setAttribute("data-option", "option" + (e + 1)),
    this.element.id = t.domIdPrefix + "-option-" + e,
    this.element.onchange = function(i, n) {
        n = n || {},
        t.updateSelectors(e, n)
    }
    ,
    !0
}
,
Shopify.Image = {
    preload: function(t, e) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            this.loadImage(this.getSizedImageUrl(n, e))
        }
    },
    loadImage: function(t) {
        (new Image).src = t
    },
    switchImage: function(t, e, i) {
        if (t && e) {
            var n = this.imageSize(e.src)
              , o = this.getSizedImageUrl(t.src, n);
            i ? i(o, t, e) : e.src = o
        }
    },
    imageSize: function(t) {
        var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != e ? e[1] : null
    },
    getSizedImageUrl: function(t, e) {
        if (null == e)
            return t;
        if ("master" == e)
            return this.removeProtocol(t);
        var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != i) {
            var n = t.split(i[0])
              , o = i[0];
            return this.removeProtocol(n[0] + "_" + e + o)
        }
        return null
    },
    removeProtocol: function(t) {
        return t.replace(/http(s)?:/, "")
    }
},
Shopify.OptionSelectors.HistoryState = function(t) {
    this.browserSupports() && this.register(t)
}
,
Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
    window.addEventListener("popstate", (function(e) {
        t.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    }
    ))
}
,
Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, i) {
    this.browserSupports() && (!t || i.initialLoad || i.popStateCall || Shopify.setParam("variant", t.id))
}
,
Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
}
;
$(document).on("shopify:block:select", (function(t) {
    var e = t.detail.blockId
      , i = $("#shopify-section-" + t.detail.sectionId);
    (i.hasClass("slideshow-section") || i.hasClass("testimonial-section")) && sliderBlock.select(e, i),
    i.hasClass("recommended-products-section") && $(".block__recommended_products").length && productPage.init(),
    i.hasClass("page-details-section") && $(".map-section").length && mapFunction.init(),
    i.hasClass("cart-section") && $(".block__featured_collection").length && featuredCollectionSection.init(),
    i.hasClass("product-template") && Shopify.theme_settings.enable_shopify_review_comments && 1 <= $("#shopify-product-reviews").length && SPR.$(document).ready((function() {
        return SPR.registerCallbacks(),
        SPR.initRatingHandler(),
        SPR.initDomEls(),
        SPR.loadProducts(),
        SPR.loadBadges()
    }
    )),
    utils.resizeActionButtons()
}
)),
$(document).on("shopify:block:deselect", (function(t) {
    var e = $("#shopify-section-" + t.detail.sectionId);
    (e.hasClass("slideshow-section") || e.hasClass("testimonial-section")) && sliderBlock.deselect(e)
}
)),
$(document).on("shopify:section:reorder", (function(t) {
    utils.pageBannerCheck()
}
)),
$(document).on("shopify:section:load", (function(t) {
    var e = $("#shopify-section-" + t.detail.sectionId);
    utils.pageBannerCheck(),
    Shopify.theme_settings.newsletter_popup && newsletter_popup.init(),
    e.hasClass("image-gallery-section") && gallery.init(e),
    e.hasClass("social-feeds-section") && $(".social-feeds-wrap").each((function(t, e) {
        social.twitter();
        var i = $(this).find(".js-instafeed");
        instagram.loadContent({
            el: i,
            clientID: i.data("client-id"),
            limit: i.data("count"),
            column: i.data("column")
        })
    }
    )),
    e.hasClass("faq-section") && faqAccordion.init(),
    e.hasClass("cart-section") && (cart.init(),
    $(".block__featured_collection").length && featuredCollectionSection.init()),
    e.hasClass("featured-promotions-section") && featuredPromotions.init(),
    e.hasClass("slideshow-section") && slideshow.init(),
    Shopify.theme_settings.enable_autocomplete && e.hasClass("search-section") && searchAutocomplete.init(),
    e.hasClass("testimonial-section") && testimonial.init(),
    e.hasClass("featured-products-section") && (productPage.initializeQuantityBox(),
    productPage.productSwatches(),
    productPage.init(),
    Shopify.theme_settings.enable_shopify_review_comments && $(".shopify-product-reviews-badge").length && SPR.$(document).ready((function() {
        return SPR.registerCallbacks(),
        SPR.initRatingHandler(),
        SPR.initDomEls(),
        SPR.loadProducts(),
        SPR.loadBadges()
    }
    ))),
    e.hasClass("map-section") && mapFunction.init(),
    e.hasClass("featured-collection-section") && featuredCollectionSection.init(),
    e.hasClass("video-section") && videoSection.init(),
    e.hasClass("recently-viewed__section") && recentlyViewed.init(),
    e.hasClass("product-template") && (productPage.init(),
    productPage.productSwatches(),
    recentlyViewed.init(),
    Shopify.theme_settings.enable_shopify_review_comments && ($("#shopify-product-reviews").length || $(".shopify-product-reviews-badge").length) && SPR.$(document).ready((function() {
        return SPR.registerCallbacks(),
        SPR.initRatingHandler(),
        SPR.initDomEls(),
        SPR.loadProducts(),
        SPR.loadBadges()
    }
    ))),
    e.hasClass("recommended-products-section") && productPage.init(),
    e.hasClass("article-template-section") && -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
        scrollTop: $("#new-comment").offset().top - 140
    }, "slow"),
    e.hasClass("collection-template-section") && (collectionSidebarFilter.init(),
    recentlyViewed.init()),
    e.hasClass("contact-section") && mapFunction.init(),
    e.hasClass("search-template-section") && (Shopify.theme_settings.enable_autocomplete && searchAutocomplete.init(),
    collectionSidebarFilter.init()),
    e.hasClass("header-section") && (header.init(),
    header.loadMegaMenu()),
    e.hasClass("mega-menu-section") && header.loadMegaMenu(),
    e.hasClass("page-details-section") && (featuredCollectionSection.init(),
    videoSection.init(),
    $(".block__image_gallery").length && gallery.init(),
    recentlyViewed.init()),
    e.hasClass("product-details-section") && (featuredCollectionSection.init(),
    videoSection.init(),
    mapFunction.init(),
    $(".block__image_gallery").length && gallery.init(),
    recentlyViewed.init(),
    productPage.init())
}
)),
$(document).on("shopify:section:unload", (function(t) {
    var e = $(t.target)
      , i = $("#shopify-section-" + t.detail.sectionId);
    i.hasClass("header-section") && (header.unload(e),
    header.unloadMegaMenu()),
    i.hasClass("slideshow-section") && slideshow.unload(e),
    i.hasClass("testimonial-section") && testimonial.unload(e),
    i.hasClass("video-section") && videoSection.unload(e),
    i.hasClass("search-section") && searchAutocomplete.unload(e),
    i.hasClass("product-template") && productPage.unload(e),
    i.hasClass("mega-menu-section") && header.unloadMegaMenu(),
    i.hasClass("page-details-section") && videoSection.unload(e),
    i.hasClass("product-details-section") && videoSection.unload(e)
}
)),
$(document).on("shopify:section:select", (function(t) {
    var e = $("#shopify-section-" + t.detail.sectionId);
    if (e.hasClass("social-feeds-section") && $(".social-feeds-wrap").each((function(t, e) {
        social.twitter()
    }
    )),
    e.hasClass("mega-menu-section")) {
        var i = $(".header ." + t.detail.sectionId).data("dropdown");
        setTimeout((function() {
            $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').trigger("mouseenter"),
            $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').parents("header").addClass("editor-hover--true"),
            header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column")
        }
        ), 10)
    }
    e.hasClass("featured-collection-section") && (featuredCollectionSection.unload(e),
    featuredCollectionSection.init()),
    utils.pageBannerCheck();
    var n = document.createEvent("UIEvents");
    n.initUIEvent("resize", !0, !1, window, 0),
    window.dispatchEvent(n)
}
)),
$(document).on("shopify:section:deselect", (function(t) {
    if ($("#shopify-section-" + t.detail.sectionId).hasClass("mega-menu-section")) {
        var e = $(".header ." + t.detail.sectionId).data("dropdown");
        $('a.mega-menu-parent[data-dropdown-rel="' + e + '"]').trigger("mouseout"),
        $('a.mega-menu-parent[data-dropdown-rel="' + e + '"]').parents("header").removeClass("editor-hover--true")
    }
}
));
//# sourceMappingURL=/s/files/1/0249/0207/4421/t/44/assets/vendors.js.map?v=7496791367544263740
